import apiCallback, {apiMethods} from "./api_callback";
import {
    addressesApis,
    adminApis,
    adminFileUploaderApis,
    authApis,
    backOrdersApis,
    bannerApis,
    bizFileApis,
    bizLiveApis,
    bizPrintTemplateAccessApis,
    bizPrintTemplateApis,
    budgetApis,
    bulkPriceChangeApis,
    catalogueApis,
    cmsApis,
    colorThemeApis,
    competitorApis,
    contactMessageApis,
    creditsApis,
    customDashboardApis,
    customerApis,
    customerCreditCardsApis,
    customerV2Apis,
    dashboardApis,
    DriverApis,
    dynamicPageApis,
    errorHandlingApis,
    exportApis,
    freeFreightRequestApis,
    freightCategoryExceptionApis,
    freightCompaniesApis,
    freightCompanyExceptionApis,
    freightCustomerExceptionApis,
    freightFlatExceptionApis,
    freightInfoApis,
    freightOrderApis,
    freightPartExceptionApis,
    freightPartRateApis,
    freightPriceLevelExceptionApis,
    freightQuoteApis,
    freightRegionExceptionApis,
    homepageEditionApis,
    homepageEditionTabApis,
    homepageEditionTabComponentApis,
    industryApis,
    industryGroupPropertyApis,
    industryPropertyApis,
    industryPropertyTemplateApis,
    inventoryAdjustmentApis,
    InventoryAdjustmentReasonsApis,
    inventoryApis,
    inventoryTransferApis,
    invoicesApis,
    linkApis,
    lookupApis,
    lostSalesApis,
    ncrActionGroupsApis,
    ncrNoteTitleSuggestionsApis,
    ncrProcessApis,
    ncrReportsApis,
    ncrSettingApis as ncrSettingsApis,
    ncrStatusApis,
    NewARApis,
    newInvoicesApis,
    newPartCategoryApis,
    NewPartSupportReqApis,
    newPriceMatrixApis,
    newSalesPersonApis,
    nexusSearchApis,
    nexusSearchReportApis,
    notesApis,
    notificationChannelApis,
    onlinePaymentReportApis,
    operatorApis,
    operatorChannelSubscriptionApis,
    operatorPartApis,
    operatorPartApplicationSuggestion,
    operatorPartFeedbackApis,
    operatorPartImageApis,
    operatorPartNoteApis,
    operatorPartPrice,
    operatorPartRelationApis,
    operatorPartTagApis,
    operatorPartTechnicalFileApis,
    operatorPartTechnicalFileShareLink,
    operatorTechnicalSuggestion,
    orderDimensionApis,
    orderNotesApis,
    orderPalletApis,
    orderV2Apis,
    partApis,
    partCodeCategoryApis,
    partCodeValueApis,
    partCompareApis,
    partFileApis,
    partFormApis,
    partGroupIndustryPropertyApis,
    partIndustryPropertyApis,
    partnerApis,
    partnerConfigurationApisV2,
    partnerConfigurationsApis,
    PartnerConnectionApis,
    partnerPrinterHubApis,
    partRelationTypes,
    partSizeApis,
    PartSupportDriverCheckListApis,
    partSupportReqApplicabilityApis,
    partSupportReqExtraFeesApis,
    partSupportReqExtraFeesTitleApis,
    partSupportReqFileTemplateApis,
    partSupportRequestStatusesApis,
    partSupportReqUploadFilesApis,
    partSupportReqVendorStatusApis,
    partSupportVendorsMsgApis,
    partWarehouseApis,
    posApis as storeApis,
    posApis,
    priceFormulaApis,
    priceLevelApis,
    priceMatrixApis,
    printerHubApis,
    printerHubQueueApis,
    productInformationApis,
    purchaseApis,
    quoteBypassApis,
    quoteBypassReasonApis,
    quoteBypassRuleApis,
    quotesApis,
    regionRateApis,
    regionsApis,
    reportingToolsApis,
    salesOrdersApis,
    salesPersonApis,
    salesTaxApis,
    searchLimitsApis,
    shoppingCartApis,
    surveysApis,
    tagApis,
    tasksApis,
    taskStatusApis,
    territoryApis,
    themeEditorApis,
    transactionCreditsApi,
    uiComponentApis,
    userAddressesApis,
    userGiftCardApis,
    userHomepageApis,
    userPaymentsApis,
    userV2Apis,
    usersApis,
    vendorPartApis,
    vendorsApis,
    vendorV2Apis,
    versionHistoryApis,
    vinApis,
    warehouseApis,
    warehouseV2Apis,
    warrantyAndReturnApis
} from "../../models/static/api-endpoints/api_endpoints";
import {routes} from "../../models/static/routes/app-routes";
import ApiResponseCodes from "../../models/static/api-response-codes";
import EnvService from "../env";
import {injectMockHomeImageCarouselEdition} from "../../mocks/mock-home-image-carousel";
import {ApiMethods} from "../../../packages/query-builder/core/models/constants/enums";
import {AccessLevelDataByPartnerId} from "../access-levels/pre-defined";
import CacheService from "../cache/cache_service";

/**
 * Interface that handles all the api calls to the server.
 */

export default class Api {
    static history;
    static location;

    // ########################################     Helper Methods    ########################################

    /**
     * Updates the history
     * @param history
     */
    static setHistory = (history) => {
        this.history = history;
    }

    /**
     * Updates the location
     * @param location
     */
    static setLocation = (location) => {
        this.location = location;
    }

    /**
     * Prepares the APi Request by injecting the history and location into the api call back
     * @param request {ApiRequestDs | any}
     * @return {ApiRequestDs}
     */
    static prepareRequest = (request) => {
        return {
            ...request,
            history: Api.history,
            location: Api.location,
        }
    }

    // ########################################     AUTH APIS     ########################################

    /**
     * Get the configuration of the site from api including the api url, login url, logout url of core
     * @return {Promise<ApiResponseDs<unknown | undefined>>}
     */
    static getApplicationConfigurations = async () => {
        const result = await apiCallback(Api.prepareRequest({
            url: authApis.getConfiguration,
            method: apiMethods.get,
            loginRequired: false,
        }));
        if (!result)
            Api.history.push(routes.error.serverError);
        else
            return result;
    }

    /**
     * Logs the user in the system
     * @param token {string} the token generated by Core
     * @param cancelToken {import('axios').CancelToken} cancels a login that has gone silent
     * @return {Promise<ApiResponseDs<unknown | undefined>>}
     */
    static login = async (token, cancelToken = undefined) => {
        let result = await apiCallback(Api.prepareRequest({
            url: authApis.login,
            method: apiMethods.post,
            data: {token},
            showSuccessToast: true,
            loginRequired: false,
            cancelToken,
        }));
        if (result?.aborted) {
            return result;
        }
        if (EnvService.bypassAuth) {
            result = {
                ...(result ?? {}),
                resultFlag: true,
                data: {
                    ...(result.data ?? {}),
                    loginResponse: {
                        token: result?.data?.loginResponse?.token ?? '3b79e866-c34b-4b32-bcda-fb46e93b2374',
                        tokenLifeSpanMinutes: result?.data?.loginResponse?.tokenLifeSpanMinutes ?? 10000000,
                    },
                },
            }
        }
        if (!result || !result.resultFlag) {
            if (!result) Api.history.push(routes.error.serverError);
            else if (!result.resultFlag) Api.history.replace(routes.error.accessDenied);
        }
        return result;
    }

    // ########################################     LOOKUP APIS     ########################################


    /**
     * Fetches the list of all makes and models in the system
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getAllMakesAndModelsList = async () => {
        return await apiCallback(Api.prepareRequest({
            url: lookupApis.makesAndModelsList,
            method: apiMethods.get,
        }))
    }

    /**
     * Search for products in the system using basic search engine
     * @param keywords {string}
     * @param industryId {string}
     * @param cancelToken {CancelToken}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static autoCompletePartLookup = async (keywords, industryId = undefined, cancelToken = undefined) => {
        const response = await apiCallback(Api.prepareRequest({
            url: lookupApis.autoCompletePartLookup(keywords, industryId),
            method: apiMethods.get,
            cancelToken: cancelToken
        }))
        if (!response || !response?.resultFlag) {
            return response;
        }
        return {
            ...response,
            data: response.data?.map(e => ({
                ...e,
                partNumber: e.partNo,
                cover: e.coverImageInfo,
            }))
        }
    }

    /**
     * Submit Lost Sale for users that could not find any items in their warehouses
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static submitLostSale = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: lookupApis.submitLostSaleReport,
            method: apiMethods.post,
            data: request,
        }));
    }

    // ########################################     CUSTOMER APIS     ########################################

    /**
     * Gets all the payment terms enum from database.
     * @return {Promise<ApiResponseDs<unknown | null>>}
     */
    static getAllPaymentTerms = async () => {
        return await apiCallback(Api.prepareRequest({
            url: customerApis.getAllPaymentTerms,
            method: apiMethods.get,
        }));
    }

    /**
     * Gets all the price level enums for the companies from database.
     * @return {Promise<ApiResponseDs<unknown | null>>}
     */
    static getAllPriceLevels = async (onErrorCallback) => {
        return await apiCallback(Api.prepareRequest({
            url: customerApis.getAllPriceLevels,
            method: apiMethods.get,
            unAuthorizedCallback: onErrorCallback,
            accessDeniedCallback: onErrorCallback,
        }));
    }

    /**
     * Updates the company information including the credit limit
     * @param request new company info including the credit limit
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateCustomerInfo = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: customerApis.update,
            data: request,
            method: apiMethods.put,
        }))
    };

    /**
     * Updates the company's price level information
     * @param request company price levels
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateCustomerPriceLevel = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: customerApis.updatePriceLevel,
            data: request,
            method: apiMethods.put,
        }))
    };

    /**
     * Updates companies payment terms
     * @param request the new payment term of the company
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateCustomerPaymentTerms = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: customerApis.updatePaymentTerms,
            method: apiMethods.put,
            data: request,
        }))
    };

    /**
     * Gets the company members access levels based on company id
     * @param companyId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getCustomerMembersWithAccessLevels = async (companyId) => {
        return await apiCallback(Api.prepareRequest({
            url: customerApis.getMembersWithAccessLevels(companyId),
            method: apiMethods.get,
        }))
    };

    /**
     * Gets the admin user of the company based on company id
     * @param customerId
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static getUserAdminByCustomerId = async (customerId) => {
        return await apiCallback(Api.prepareRequest({
            url: customerApis.getUserAdminByCustomerId(customerId),
            method: apiMethods.get,
            showErrorToast: false,
        }))
    }

    // ########################################     PART APIS     ########################################

    /**
     * Gets the customer recent searches.
     * @param customerId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getCustomerRecentSearches = async (customerId) => {
        return await apiCallback(Api.prepareRequest({
            url: partApis.getCustomerRecentSearches(customerId),
            method: apiMethods.get,
        }));
    }

    /**
     * Gets the part information including their image based on part number.
     * @param partNumber {string}
     * @param searchToken {string} optional - the token that is used for searching the part.
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartInformation = async (partNumber, searchToken = undefined, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: partApis.getPart(partNumber, searchToken),
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }


    /**
     * Gets the related parts list for a specific part for a specific user
     * @param partNumber {string}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartRelatedParts = async (partNumber) => {
        return await apiCallback(Api.prepareRequest({
            url: partApis.getRelatedParts(partNumber),
            method: apiMethods.get,
        }));
    }

    /**
     * Gets the comments of a specific part
     * @param partNumber {string}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartFeedbacks = async (partNumber) => {
        return await apiCallback(Api.prepareRequest({
            url: partApis.getFeedbacks(partNumber),
            method: apiMethods.get,
        }));
    }

    /**
     * Toggles the visibility of a specific feedback based on its id
     * @param feedbackId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static toggleFeedbackVisibility = async (feedbackId) => {
        return await apiCallback(Api.prepareRequest({
            url: partApis.toggleFeedbackVisibility(feedbackId),
            method: apiMethods.delete,

        }));
    }

    /**
     * Removes a specific feedback based on its id.
     * @param feedbackId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeFeedback = async (feedbackId) => {
        return await apiCallback(Api.prepareRequest({
            url: partApis.removeFeedback(feedbackId),
            method: apiMethods.delete,

        }));
    }

    /**
     * Reports a problem for a specific part
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static reportPartProblem = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partApis.reportProblem,
            method: apiMethods.post,
            data: request,
        }));
    }

    // ########################################     PART SHARE LINK APIS     ########################################

    /**
     * Generates a share link for a specific part.
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static generateLink = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: linkApis.create,
            method: apiMethods.post,
            data: request,

        }));
    }

    /**
     * Updates a link information for a specific part
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateLink = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: linkApis.update,
            method: apiMethods.put,
            data: request,

        }));
    }

    // ########################################     COMPETITORS APIS     ########################################

    /**
     * Lists active competitors for the current partner.
     * @param {import('axios').CancelToken} [cancelToken]
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listCompetitors = async (cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: competitorApis.list,
            method: apiMethods.get,
            cancelToken,
        }));
    }

    /**
     * Creates a competitor (created as public).
     * @param {{title: string}} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addCompetitor = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: competitorApis.add,
            method: apiMethods.post,
            data,
        }));
    }

    /**
     * Updates a competitor owned by the current partner.
     * @param {{id: number, title: string, isPublic: boolean}} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateCompetitor = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: competitorApis.update,
            method: apiMethods.put,
            data,
        }));
    }

    /**
     * Soft-deletes a competitor and reassigns related price reports.
     * @param {number} id
     * @param {number} replacementId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static deleteCompetitor = async (id, replacementId) => {
        return await apiCallback(Api.prepareRequest({
            url: competitorApis.delete(id, replacementId),
            method: apiMethods.delete,
        }));
    }

    /**
     * Reports a competitor price for a part and customer.
     * @param {{partId: number, currentPrice: number, competitorId: number, competitorPrice: number, customerId: number, priceLevelId: number}} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static reportCompetitorPrice = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: competitorApis.reportPrice,
            method: apiMethods.post,
            data,
        }));
    }

    /**
     * Paginated competitor price reports for the current partner.
     * @param {object} data
     * @param {import('axios').CancelToken} [cancelToken]
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listCompetitorPriceReports = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: competitorApis.listPriceReports,
            method: apiMethods.post,
            data,
            cancelToken,
        }));
    }

    /**
     * Paginated competitor price reports submitted by the current operator.
     * @param {object} data
     * @param {import('axios').CancelToken} [cancelToken]
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listMyCompetitorPriceReports = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: competitorApis.listMyPriceReports,
            method: apiMethods.post,
            data,
            cancelToken,
        }));
    }

    /**
     * Checks or unchecks a competitor price report.
     * @param {{id: number, isChecked: boolean}} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static checkCompetitorPriceReport = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: competitorApis.checkPriceReport,
            method: apiMethods.put,
            data,
        }));
    }

    /**
     * Soft-deletes a competitor price report.
     * @param {number} id
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeCompetitorPriceReport = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: competitorApis.removePriceReport(id),
            method: apiMethods.delete,
        }));
    }


    // ########################################     USER GIFT CARDS APIS     ########################################

    /**
     * Gets a list of gift cards for a specific customer
     * @param customerId
     * @param loadAll
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static getCustomerGiftCards = async (customerId, loadAll = true) => {
        return await apiCallback(Api.prepareRequest({
            url: userGiftCardApis.getCustomerGiftCards(customerId, loadAll),
            method: apiMethods.get,
        }));
    }

    /**
     * Gets the list of reasons for refilling the gift cards.
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getRefillReasonsForGiftCards = async () => {
        return await apiCallback(Api.prepareRequest({
            url: userGiftCardApis.getRefillReasonsForGiftCards,
            method: apiMethods.get,
        }));
    }

    /**
     * Searches for the gift cards in the system based on the provided filters.
     * @param request {any}
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchGiftCards = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: userGiftCardApis.searchGiftCards,
            method: apiMethods.post,
            data: request,
            redirectToError: true,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Creates a gift card for a specific user.
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createGiftCard = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: userGiftCardApis.create,
            data: request,
            method: apiMethods.post,
        }));
    }

    /**
     * Creates a series of  gift cards for a specific user.
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createGiftCardInBulk = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: userGiftCardApis.createBulk,
            data: request,
            method: apiMethods.post,
        }));
    }

    /**
     * Creates or updates a specific gift card category. If the id is present, it will update, otherwise it will create.
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createOrUpdateGiftCardCategory = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: userGiftCardApis.createOrUpdateCategory,
            data: request,
            method: apiMethods.post,
        }));
    }

    /**
     * Gets the list of gift card categories
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getGiftCardCategories = async () => {
        return await apiCallback(Api.prepareRequest({
            url: userGiftCardApis.getCategories,
            method: apiMethods.get,
        }));
    }

    /**
     * Gets the list of fixed gift card available amounts in the system
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getGiftCardAmounts = async () => {
        return await apiCallback(Api.prepareRequest({
            url: userGiftCardApis.getAvailableAmounts,
            method: apiMethods.get,
        }));
    }

    /**
     * Removes a specific gift card of the company
     * @param cardNumber {string}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeGiftCard = async (cardNumber) => {
        return await apiCallback(Api.prepareRequest({
            url: userGiftCardApis.removeGiftCard(cardNumber),
            method: apiMethods.delete,
        }));
    }

    /**
     * Removes a specific gift card category of the company
     * @param categoryId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeGiftCardCategory = async (categoryId) => {
        return await apiCallback(Api.prepareRequest({
            url: userGiftCardApis.removeGiftCardCategory(categoryId),
            method: apiMethods.delete,
        }));
    }

    /**
     * Refills a specific gift card of the company
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static refillGiftCard = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: userGiftCardApis.refillGiftCard,
            method: apiMethods.patch,
            data: request,
        }));
    }

    /**
     * Assigns a user to a specific gift card of the company
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static assignUserToGiftCard = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: userGiftCardApis.assignToUser,
            method: apiMethods.patch,
            data: request,
        }));
    }

    /**
     * Updates the activation status of a specific gift card of the company
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateActivationStatusOfGiftCard = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: userGiftCardApis.updateActivationStatus,
            method: apiMethods.patch,
            data: request,
        }));
    }

    /**
     * Updates the category of a specific gift card of the company
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateGiftCardCategory = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: userGiftCardApis.updateCategory,
            method: apiMethods.patch,
            data: request,
        }));
    }

    /**
     * Removes a user from a particular gift card.
     * @param cardId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeLockForUserFromCard = async (cardId) => {
        return await apiCallback(Api.prepareRequest({
            url: userGiftCardApis.removeLockForUserFromCard(cardId),
            method: apiMethods.patch,
        }));
    }

    /**
     * Searches among gift card histories of the user given filter data and the gift card info.
     *
     * @param cancelToken
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchGiftCardHistory = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: userGiftCardApis.searchHistory,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }));
    }

    // ########################################     USER ADDRESSES APIS     ########################################

    /**
     * Fetches the list of customer addresses which contain shipping and billing addresses for a specific customer.
     * @param customerId
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static getCustomerAddresses = async (customerId) => {
        return await apiCallback(Api.prepareRequest({
            url: userAddressesApis.getAllByCustomer(customerId),
            method: apiMethods.get,
        }));
    }

    /**
     * Creates an address for a specific user.
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createUserAddress = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: userAddressesApis.create,
            data: request,
            method: apiMethods.post,
        }));
    }

    /**
     * Updates a specific address for a user.
     *
     * in the case that the address was default then the default value can not be updated nor the type of the address
     *
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateUserAddress = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: userAddressesApis.update,
            method: apiMethods.put,
            data: request,
        }));
    }

    /**
     * Sets an address as a default address based on its id
     * @param addressId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setUserAddressAsDefault = async (addressId) => {
        return await apiCallback(Api.prepareRequest({
            url: userAddressesApis.setAsDefault(addressId),
            method: apiMethods.put,
        }));
    }

    /**
     * Removes a specific address based on its id
     * @param addressId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeUserAddress = async (addressId) => {
        return await apiCallback(Api.prepareRequest({
            url: userAddressesApis.remove(addressId),
            method: apiMethods.delete,
        }));
    }

    // ####################################    USERS APIS     ########################################

    /**
     * Gets customer account information based on their id
     * @param customerId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getCustomerAccountInformation = async (customerId) => {
        return await apiCallback(Api.prepareRequest({
            url: usersApis.getCustomerExtraInfo(customerId),
            method: apiMethods.get,
        }));
    }

    /**
     * Gets a list of login logs based on provided filters
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchLoginLogs = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: usersApis.loginLogSearch,
            data: request,
            method: apiMethods.post,
            //
        }));
    }

    /**
     * Gets all the access levels for the members of the company.
     */
    static getMembersAccessLevels = async () => {
        return await apiCallback(Api.prepareRequest({
            url: usersApis.getMembersAccessLevels,
            method: apiMethods.get,
        }));
    }

    /**
     * Gets the enum form needed for list sections of users. includes the status types.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getUserSearchForm = async () => {
        return await apiCallback(Api.prepareRequest({
            url: usersApis.getUserSearchForm,
            method: apiMethods.get,
        }));
    }

    /**
     * Gets the user profile enums. Includes countries, provinces, status types, price levels, search limit periods
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getUserProfileForm = async () => {
        return await apiCallback(Api.prepareRequest({
            url: usersApis.getProfilePageForm,
            method: apiMethods.get,
        }));
    }

    /**
     * Searches the users.
     * if request.memberShipName !== 'OnHold' for current users
     *
     * @param {any} request
     * @param {any} cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|{data: null, errorCode: number, resultFlag: boolean, message: string, headerTitle: string, status: number}|undefined>}
     */
    static searchCurrentUsers = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: usersApis.searchAllUsers,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Searches the deactivated users.
     * request.memberShipName === 'OnCompanyLost' for the ones that are kicked from a company
     * request.memberShipName === 'Deactivated' for the ones that still belong to a company but are deactivated
     *
     * @param {any} cancelToken
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|{data: null, errorCode: number, resultFlag: boolean, message: string, headerTitle: string, status: number}|undefined>}
     */
    static searchInactiveUsers = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: usersApis.searchAllUsers,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Searches the users.
     * request.memberShipName === 'OnHold' for new users
     *
     * @param {any} request
     * @param {any} cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|{data: null, errorCode: number, resultFlag: boolean, message: string, headerTitle: string, status: number}|undefined>}
     */
    static searchNewUsers = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: usersApis.searchAllUsers,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Searches for the users only using first name last name and email
     * @param keywords {string}
     * @param {import(axios).CancelToken} cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static fastSearchUsers = async (keywords, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: usersApis.fastSearch(keywords),
            method: apiMethods.get,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Accepts a new user by assigning a company for it or choosing a company (suggestions)
     * Activates the members of companies
     *
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|{data: null, errorCode: number, resultFlag: boolean, message: string, headerTitle: string, status: number}|undefined>}
     */
    static AssignCompanyToUser = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: usersApis.assignCompanyToUser,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Deactivates a user by removing them from their company
     * @param userId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeCompanyFromUser = async (userId) => {
        return await apiCallback(Api.prepareRequest({
            url: usersApis.removeCompanyFromUser(userId),
            method: apiMethods.put,
        }))
    }

    /**
     * Updates the profile info of the user.
     *
     * for adding images, or replacing it, use the contentBytes obtained from the image and place it in the avatar
     * object
     * ```javascript
     * avatar: { content: [<content goes here>]}
     * ```
     *
     * @param request
     * @param onUploadProgress {function}
     * @return {Promise<ApiResponseDs<unknown | null>|{data: null, errorCode: number, resultFlag: boolean, message: string, headerTitle: string, status: number}|undefined>}
     */
    static updateUserProfileInfo = async (request, onUploadProgress = null) => {
        return await apiCallback(Api.prepareRequest({
            url: usersApis.update,
            method: apiMethods.patch,
            onUploadProgress: onUploadProgress,
            data: request,
        }))
    }

    /**
     * Toggles the status of the user from active to de-active and vise versa.
     * @param userId {number} id of the user to be toggled
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static toggleUserStatus = async (userId) => {
        return await apiCallback(Api.prepareRequest({
            url: usersApis.toggleStatus(userId),
            method: apiMethods.put,
        }))
    }

    /**
     * Resends the activation email for a user and returns the activation link.
     * @param {number} userId
     * @param {{showErrorToast?: boolean}} [options]
     * @return {Promise<ApiResponseDs<{activationLink?: string, emailSent?: boolean} | null>|undefined>}
     */
    static resendUserActivation = async (userId, options = {}) => {
        return await apiCallback(Api.prepareRequest({
            url: userV2Apis.resendActivation,
            method: apiMethods.post,
            data: {userId},
            showErrorToast: options.showErrorToast,
        }))
    }

    /**
     * Updates a company member's access levels based on their id
     *
     * if hasFullAccessLevel then send the accessLevel list as null.
     *
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateCompanyMemberAccessLevels = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: usersApis.updateUserAccessLevels,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Creates a new User and also creates a new Company if the fields are provided.
     *
     * @param request
     * @param hideToasts
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createUser = async (request, hideToasts = false) => {
        return await apiCallback(Api.prepareRequest({
            url: usersApis.create,
            method: apiMethods.post,
            data: request,
            ...(hideToasts ? {
                showErrorToast: false,
                showSuccessToast: false,
            } : {})
        }))
    }


    /**
     * Creates a new User from a given customer from the backend
     *
     * @param request
     * @param hideToasts
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static fastCreateUserFromSpireCustomer = async (request, hideToasts = false) => {
        return await apiCallback(Api.prepareRequest({
            url: usersApis.fastCreateFromSpireCustomer,
            method: apiMethods.post,
            data: request,
            ...(hideToasts ? {
                showErrorToast: false,
                showSuccessToast: false,
            } : {})
        }))
    }


    /**
     * Gets the users basic information including their name email and phone  number.
     * @param userId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getUserBasicInfo = async (userId) => {
        return await apiCallback(Api.prepareRequest({
            url: usersApis.getBasicInfo(userId),
            method: apiMethods.get,
        }))
    }

    // ####################################    QUOTES APIS     ########################################

    /**
     * Search the list of quests for a specific user or users based on provided filters
     * @param request
     * @param sourceToken
     * @param onErrorCallback
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchQuotes = async (request, sourceToken, onErrorCallback) => {
        return await apiCallback(Api.prepareRequest({
            url: quotesApis.search,
            method: apiMethods.post,
            data: request,
            sourceToken: sourceToken,
            unAuthorizedCallback: onErrorCallback,
            accessDeniedCallback: onErrorCallback,
        }))
    }

    /**
     * Search the list of quest items for a specific user or users based on provided filters
     * @param sourceToken
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchQuoteItems = async (request, sourceToken) => {
        return await apiCallback(Api.prepareRequest({
            url: quotesApis.searchItems,
            method: apiMethods.post,
            data: request,
            sourceToken: sourceToken,
        }))
    }

    /**
     * Gets the information of a specific quote for a specific customer
     * @param customerId {number}
     * @param quoteId {number}
     * @param showErrorToast
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getQuoteInformationForCustomer = async (customerId, quoteId, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: quotesApis.getForCustomer(customerId, quoteId),
            method: apiMethods.get,
            redirectToError: showErrorToast,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Gets the customer's last accessed quote based on the user id.
     * @param userId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getCustomerLastQuote = async (userId) => {
        return await apiCallback(Api.prepareRequest({
            url: quotesApis.getLastQuoteForCustomer(userId),
            method: apiMethods.get,
        }))
    }

    /**
     * Updates the quote parts information.
     * @param request
     * @param cancelToken
     * @param showErrorToast
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateQuoteItems = async (request, cancelToken, showErrorToast = true) => {
        const _request = Api.prepareRequest({
            url: quotesApis.update,
            method: apiMethods.put,
            data: request,
            cancelToken: cancelToken,
            showErrorToast: showErrorToast,
        });
        const response = await apiCallback(_request);
        if (response?.resultFlag) {
            return response;
        }
        if (response?.errorCode === ApiResponseCodes.requireSalesPersonProfile) {
            response?.showToast?.error({
                hideTicketSubmission: false,
                title: "Sales Person",
                message: `${response.message}`,
                buttons: [{
                    children: "Create Profile",
                    onClick: ({closeToast}) => _request?.history?.push(routes.salesPerson.dashboard) || closeToast(),
                }],
            });
        }
        return response;
    }

    /**
     * Updates the quote item's discount percentage.
     * @param request
     * @param showErrorToast
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateQuoteItemDiscount = async (request, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: quotesApis.updateItemDiscount,
            method: apiMethods.post,
            data: request,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Updates the quote item's comment.
     * @param request
     * @param showErrorToast
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateQuoteItemComment = async (request, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: quotesApis.updateItemComment,
            method: apiMethods.post,
            data: request,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Creates a new quote for the user with some initial items
     * @param request
     * @param cancelToken
     * @param showErrorToast
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createNewQuoteV2 = async (request, showErrorToast = false, cancelToken,) => {
        const _request = Api.prepareRequest({
            url: orderV2Apis.create,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
            showErrorToast: false,
        });
        const response = await apiCallback(_request);
        if (response?.resultFlag) {
            return response;
        }
        if (response?.errorCode === ApiResponseCodes.requireSalesPersonProfile) {
            response?.showToast?.error({
                hideTicketSubmission: false,
                title: "Sales Person",
                message: `${response.message}`,
                buttons: [{
                    children: "Create Profile",
                    onClick: ({closeToast}) => _request?.history?.push(routes.salesPerson.dashboard) || closeToast(),
                }],
            });
        } else if (showErrorToast) {
            response?.showToast?.error({
                title: response?.headerTitle,
                message: response?.message,
                hideTicketSubmission: (response?.errorCode === 401),
            });
        }
        return response;
    }

    /**
     * Updates the address of the quote.
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateQuoteAddress = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: quotesApis.updateAddress,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Remove a transaction from a particular quote and refunds the amount of that transaction to the customer
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeQuoteTransactionItem = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: quotesApis.removeTransactionItem,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Creates a payment transaction for a quote of a particular user.
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static payQuote = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: quotesApis.payQuote,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Converts a quote into a sales order.
     * @param request {any}
     * @param showErrorToast {boolean}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static generateSalesOrder = async (request, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: quotesApis.processCheckout,
            method: apiMethods.put,
            data: request,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Adds a Credit to a specific Quote of a specific user.
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addCreditToQuote = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: quotesApis.addCredit,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Adds a Gift Card to a specific Quote of a specific user.
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addGiftCardToQuote = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: quotesApis.addGiftCard,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Removes a specific Quote of a specific customer.
     * @param customerId
     * @param quoteId
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static removeQuoteByCustomer = async (customerId, quoteId, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: quotesApis.removeByCustomer(customerId, quoteId),
            method: apiMethods.delete,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Updates the customer po number and fob of a specific quote of a specific user.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateQuotesPOAndFob = async (request, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: quotesApis.updatePOAndFob,
            method: apiMethods.put,
            data: request,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Sends an email containing the quote information to the users email address
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static sendQuoteInformationToUserEmail = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: quotesApis.sendEmail,
            method: apiMethods.post,
            data: request,
            showSuccessToast: true,
        }))
    }

    /**
     * Fetches the pre-authorization payment's margin percentage amount that is to be applied to the amount of the
     * quote payment.
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getQuoteAuthPaymentMarginPercentage = async () => {
        return await apiCallback(Api.prepareRequest({
            url: quotesApis.getMarginPreAuthPaymentsPercentageAmount,
            method: apiMethods.get,
        }))
    }


    // ####################################    SALES ORDERS APIS     ########################################

    /**
     * Search the list of sales orders for a specific user or users based on provided filters
     * @param request
     * @param cancelToken
     * @param onErrorCallback
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchSalesOrders = async (request, cancelToken, onErrorCallback) => {
        return await apiCallback(Api.prepareRequest({
            url: salesOrdersApis.search,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
            unAuthorizedCallback: onErrorCallback,
            accessDeniedCallback: onErrorCallback,
        }))
    }

    /**
     * Search the list of sales order items for a specific user or users based on provided filters
     * @param cancelToken
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchSalesOrderItems = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: salesOrdersApis.searchItems,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Gets the information of a specific sales order for a specific customer
     * @param customerId
     * @param salesOrderId
     * @param {boolean} [showErrorToast=true]
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static getSalesOrderInformationForCustomer = async (customerId, salesOrderId, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: salesOrdersApis.getForCustomer(customerId, salesOrderId),
            method: apiMethods.get,
            redirectToError: showErrorToast,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Updates the sales order parts information.
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateSalesOrderItems = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: salesOrdersApis.update,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Reverts a sales order to quote.
     * @param customerId
     * @param salesOrderId
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static revertToQuoteByCustomer = async (customerId, salesOrderId) => {
        return await apiCallback(Api.prepareRequest({
            url: salesOrdersApis.revertToQuoteByCustomer(customerId, salesOrderId),
            method: apiMethods.put,
        }))
    }

    /**
     * Remove a transaction from a particular sales order and refunds the amount of that transaction to the customer
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeSalesOrderTransactionItem = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: salesOrdersApis.removeTransactionItem,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Creates a payment transaction for a sales order of a particular user.
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static paySalesOrder = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: salesOrdersApis.paySalesOrder,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Gets the list of serial numbers available for the provided warehouse and part number
     * @param warehouseCode {string}
     * @param partNumber {string}
     * @param showErrorToast {boolean?}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getInventorySerialNumbers = async (warehouseCode, partNumber, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: salesOrdersApis.getInventorySerialNumbers(warehouseCode, partNumber),
            method: apiMethods.get,
            showErrorToast: showErrorToast
        }))
    }


    /**
     * Updates the serial number list of a specific part in a sales order.
     * @param request
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateSalesOrderPartSerialNumbers = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: salesOrdersApis.updatePartSerialNumbers,
            method: apiMethods.put,
            data: request,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Updates the address of the sales order.
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateSalesOrderAddress = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: salesOrdersApis.updateAddress,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Converts a sales order into an invoice
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static generateInvoice = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: salesOrdersApis.processCheckout,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Updates the customer po number and fob of a specific sales order of a specific user.
     * @param request
     * @param cancelToken
     * @param {boolean} [showErrorToast=true]
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateSalesOrdersPOAndFob = async (request, cancelToken, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: salesOrdersApis.updatePOAndFob,
            method: apiMethods.put,
            data: request,
            cancelToken: cancelToken,
            showErrorToast,
        }))
    }

    /**
     * Updates the parts' committed quantity for a selected part of a selected sales order of a specific user.
     *
     * @param request
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateSalesOrderCommittedQuantityOfPart = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: salesOrdersApis.updateCommittedQuantityOfPart,
            method: apiMethods.put,
            data: request,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Updates the sales order item's comment.
     * @param request
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateSalesOrderItemComment = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: salesOrdersApis.updateItemComment,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Sends an email containing the sales order information to the users email address
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static sendSalesOrderInformationToUserEmail = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: salesOrdersApis.sendEmail,
            method: apiMethods.post,
            data: request,
            showSuccessToast: true,
        }))
    }

    // ####################################    BACK ORDERS APIS     ########################################

    /**
     * Search the list of back orders for a specific user or users based on provided filters
     * @param request
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchBackOrders = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: backOrdersApis.search,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Search the list of back order Items for a specific user or users based on provided filters
     * @param cancelToken
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchBackOrderItems = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: backOrdersApis.searchItems,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }))
    }


    // ####################################    INVOICE APIS     ########################################

    /**
     * Search the list of invoices for a specific user or users based on provided filters
     * @param request
     * @param cancelToken
     * @param onErrorCallback
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchInvoices = async (request, cancelToken = null, onErrorCallback) => {
        return await apiCallback(Api.prepareRequest({
            url: invoicesApis.search,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
            unAuthorizedCallback: onErrorCallback,
            accessDeniedCallback: onErrorCallback,
        }))
    }

    /**
     * Search the list of invoice items for a specific user or users based on provided filters
     * @param request
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchInvoiceItems = async (request, cancelToken = null) => {
        return await apiCallback(Api.prepareRequest({
            url: invoicesApis.searchItems,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken
        }))
    }

    /**
     * Gets the information of a specific invoice for a specific user
     */
    static getInvoiceInformationForCustomer = async (customerId, invoiceId) => {
        return await apiCallback(Api.prepareRequest({
            url: invoicesApis.getForCustomer(customerId, invoiceId),
            method: apiMethods.get,
            redirectToError: true,
        }))
    }


    /**
     * Gets the list of invoices for a specific user and a specific part
     * @param request
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchInvoicesBasedOnPart = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: newInvoicesApis.getInvoicesForPart,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Adds a Credit to multiple selected invoices of a specified user
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addCreditToMultiInvoices = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: invoicesApis.addCreditToMulti,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Pay for a series of invoices for a specific user.
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static payMultipleInvoices = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: invoicesApis.payMultiInvoices,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Removes a transaction item from a specific invoice.
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeTransactionItemFromInvoice = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: invoicesApis.removeTransactionItem,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Pays for a specific invoice with the provided credit card.
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static payInvoice = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: invoicesApis.payInvoice,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Adds a specific credit to an invoice of the user.
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addCreditToInvoice = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: invoicesApis.addCreditToInvoice,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Removes a transaction item from a set of specific invoices.
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeTransactionItemFromMultiInvoices = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: invoicesApis.removeBulkTransactionItem,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Sends an email containing the invoice information to the users email address
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static sendInvoiceInformationToUserEmail = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: invoicesApis.sendEmail,
            method: apiMethods.post,
            data: request,
            showSuccessToast: true,
        }))
    }

    /**
     * Sends an email containing the multi invoice information to the users email address
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static sendMultiInvoiceInformationToUserEmail = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: invoicesApis.sendMultiEmail,
            method: apiMethods.post,
            data: request,
            showSuccessToast: true,
        }))
    }

    /**
     * Updates the customer po number and reference of a specific invoice of a specific customer.
     * @param request
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static updateInvoicePoReference = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: invoicesApis.updatePoReference,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Updates the invoice item's comment.
     * @param request
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static updateInvoiceItemComment = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: invoicesApis.updateItemComment,
            method: apiMethods.post,
            data: request,
        }))
    }

    // ####################################    CREDIT APIS     ########################################

    /**
     * Search the list of credits for a specific user or users based on provided filters
     * @param cancelToken
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchCredits = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: creditsApis.search,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Search the list of credit items for a specific user or users based on provided filters
     * @param request
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchCreditItems = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: creditsApis.searchItems,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Gets the information of a specific credit for a specific customer
     * @param customerId {number}
     * @param creditId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getCreditInformationForCustomer = async (customerId, creditId) => {
        return await apiCallback(Api.prepareRequest({
            url: creditsApis.getForCustomer(customerId, creditId),
            method: apiMethods.get,
            redirectToError: true,
        }))
    }


    // ####################################    SHOPPING CART APIS     ########################################

    /**
     * Gets the users currently active quote as their shopping cart.
     * @param userId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getCurrentShoppingCartForUser = async (userId) => {
        return await apiCallback(Api.prepareRequest({
            url: shoppingCartApis.getActiveCart(userId),
            method: apiMethods.get,
        }))
    }

    /**
     * Closes a users' shopping cart for a specific user.
     * @param userId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static closeShoppingCart = async (userId) => {
        return await apiCallback(Api.prepareRequest({
            url: shoppingCartApis.closeShoppingCart(userId),
            method: apiMethods.put,
        }))
    }

    /**
     * Updates the items of a shopping cart.
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateShoppingCartItems = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: shoppingCartApis.updateItems,
            data: request,
            method: apiMethods.put,
        }))
    }

    // ####################################    SEARCH LIMIT APIS     ########################################

    /**
     * Creates a new search limit for the user.
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createSearchLimitForCustomer = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: searchLimitsApis.createLimit,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Updates a search limit for a specific user.
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateSearchLimitForCustomer = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: searchLimitsApis.updateLimit,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Removes a search limit for a specific user based on the id of the search limit
     * @param searchLimitId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeSearchLimitForCustomer = async (searchLimitId) => {
        return await apiCallback(Api.prepareRequest({
            url: searchLimitsApis.removeLimit(searchLimitId),
            method: apiMethods.delete,
            redirectToError: false,
        }))
    }


    // ####################################    OPERATOR APIS     ########################################

    /**
     * Gets the operator info including their user groups based on their id.
     *
     * @param operatorId {string} - operator token
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getOperatorById = async (operatorId) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorApis.getById(operatorId),
            method: apiMethods.get,
        }))
    }

    /**
     * Searches for the operators in the partner database (local) based on the provided filters
     *
     * @param request {any}
     * @param {import(axios).CancelToken} cancelToken
     * @param onErrorCallback
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchOperatorsLocal = async (request, cancelToken, onErrorCallback) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorApis.searchLocal,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
            unAuthorizedCallback: onErrorCallback,
            accessDeniedCallback: onErrorCallback,
        }))
    }

    /**
     * Creates a new operator for the company of the creator.
     *
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createOperator = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorApis.createOperator,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Creates a new operator record for the company of the creator.
     *
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createOperatorGroup = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorApis.createOperatorGroup,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Gets current operator information
     * @param {Function | null} getHeaders
     * @param {CancelToken | undefined} cancelToken
     * @param {boolean} bypassAuthCheck
     * @param {unknown} logger
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getCurrentOperatorInformation = async (getHeaders = null, cancelToken = null, bypassAuthCheck = false, logger = null) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorApis.getCurrentOperatorInformation,
            method: apiMethods.get,
            showErrorToast: false,
            getHeaders: getHeaders,
            cancelToken: cancelToken,
            logger: logger,
            loginRequired: !bypassAuthCheck,
        }))
    }

    /**
     * Updates an operator information.
     *
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateOperator = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorApis.updateOperator,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Resets current operator's password
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static resetCurrentOperatorPassword = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorApis.resetCurrentOperatorPassword,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Updates an operator groups by assigning new groups or removing some from them.
     *
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateOperatorGroups = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorApis.updateOperatorGroups,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Updates an operator record (its name for this stage)
     *
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateOperatorGroup = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorApis.updateGroup,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Gets all the groups for the operators' company
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getAllOperatorGroups = async () => {
        return await apiCallback(Api.prepareRequest({
            url: operatorApis.getAllOperatorGroups,
            method: apiMethods.get,
        }))
    }

    /**
     * Gets all the groups for the operators' company
     *
     * @param {any} request request for resetting password.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static resetOperatorPassword = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorApis.resetPassword,
            method: apiMethods.put,
            data: request,
            showSuccessToast: true,
        }))
    }

    /**
     * Gets all access levels that a specific record has.
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getOperatorGroupAccessLevels = async (groupId) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorApis.getOperatorGroupById(groupId),
            method: apiMethods.get,
        }))
    }

    /**
     * Gets all access levels available for the company.
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getAllAccessLevels = async () => {
        return await apiCallback(Api.prepareRequest({
            url: operatorApis.getAllAccessLevels,
            method: apiMethods.get,
        }))
    }

    /**
     * Adds an access level for a specific operator
     *
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addAccessLevelsForOperatorGroup = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorApis.addNewAccessLevel,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Removes an access level from a specific operator
     *
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeAccessLevelFromOperatorGroup = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorApis.removeAccessLevel,
            method: apiMethods.post,
            data: request,
        }))
    }


    // ####################################    PRICE MATRIX APIS     ########################################

    /**
     * Fetches the price matrices for the system.
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static getSystemPriceMatrices = async () => {
        return await apiCallback(Api.prepareRequest({
            url: priceMatrixApis.getSystemPriceMatrices,
            method: apiMethods.get,
        }))
    }

    /**
     * Fetches the price matrices for the customer.
     * @param customerId
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static getCustomerPriceMatrices = async (customerId) => {
        return await apiCallback(Api.prepareRequest({
            url: priceMatrixApis.getCustomerPriceMatrices(customerId),
            method: apiMethods.get,
        }))
    }

    /**
     * Creates a new price matrix for a specific user.
     * @param request
     * @param showErrorToast
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createPriceMatrix = async (request, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: priceMatrixApis.create,
            method: apiMethods.post,
            data: request,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Creates a new price matrix for a specific user.
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updatePriceMatrix = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: priceMatrixApis.update,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Removes a price matrix from a specific user.
     * @param priceMatrixId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removePriceMatrix = async (priceMatrixId) => {
        return await apiCallback(Api.prepareRequest({
            url: priceMatrixApis.remove(priceMatrixId),
            method: apiMethods.delete,
        }))
    }


    // ####################################    WARRANTY AND RETURN APIS     ########################################


    /**
     * Assigns the selected warranty request to the current operator
     * @param warrantyId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static assignPartSupportRequestToOperator = async (warrantyId) => {
        return await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.assignToOperator(warrantyId),
            method: apiMethods.put,
        }))
    }

    /**
     * Assigns the selected vendor to the warranty request.
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static assignVendorToPartSupportRequest = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.assignToVendor,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Gets the messages and the request information of a selected warranty and return request.
     * @param warrantyId {number}
     * @param redirectToError
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartSupportRequestInformation = async (warrantyId, redirectToError = false) => {
        return await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.getInformation(warrantyId),
            method: apiMethods.get,
            redirectToError: redirectToError,
            showErrorToast: redirectToError,
        }))
    }

    /**
     * Gets List of types and statuses for warranty and return
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartSupportTypesAndStatuses = async (cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.getStatusesAndTypes,
            method: apiMethods.get,
            redirectToError: true,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Submits an initial warranty and return request.
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static submitInitialPartSupportRequest = async (request) => {
        const response = await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.submitInitialRequest,
            method: apiMethods.post,
            data: request,
            showSuccessToast: true,
            showErrorToast: false,
        }))
        if (response?.resultFlag)
            return response;
        if (!response?.resultFlag && response.errorCode !== ApiResponseCodes.expiredPartSupport) {
            response?.showToast?.error({
                hideTicketSubmission: true,
                title: response?.headerTitle,
                message: `${response.message}`,
            });
        }
        return response;

    }

    /**
     * Sends a new message for a specific warranty and return request.
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static sendPartSupportMessage = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.sendMessage,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Removes a message in a specific warranty and return request.
     * @param messageId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removePartSupportMessage = async (messageId) => {
        return await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.deleteMessage(messageId),
            method: apiMethods.delete,
        }))
    }

    /**
     * Changes the status of a specific request with the specific status.
     * @param requestId {number}
     * @param statusId {number}
     * @param reasonId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static changePartSupportRequestStatus = async (requestId, statusId, reasonId = null) => {
        return await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.changeStatus(requestId, statusId, reasonId),
            method: apiMethods.put,
        }))
    }

    /**
     * Submits a new expiration date for an expired serial number in a specific invoice
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static SubmitNewExpirationDateForSerialNumber = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.submitRequestNewExpirationDate,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Validates the given rga on whether it already exits or not.
     * @param rga {string}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static validateRGA = async (rga) => {
        return await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.validateRGA(rga),
            method: apiMethods.get,
            showErrorToast: false,
        }))
    }

    /**
     * Validates the given rga on whether it already exits or not.
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateWarrantyAndReturnRga = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.updateRga,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Removes a warranty and return request.
     *
     * @param id {number} the id of the request to be removed.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeWarrantyAndReturnRequest = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.remove(id),
            method: apiMethods.delete,
        }))
    }

    /**
     * Gets warranty and return process page data for CRUD operations.
     *
     * @param {any} request the request.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getWarrantyAndReturnProcessSettingData = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.getProcessEditPageData,
            method: apiMethods.post,
            data: request,
            redirectToError: true,
        }))
    }

    /**
     * Assigns a credit to a part support request information.
     *
     * @param {any} request the request.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static assignCreditToPartSupportRequest = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.assignCredit,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Removes a vendor from a part support request.
     *
     * @param {any} request the request.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeVendorFromPartSupportRequest = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.removeVendor,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Updates an existing part support request.
     *
     * @param {any} request the request to be updated.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updatePartSupportRequest = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.updateRequest,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Removes the attached credit from the selected part support request.
     *
     * @param {any} request the data for the api request.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static detachPartSupportRequestCredit = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.detachCredit,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Assigns a vendor credit to the selected part support request.
     *
     * @param {any} request the data for the api request.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static assignPartSupportRequestVendorCredit = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.assignVendorCredit,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Removes the attached vendor credit from the selected part support request.
     *
     * @param {any} request the data for the api request.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static detachPartSupportRequestVendorCredit = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.detachVendorCredit,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Updates the note of a part support request.
     *
     * @param {any} request the data for the api request.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updatePartSupportRequestNote = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.updateNote,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Updates the note of a part support request.
     *
     * @param {number} id the id of the request
     * @param {string?} keywords the optional keywords for the search
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchVendorCreditsForPartSupportRequest = async (id, keywords = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: warrantyAndReturnApis.searchVendorCredits(id, keywords),
            method: apiMethods.get,
        }))
    }

    // ####################################    PARTNER CONFIGURATION APIS     ########################################

    /**
     * Lists all partner configuration properties (catalog).
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listPartnerConfigurationProperties = async () => {
        return await apiCallback(Api.prepareRequest({
            url: partnerConfigurationApisV2.list,
            method: apiMethods.get,
            redirectToError: true,
        }));
    }

    /**
     * Gets partner and operator values for configuration properties.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartnerConfigurationValues = async () => {
        return await apiCallback(Api.prepareRequest({
            url: partnerConfigurationApisV2.getValues,
            method: apiMethods.get,
            redirectToError: true,
        }));
    }

    /**
     * Sets (or clears) a partner-level configuration value.
     * @param request {{propertyId: number, value: string | null}}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setPartnerConfigurationValue = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partnerConfigurationApisV2.setPartner,
            data: request,
            method: apiMethods.put,
        }));
    }

    /**
     * Sets (or clears) an operator-level configuration value.
     * @param request {{propertyId: number, value: string | null}}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setOperatorConfigurationValue = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partnerConfigurationApisV2.setOperator,
            data: request,
            method: apiMethods.put,
        }));
    }

    /**
     * Gets the print application token.
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPrintApplicationToken = async () => {
        return await apiCallback(Api.prepareRequest({
            url: partnerConfigurationsApis.getPrintApplicationToken,
            method: apiMethods.get,
            showErrorToast: false,
        }));
    }


    // ####################################    WAREHOUSE APIS     ########################################

    /**
     * Get a list of warehouses for the partner
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getOperatorWarehouses = async (cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: warehouseApis.getAll,
            method: apiMethods.get,
            redirectToError: true,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Gets all partner warehouses from Spire (code and title; id when the backend provides it).
     * @param cancelToken
     * @return {Promise<ApiResponseDs<Array<{code: string, title: string, id?: number}> | null>|undefined>}
     */
    static readAllWarehouses = async (cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: warehouseV2Apis.readAll,
            method: apiMethods.get,
            redirectToError: false,
            cancelToken: cancelToken,
        }))
    }


    // ####################################    TRANSACTION CREDIT APIS     ########################################

    /**
     * Get a list of credits available for a specific customer
     * @param customerId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getAllAvailableCreditByCustomer = async (customerId) => {
        return await apiCallback(Api.prepareRequest({
            url: transactionCreditsApi.getAllAvailableCreditByCustomer(customerId),
            method: apiMethods.get,
        }))
    }

    /**
     * Get a list of all transactions that have been submitted for a specific order (quote, sales order, invoice)
     * @param orderId {number}
     * @param type {string}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getAllTransactionsDetailsOfOrder = async (orderId, type) => {
        return await apiCallback(Api.prepareRequest({
            url: transactionCreditsApi.getAllTransactionsDetailsOfOrder(orderId, type),
            method: apiMethods.get,
            showErrorToast: false,
        }))
    }

    // ####################################    DASHBOARD APIS     ########################################

    /**
     * Get a list of all operator groups in a partner with their assigned dashboards.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getAllOperatorGroupsWithAssignedDashboards = async () => {
        return await apiCallback(Api.prepareRequest({
            url: dashboardApis.getAllGroupsWithAssignedDashboards,
            method: apiMethods.get,
            redirectToError: true,
        }))
    }

    /**
     * Removes a specific dashboard from a specific operator record.
     * @param dashboardId {number}
     * @param operatorId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeDashboardFromOperatorGroup = async (dashboardId, operatorId) => {
        return await apiCallback(Api.prepareRequest({
            url: dashboardApis.removeDashboardFromGroup(dashboardId, operatorId),
            method: apiMethods.put,
        }))
    }

    /**
     * Adds a specific dashboard to a specific operator record.
     * @param dashboardId {number}
     * @param operatorId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addDashboardToOperatorGroup = async (dashboardId, operatorId) => {
        return await apiCallback(Api.prepareRequest({
            url: dashboardApis.addDashboardToGroup(dashboardId, operatorId),
            method: apiMethods.put,
        }))
    }

    /**
     * Get a list of available dashboards for the current operator
     *
     * @param {boolean} report whether to send the reports of the dashboards
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getAvailableDashboards = async (report = false) => {
        return await apiCallback(Api.prepareRequest({
            url: dashboardApis.getOperatorDashboards(report),
            method: apiMethods.get,
            redirectToError: true,
        }))
    }

    /**
     * Sets a specific dashboard as operators default dashboard.
     * @param dashboardId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setDashboardAsDefault = async (dashboardId) => {
        return await apiCallback(Api.prepareRequest({
            url: dashboardApis.setDefault(dashboardId),
            method: apiMethods.put,
            showErrorToast: false,
        }))
    }

    /**
     * Gets the list of public dashboards in the system
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPublicDashboards = async () => {
        return await apiCallback(Api.prepareRequest({
            url: dashboardApis.getPublicDashboards,
            method: apiMethods.get,
            showErrorToast: false,
        }));
    }

    /**
     * Gets the list of public reports in the system
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPublicReports = async () => {
        return await apiCallback(Api.prepareRequest({
            url: dashboardApis.getPublicReports,
            method: apiMethods.get,
            showErrorToast: false
        }))
    }

    // ####################################   ADDRESSES APIS     ########################################

    /**
     * Gets the list of all countries
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getAllCountries = async () => {
        return await apiCallback(Api.prepareRequest({
            url: addressesApis.getAllCountries,
            method: apiMethods.get,
            showErrorToast: false,
        }))
    }

    /**
     * Gets the list of all provinces by the given countryId
     *
     * @param countryId {number}
     * @param {import(axios).CancelToken | undefined} cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getAllProvincesByCountryId = async (countryId, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: addressesApis.getAllProvincesForCountry(countryId),
            method: apiMethods.get,
            showErrorToast: false,
            cancelToken: cancelToken,
        }))
    }


    // ####################################   BIZ LIVE APIS     ########################################


    /**
     * Fetches the number of unread messages that the current user has in their notification center.
     *
     * @param {Function | null} onErrorCallback a callback for 401 and 403 responses.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getUnreadNotificationCount = async (onErrorCallback = null) => {
        return await apiCallback(Api.prepareRequest({
            url: bizLiveApis.getUnreadCount,
            method: apiMethods.get,
            showErrorToast: false,
            loginRequired: false,
            unAuthorizedCallback: onErrorCallback,
            accessDeniedCallback: onErrorCallback,
        }))
    }

    /**
     * Fetches the notification of the user that are in their notification center.
     *
     * @param {any} request the pagination information of the request.
     * @param {Function | null} onErrorCallback a callback for 401 and 403 responses.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNotifications = async (request, onErrorCallback = null) => {
        return await apiCallback(Api.prepareRequest({
            url: bizLiveApis.getNotifications,
            method: apiMethods.post,
            data: request,
            loginRequired: false,
            showErrorToast: false,
            unAuthorizedCallback: onErrorCallback,
            accessDeniedCallback: onErrorCallback,
        }))
    }

    /**
     * Deactivates user's current firebase token.
     *
     * @param {Function | null} onErrorCallback a callback for 401 and 403 responses.
     * @param {boolean | null} loginRequired whether the request requires login or not.
     * @param {any} request the deactivation request info.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static deactivateFirebaseDevice = async (request, loginRequired, onErrorCallback = null) => {
        return await apiCallback(Api.prepareRequest({
            url: bizLiveApis.deactivateFirebaseDevice,
            data: request,
            method: apiMethods.post,
            loginRequired: loginRequired ?? false,
            showErrorToast: false,
            unAuthorizedCallback: onErrorCallback,
            accessDeniedCallback: onErrorCallback,
        }))
    }

    /**
     * Submits the user's current firebase token to the server for Notification integration.
     *
     * @param {Function | null} onErrorCallback a callback for 401 and 403 responses.
     * @param {any} request the submission request.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static submitFirebaseDevice = async (request, onErrorCallback = null) => {
        return await apiCallback(Api.prepareRequest({
            url: bizLiveApis.submitFirebaseDevice,
            data: request,
            method: apiMethods.post,
            loginRequired: false,
            showErrorToast: false,
            unAuthorizedCallback: onErrorCallback,
            accessDeniedCallback: onErrorCallback,
        }))
    }

    /**
     * Fetches the list of available notification types from the server.
     *
     * @param {Function | null} onErrorCallback a callback for 401 and 403 responses.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNotificationTypes = async (onErrorCallback = null) => {
        return await apiCallback(Api.prepareRequest({
            url: bizLiveApis.getNotificationTypes,
            method: apiMethods.get,
            showErrorToast: false,
            loginRequired: false,
            unAuthorizedCallback: onErrorCallback,
            accessDeniedCallback: onErrorCallback,
        }))
    }

    /**
     * Send a request that results in sending notification to the system.
     *
     * @param {Function | null} onErrorCallback a callback for 401 and 403 responses.
     * @param {any} request the notification info.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static sendNotification = async (request, onErrorCallback = null) => {
        return await apiCallback(Api.prepareRequest({
            url: bizLiveApis.sendNotification,
            data: request,
            method: apiMethods.post,
            showSuccessToast: true,
            loginRequired: false,
            unAuthorizedCallback: onErrorCallback,
            accessDeniedCallback: onErrorCallback,
        }))
    }

    /**
     * Searches between the received notifications of this partner with the given filters.
     *
     * * the keyword parameter would search : Data, Category, Description, Title.
     * * to search with categoryId, the front end should send isSearchWithCategory = true.
     * * categoryId is nullable and null means default saved messages .basically isSearchWithCategory = true searches
     * between saved messages
     *
     * @param {Function | null} onErrorCallback a callback for 401 and 403 responses.
     * @param {any} request contains paginationInfo and filters.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchReceivedNotifications = async (request, onErrorCallback = null) => {
        return await apiCallback(Api.prepareRequest({
            url: bizLiveApis.searchReceivedNotifications,
            data: request,
            method: apiMethods.post,
            showErrorToast: false,
            redirectToError: true,
            loginRequired: false,
            unAuthorizedCallback: onErrorCallback,
        }))
    }

    /**
     * Searches between the sent notifications of this partner with the given filters.
     *
     * @param {Function | null} onErrorCallback a callback for 401 and 403 responses.
     * @param {any} request contains paginationInfo and filters.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchSentNotifications = async (request, onErrorCallback = null) => {
        return await apiCallback(Api.prepareRequest({
            url: bizLiveApis.searchSentNotifications,
            data: request,
            method: apiMethods.post,
            loginRequired: false,
            unAuthorizedCallback: onErrorCallback,
            accessDeniedCallback: onErrorCallback,
        }))
    }

    /**
     * Toggles the specific notification read status in the system.
     *
     * @param {Function | null} onErrorCallback a callback for 401 and 403 responses.
     * @param {number} id id of the notification to be set as unread.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static toggleNotificationRaedStatus = async (id, onErrorCallback = null) => {
        return await apiCallback(Api.prepareRequest({
            url: bizLiveApis.toggleRaedStatus(id),
            method: apiMethods.put,
            loginRequired: false,
            unAuthorizedCallback: onErrorCallback,
            accessDeniedCallback: onErrorCallback,
        }))
    }

    /**
     * Marks all the un-read notification of the system as read.
     *
     * @param {Function | null} onErrorCallback a callback for 401 and 403 responses.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static markAllNotificationAsRead = async (onErrorCallback = null) => {
        return await apiCallback(Api.prepareRequest({
            url: bizLiveApis.markAllAsRead,
            method: apiMethods.put,
            loginRequired: false,
            unAuthorizedCallback: onErrorCallback,
            accessDeniedCallback: onErrorCallback,
        }))
    }

    /**
     * toggles the saved status of a specific notification.
     *
     * @param {Function | null} onErrorCallback a callback for 401 and 403 responses.
     * @param {number} id id of the notification to be set as unread.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static toggleNotificationSavedStatus = async (id, onErrorCallback = null) => {
        return await apiCallback(Api.prepareRequest({
            url: bizLiveApis.toggleSavedStatus(id),
            method: apiMethods.put,
            loginRequired: false,
            unAuthorizedCallback: onErrorCallback,
            accessDeniedCallback: onErrorCallback,
        }))
    }

    /**
     * Sets a user defined category for a specific notification
     *
     * @param {Function | null} onErrorCallback a callback for 401 and 403 responses.
     * @param {any} request the request for this api call.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setCategoryForNotification = async (request, onErrorCallback = null) => {
        return await apiCallback(Api.prepareRequest({
            url: bizLiveApis.setCategoryForNotification,
            method: apiMethods.put,
            data: request,
            loginRequired: false,
            unAuthorizedCallback: onErrorCallback,
            accessDeniedCallback: onErrorCallback,
        }))
    }

    /**
     * Fetches all of the user defined categories for the notifications.
     *
     * @param {Function | null} onErrorCallback a callback for 401 and 403 responses.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getAllNotificationCategories = async (onErrorCallback = null) => {
        return await apiCallback(Api.prepareRequest({
            url: bizLiveApis.getNotificationCategories,
            method: apiMethods.get,
            redirectToError: true,
            unAuthorizedCallback: onErrorCallback,
        }))
    }

    /**
     * Creates a user-defined notification category.
     *
     * @param {Function | null} onErrorCallback a callback for 401 and 403 responses.
     * @param {any} request the request for this api call.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createNotificationCategory = async (request, onErrorCallback = null) => {
        return await apiCallback(Api.prepareRequest({
            url: bizLiveApis.createNotificationCategory,
            method: apiMethods.post,
            data: request,
            unAuthorizedCallback: onErrorCallback,
        }))
    }

    /**
     * Updates a specific user-defined notification category.
     *
     * @param {Function | null} onErrorCallback a callback for 401 and 403 responses.
     * @param {any} request the request for this api call.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateNotificationCategory = async (request, onErrorCallback = null) => {
        return await apiCallback(Api.prepareRequest({
            url: bizLiveApis.updateNotificationCategory,
            method: apiMethods.put,
            data: request,
            unAuthorizedCallback: onErrorCallback,
        }))
    }

    /**
     * Updates the order of notification categories of the user.
     *
     * @param {Function | null} onErrorCallback a callback for 401 and 403 responses.
     * @param {any} request the request for this api call.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateNotificationCategoriesOrder = async (request, onErrorCallback = null) => {
        return await apiCallback(Api.prepareRequest({
            url: bizLiveApis.updateNotificationCategoriesOrder,
            method: apiMethods.put,
            data: request,
            unAuthorizedCallback: onErrorCallback,
        }))
    }

    /**
     * Removes a specific user-defined notification category.
     *
     * @param {Function | null} onErrorCallback a callback for 401 and 403 responses.
     * @param {any} id id of the notification to be removed
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeNotificationCategory = async (id, onErrorCallback = null) => {
        return await apiCallback(Api.prepareRequest({
            url: bizLiveApis.removeNotificationCategory(id),
            method: apiMethods.delete,
            unAuthorizedCallback: onErrorCallback,
        }))
    }

    // ####################################   PartSupportVendorsMsg APIS     ########################################

    /**
     * Fetches the list of vendor messages for the specific request.
     * @param requestId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getWarrantyAndReturnMessagesForVendor = async (requestId) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportVendorsMsgApis.getMessages(requestId),
            method: apiMethods.get,
        }))
    }


    /**
     * Resets the access link of an specific request for the vendor.
     *
     * @param requestId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static resetWarrantyAndReturnAccessLinkForVendor = async (requestId) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportVendorsMsgApis.resetVendorChatAccessLink(requestId),
            method: apiMethods.put,
        }))
    }

    /**
     * Forwards a message from the chat of operator's and its user to the chat of operator and the assigned vendor
     *
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static forwardUserChatMessage = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportVendorsMsgApis.forwardUserChatMessage,
            method: apiMethods.post,
            data: request,
        }))
    }


    /**
     * Sends a new message for a specific warranty and return request.
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static sendWarrantyAndReturnMessageToVendor = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportVendorsMsgApis.sendMessage,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Removes a message in a specific warranty and return request.
     * @param messageId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeWarrantyAndReturnMessageFromVendor = async (messageId) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportVendorsMsgApis.deleteMessage(messageId),
            method: apiMethods.delete,
        }))
    }

    // ####################################   Vendors APIS     ########################################

    /**
     * searches through the list of vendors with the provided information
     * @param request {any}
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchVendors = async (request, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorsApis.search,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Fetches the specific vendor by its code. Returns null if it does not exist.
     * @param vendorCode {string}
     * @param showErrorToast {boolean} whether to show error toast in case the vendor is not found. default is true.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getVendorInformation = async (vendorCode, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorsApis.getVendorInformation(vendorCode),
            method: apiMethods.get,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Fetches the list of vendors that sell the specific part and returns them.
     * @param partNo {string}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getVendorSuggestions = async (partNo) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorsApis.getVendorSuggestions(partNo),
            method: apiMethods.get,
        }))
    }

    /**
     * Creates an online profle for the vendor.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createVendorOnlineProfile = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorsApis.createOnlineProfile,
            method: apiMethods.post,
            data: data,
        }))
    }

    // ####################################   CMS APIS     ########################################

    /**
     * Fetches the list of cms categories provided the category type.
     *
     * @param {string} type
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getCmsCategoriesByType = async (type) => {
        return await apiCallback(Api.prepareRequest({
            url: cmsApis.getCategoriesByType(type),
            method: apiMethods.get,
        }))
    }

    /**
     * Searches in the blogs of the cms system based on the provided filters
     *
     * @param {any} request
     * @param {import(axios).CancelToken} cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchBlogs = async (request, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: cmsApis.searchBlogs,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Searches in the videos of the cms system based on the provided filters
     *
     * @param {any} request
     * @param {import(axios).CancelToken} cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchVideos = async (request, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: cmsApis.searchVideos,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Fetches the information of a specific blog provided its slug.
     *
     * @param {string} slug
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getBlogBySlug = async (slug) => {
        return await apiCallback(Api.prepareRequest({
            url: cmsApis.getBlogBySlug(slug),
            method: apiMethods.get,
            redirectToError: true,
        }))
    }

    /**
     * Fetches the information of a specific video provided its slug.
     *
     * @param {string} slug
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getVideoBySlug = async (slug) => {
        return await apiCallback(Api.prepareRequest({
            url: cmsApis.getVideoBySlug(slug),
            method: apiMethods.get,
            redirectToError: true,
        }))
    }

    // ####################################   CMS APIS     ########################################

    /**
     * Fetches the information of operators sales person profile
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getSalesPersonProfile = async () => {
        return await apiCallback(Api.prepareRequest({
            url: salesPersonApis.getProfile,
            method: apiMethods.get,
        }))
    }

    /**
     * Creates the sales person profile for an operator
     *
     * @param {any} request the sales person info
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createSalesPersonProfile = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: salesPersonApis.getProfile,
            method: apiMethods.post,
            data: request,
            showSuccessToast: true,
        }))
    }


    // ####################################   VERSION HISTORY APIS     ########################################

    /**
     * Fetches the version history of the application
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getVersionHistory = async () => {
        return await apiCallback(Api.prepareRequest({
            url: versionHistoryApis.get,
            method: apiMethods.get,
            checkResult: false,
            loginRequired: false,
            showErrorToast: false,
        }))
    }

    /**
     * Fetches the latest version history information of all the applications in the system.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getLatestApplicationsVersion = async () => {
        return await apiCallback(Api.prepareRequest({
            url: versionHistoryApis.getLatest,
            method: apiMethods.get,
        }))
    }

    /**
     * Reads the latest version history information of all the applications in the system.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static readLatestApplicationsVersion = async () => {
        return await apiCallback(Api.prepareRequest({
            url: versionHistoryApis.readLatest,
            method: apiMethods.post,
        }))
    }

    // ####################################   PART SUPPORT UPLOADS APIS     ########################################

    /**
     * Fetches the list of support template files.
     *
     * @param {number} requestId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartSupportTemplateFiles = async (requestId) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqUploadFilesApis.getTemplateFiles(requestId),
            method: apiMethods.get,
        }))
    }

    /**
     * Uploads a new template for a particular part support request
     *
     * @param {any} request
     * @param {Function} onUploadProgress
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static uploadPartSupportTemplate = async (request, onUploadProgress) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqUploadFilesApis.upload,
            method: apiMethods.post,
            data: request,
            onUploadProgress: onUploadProgress,
        }))
    }

    /**
     * Removes a template content for a particular part support request
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removePartSupportTemplate = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqUploadFilesApis.remove,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Submits the templates for a particular part support request
     *
     * @param {number} requestId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static submitPartSupportTemplates = async (requestId) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqUploadFilesApis.submitTemplate(requestId),
            method: apiMethods.post,
        }))
    }

    // ####################################   USER ORDER NOTES APIS     ########################################

    /**
     * Fetches the list of all order notes for a particular order.
     *
     * @param {string} orderNumber
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getOrderNotes = async (orderNumber) => {
        return await apiCallback(Api.prepareRequest({
            url: orderNotesApis.getAll(orderNumber),
            method: apiMethods.get,
        }))
    }

    /**
     * Fetches the list of all order note types in the system.
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getOrderNoteTypes = async () => {
        return await apiCallback(Api.prepareRequest({
            url: orderNotesApis.getTypes,
            method: apiMethods.get,
        }))
    }

    /**
     * Fetches the list of all order note print places in the system.
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getOrderNotePrintPlaces = async () => {
        return await apiCallback(Api.prepareRequest({
            url: orderNotesApis.getPrintPlaces,
            method: apiMethods.get,
        }))
    }

    /**
     * Creates a new order note for an order.
     *
     * @param {any} request the note to be created
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createOrderNote = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: orderNotesApis.create,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Updates an existing order note for an order.
     *
     * @param {any} request the note to be created
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateOrderNote = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: orderNotesApis.update,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Updates an existing order note for an order.
     *
     * @param {number} noteId the id of the note to be removed.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeOrderNote = async (noteId) => {
        return await apiCallback(Api.prepareRequest({
            url: orderNotesApis.remove(noteId),
            method: apiMethods.delete,
        }))
    }

    // ####################################   PART SUPPORT STATUSES APIS     ########################################

    /**
     * Get all the statuses and reasons for edit purposes.
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartSupportStatusesAndReasonsForEdit = async () => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportRequestStatusesApis.getAll,
            method: apiMethods.get,
            redirectToError: true,
        }))
    }

    /**
     * Updates a part support status information
     *
     * @param {any} request reason to be created
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updatePartSupportStatus = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportRequestStatusesApis.updateStatus,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Creates a part support status
     *
     * @param {any} request reason to be created
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createPartSupportStatus = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportRequestStatusesApis.createStatus,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Updates a part support reason
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updatePartSupportReason = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportRequestStatusesApis.updateReason,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Creates a part support reason
     *
     * @param {any} request reason to be created
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createPartSupportReason = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportRequestStatusesApis.createReason,
            method: apiMethods.post,
            data: request,
        }))
    }

    // ####################################   Operator User Events Subscriptions APIS   ########################################

    /**
     * Fetches the list of all available operator subscriptions from the server.
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static geAllAvailableOperatorSubscriptionChannels = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorChannelSubscriptionApis.getAllAvailableChannels,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Fetches the list of all available operator subscriptions along with the currently susbscribed channels from the
     * server.
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getOperatorSubscriptionChannelPageData = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorChannelSubscriptionApis.getOperatorChannelsSubscriptionPageData,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Subscribes the current operator to the provided user event
     *
     * @param {any} request the request for the subscription operation
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static subscribeToNotificationChannel = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorChannelSubscriptionApis.subscribe,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Un-Subscribes the current operator to the provided user event
     *
     * @param {any} request the request for the subscription operation
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static unSubscribeFromNotificationChannel = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorChannelSubscriptionApis.unsubscribe,
            method: apiMethods.post,
            data: request,
        }))
    }

    // ####################################   NOTIFICATION CHANNEL APIS   ########################################

    /**
     * Fetches the list of all available notification channels from the server.
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getAllNotificationChannels = async () => {
        return await apiCallback(Api.prepareRequest({
            url: notificationChannelApis.getAllChannelsEditPageData,
            method: apiMethods.get,
            redirectToError: true,
        }))
    }

    /**
     * Adds an operator group to the specific notification channel.
     *
     * @param {any} request the request for the api call.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addGroupToNotificationChannel = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: notificationChannelApis.addNewGroupToChannel,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Removes an operator group from the specific notification channel.
     *
     * @param {any} request the request for the api call.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeGroupFromNotificationChannel = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: notificationChannelApis.removeGroupFromChannel,
            method: apiMethods.put,
            data: request,
        }))
    }

    // #################################### PART SUPPORT REQ FILE TEMPLATE APIS ########################################

    /**
     * Creates a new part support file template.
     *
     * @param {any} request the request for the creation of the template
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createPartSupportRequestFileTemplate = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqFileTemplateApis.create,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Edits a part support file template.
     *
     * @param {any} request the request for the updating the template
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static editPartSupportRequestFileTemplate = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqFileTemplateApis.edit,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Remove a part support file template.
     *
     * @param {number} id the id of the part support file template
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removePartSupportRequestFileTemplate = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqFileTemplateApis.remove(id),
            method: apiMethods.delete,
        }))
    }

    // #################################### PART SUPPORT REQ Applicability APIS ########################################

    /**
     * Creates a new part support Applicability.
     *
     * @param {any} request the request for the creation of the Applicability
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createPartSupportRequestApplicability = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqApplicabilityApis.create,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Edits a part support Applicability.
     *
     * @param {any} request the request for the updating the Applicability
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static editPartSupportRequestApplicability = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqApplicabilityApis.edit,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Remove a part support Applicability.
     *
     * @param {number} id the id of the part support Applicability
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removePartSupportRequestApplicability = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqApplicabilityApis.remove(id),
            method: apiMethods.delete,
        }))
    }

    // #################################### PART SUPPORT REQ EXTRA FEES APIS ########################################

    /**
     * Creates a new part support ExtraFees.
     *
     * @param {any} request the request for the creation of the ExtraFees
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createPartSupportRequestExtraFees = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqExtraFeesApis.create,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Edits a part support ExtraFees.
     *
     * @param {any} request the request for the updating the ExtraFees
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static editPartSupportRequestExtraFees = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqExtraFeesApis.edit,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Remove a part support ExtraFees.
     *
     * @param {number} id the id of the part support ExtraFees
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removePartSupportRequestExtraFees = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqExtraFeesApis.remove(id),
            method: apiMethods.delete,
        }))
    }

    // #################################### PART SUPPORT REQ EXTRA FEES APIS ########################################

    /**
     * Fetches all the support Extra Fees Titles.
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartSupportRequestExtraFeesTitles = async () => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqExtraFeesTitleApis.get,
            method: apiMethods.get,
        }))
    }

    /**
     * Creates a new part support Extra Fee Title.
     *
     * @param {any} request the request for the creation of the ExtraFeesTitle
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createPartSupportRequestExtraFeesTitle = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqExtraFeesTitleApis.create,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Edits a part support Extra Fee Title.
     *
     * @param {any} request the request for the updating the ExtraFeesTitle
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static editPartSupportRequestExtraFeesTitle = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqExtraFeesTitleApis.edit,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Remove a part support ExtraFeesTitle.
     *
     * @param {number} id the id of the part support ExtraFeesTitle
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removePartSupportRequestExtraFeesTitle = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqExtraFeesTitleApis.remove(id),
            method: apiMethods.delete,
        }))
    }

    // #################################### OPERATOR PARTS APIS ########################################

    /**
     * Fetches the full information of a part for editing purposes.
     *
     * @param {number} id the id of the part to be fetched.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getOperatorPartFullInfo = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartApis.getPartFullInfo(id),
            method: apiMethods.get,
            redirectToError: true,
        }))
    }

    /**
     * Updates a part's upc number.
     *
     * @param {any} request the new upc info
     * @param {boolean} showToast indicating whether to show the toast
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateOperatorPartUPC = async (request, showToast = false) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartApis.updateUPC,
            method: apiMethods.put,
            data: request,
            showErrorToast: showToast,
            showSuccessToast: showToast,
        }))
    }

    /**
     * Updates a part's category.
     *
     * @param {any} request the new category info
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateOperatorPartCategory = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartApis.updateCategory,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Adds or edits a part's full description.
     *
     * @param {any} request the new description of the part.
     * @param {boolean} showToast indicator for showing the error toast
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static upsertOperatorPartDescription = async (request, showToast = false) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartApis.updateOrAddFullDescription,
            method: apiMethods.put,
            data: request,
            showErrorToast: showToast,
        }))
    }

    /**
     * Adds or edits a part's full description.
     *
     * @param {any} request the new description of the part.
     * @param {boolean} showToast indicator for showing the error toast
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateOperatorPartShortDescription = async (request, showToast = false) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartApis.updateShortDescription,
            method: apiMethods.put,
            data: request,
            showErrorToast: showToast,
        }))
    }

    // #################################### OPERATOR PART APPLICATION APIS ########################################

    /**
     * suggests a new application record to the system
     *
     * @param {object} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static suggestApplicationRecordForPart = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartApplicationSuggestion.suggestNewApplication,
            method: apiMethods.post,
            data: request,
            showSuccessToast: true
        }))
    }


    // #################################### OPERATOR PART NOTE APIS ########################################

    /**
     * Fetches the notes of a specific user defined part in the system.
     *
     * @param {number} id the id of the specific part.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getOperatorPartNotes = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartNoteApis.getByPartId(id),
            method: apiMethods.get,
            redirectToError: true,
        }))
    }

    /**
     * Creates a new note for a specific user defined part.
     *
     * @param {any} request the new note to be created.
     * @param {any} showErrorToast
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createOperatorPartNote = async (request, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartNoteApis.create,
            method: apiMethods.post,
            data: request,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Updates an existing note for a specific user defined part.
     *
     * @param {any} request the note to be updated.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateOperatorPartNote = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartNoteApis.edit,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Removes an existing Note for a specific user defined part.
     *
     * @param {number} id id of the Note to be removed.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeOperatorPartNote = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartNoteApis.remove(id),
            method: apiMethods.delete,
        }))
    }

    // #################################### OPERATOR PART IMAGE APIS ########################################

    /**
     * Fetches the images of a specific user defined part in the system.
     *
     * @param {number} id the id of the specific part.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getOperatorPartImages = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartImageApis.getByPartId(id),
            method: apiMethods.get,
            redirectToError: true,
        }))
    }

    /**
     * Creates a new Image for a specific user defined part.
     *
     * @param {any} request the new Image to be created.
     * @param {Function} onUploadProgress
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createOperatorPartImage = async (request, onUploadProgress) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartImageApis.create,
            method: apiMethods.post,
            data: request,
            onUploadProgress: onUploadProgress,
        }))
    }

    /**
     * Updates an existing image for a specific user defined part.
     *
     * @param {any} request the image to be updated.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateOperatorPartImagesOrder = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartImageApis.updateImagesOrder,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Sets an existing image for a specific user defined part as its default image.
     *
     * @param {number} id id of the image to be set as default
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setOperatorPartImageAsDefault = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartImageApis.setDefaultCoverImage(id),
            method: apiMethods.put,
        }))
    }

    /**
     * Removes an existing image for a specific user defined part.
     *
     * @param {number} id id of the image to be removed.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeOperatorPartImage = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartImageApis.remove(id),
            method: apiMethods.delete,
        }))
    }

    // #################################### OPERATOR PART TECHNICAL FILE APIS ########################################

    /**
     * Fetches the technical files of a specific user defined part in the system.
     *
     * @param {number} id the id of the specific part.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getOperatorPartTechnicalFiles = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartTechnicalFileApis.getByPartId(id),
            method: apiMethods.get,
            redirectToError: true,
        }))
    }

    /**
     * Fetches the technical file history of a specific technical file in the system.
     *
     * @param {string} id the id of the technical file
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getOperatorPartTechnicalFileHistory = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartTechnicalFileApis.getHistoryById(id),
            method: apiMethods.get,
        }))
    }

    /**
     * Removes the last version of a specific technical file beloning to a spsecific user defined part.
     *
     * @param {string} id the id of the technical file
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeOperatorPartTechnicalFileCurrentVersion = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartTechnicalFileApis.removeLastVersion(id),
            method: apiMethods.put,
        }))
    }

    /**
     * Removes the last version of a specific technical file beloning to a spsecific user defined part.
     *
     * @param {string} id the id of the technical file
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeOperatorPartTechnicalFile = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartTechnicalFileApis.remove(id),
            method: apiMethods.put,
        }))
    }

    /**
     * Creates a new technical file for a specific user defined part.
     *
     * @param {any} request the new technical file information
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createOperatorPartTechnicalFile = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartTechnicalFileApis.create,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Uploads a new technical file version for a specific technical file.
     *
     * @param {any} request the new technical file version information
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static uploadOperatorPartTechnicalFileVersion = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartTechnicalFileApis.uploadNewVersion,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Updates the information of an existing technical file for a specific user defined part.
     *
     * @param {any} request the updated technical file information
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateOperatorPartTechnicalFile = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartTechnicalFileApis.updateDocumentInfo,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Sets the selected technical file version to the current version of the technical file document.
     *
     * @param {any} request the information of the selected version and its document.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setOperatorPartTechnicalFileVersionToCurrentVersion = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartTechnicalFileApis.setVersionToCurrentVersion,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Searches for the assigned parts of a particular technical file.
     *
     * @param {any} request the filters and pagination info of the search.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchOperatorPartTechnicalFileAssignedParts = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartTechnicalFileApis.searchAssignedParts,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Assigns a selected list of parts to the selected technical file in the system.
     *
     * @param {any} request the assignment information.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static assignPartsToOperatorPartTechnicalFile = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartTechnicalFileApis.assignPartsToDocument,
            method: apiMethods.put,
            data: request,
        }))
    }


    // #################################### OPERATOR PART PRICE APIS ############################################

    /**
     * Gets the list of live price levels
     *
     * @param {number} request
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartLivePriceLevels = async (request, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartPrice.getLivePriceLevels(request),
            method: apiMethods.get,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Gets the list of previous price levels
     *
     * @param {number} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getListOfPreviousPriceLevels = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartPrice.getListOfPreviousPriceLevels(request),
            method: apiMethods.get,
        }))
    }

    /**
     * Gets the details of a price change log
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPreviousPriceLevelFullDetails = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartPrice.getPreviousPriceLevelFullDetails,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Updates a price level price for a part
     *
     * @param {object} request
     * @param {boolean?} showErrorToast
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updatePartPriceLevel = async (request, showErrorToast = false) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartPrice.updatePartPrice,
            method: apiMethods.put,
            data: request,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Gets all logged price levels and live price level based on the given filters
     *
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static generateReportOfPartPriceLevels = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartPrice.generateReportOfPartPriceLevels,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Gets all logged price levels and live price level based on the given filters
     *
     * @param request
     * @param showErrorToast
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setProductMultiplePriceLevelPrices = async (request, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartPrice.setPrice,
            method: apiMethods.post,
            data: request,
            showErrorToast: showErrorToast,
        }))
    }


    // #################################### OPERATOR PART FEEDBACKS APIS ########################################

    /**
     * Fetches the feedbacks of a specific user defined part in the system.
     *
     * @param {number} id the id of the specific part.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getOperatorPartFeedbacks = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartFeedbackApis.getByPartId(id),
            method: apiMethods.get,
            redirectToError: true,
        }))
    }

    /**
     * Removes an existing part feedback for a specific user defined part.
     *
     * @param {number} id id of the part feedback to be removed.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeOperatorPartFeedback = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartFeedbackApis.remove(id),
            method: apiMethods.delete,
        }))
    }

    // #################################### OPERATOR PART RELATION APIS ########################################

    /**
     * Fetches the relations of a specific user defined part in the system.
     *
     * @param {number} id the id of the specific part.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getOperatorPartRelations = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartRelationApis.getByPartId(id),
            method: apiMethods.get,
            redirectToError: true,
        }))
    }

    /**
     * Fetches all the different relation types that can be applied to between two parts in the system.
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getAllOperatorPartRelationTypes = async () => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartRelationApis.getAllRelationTypes,
            method: apiMethods.get,
        }))
    }

    /**
     * Create a new relation between two parts in the system.
     *
     * @param {any} request the new relation to be created.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createOperatorPartRelation = async (request, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartRelationApis.create,
            method: apiMethods.post,
            data: request,
            showErrorToast,
        }))
    }

    /**
     * Removes a relation between two parts in the system.
     *
     * @param {any} request the relation that needs to be removed.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removesOperatorPartRelation = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartRelationApis.remove,
            method: apiMethods.put,
            data: request,
        }))
    }

    // #################################### Part Relation Types ########################################


    /**
     * Fetches all the relation types for products in the system from server
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getAllPartRelationTypes = async () => {
        return await apiCallback(Api.prepareRequest({
            url: partRelationTypes.baseUrl,
            method: apiMethods.get,
            showErrorToast: false,
        }))
    }

    /**
     * Adds a new relation type for products in the system
     *
     * @param request object containing the title of the relation
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addNewPartRelationType = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partRelationTypes.baseUrl,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Updates the part relation type title in the server
     *
     * @param request object containing the title and id of the relation type
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updatePartRelationType = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partRelationTypes.baseUrl,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Deletes the part relation type from server
     *
     * @param {number} request id of the relation type
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static deletePartRelationType = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partRelationTypes.deletePartRelationType(request),
            method: apiMethods.delete,
        }))
    }


    // #################################### OPERATOR PART TAG APIS ########################################

    /**
     * Adds a new tag to a specific user defined part.
     *
     * @param {any} request the new tag to be added.
     * @param {any} showErrorToast
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addTagToOperatorPart = async (request, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartTagApis.addNewToPart,
            method: apiMethods.post,
            data: request,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Removes an existing from a specific user defined part.
     *
     * @param {any} request the tag and part information needed for removal.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeTagFromOperatorPart = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartTagApis.removeFromPart,
            method: apiMethods.put,
            data: request,
        }))
    }

    // ############################### PART FORM APIS ###############################

    /**
     * Lists forms associated with a part.
     * @param {number} partId
     * @return {Promise<ApiResponseDs<import('./type-declerations/response').PartFormEntryDs[]|null>|undefined>}
     */
    static listPartForms = async (partId) => {
        return await apiCallback(Api.prepareRequest({
            url: partFormApis.list(partId),
            method: apiMethods.get,
        }))
    }

    /**
     * Associates a form with a part.
     * @param {{partId: number, formId: string, isRequired: boolean}} request
     * @param showErrorToast
     * @return {Promise<ApiResponseDs<import('./type-declerations/response').PartFormMutationResultDs|null>|undefined>}
     */
    static addPartForm = async (request, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: partFormApis.add,
            method: apiMethods.post,
            data: request,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Updates a part-form association (e.g. required flag).
     * @param {{id: number, isRequired: boolean}} request
     * @return {Promise<ApiResponseDs<import('./type-declerations/response').PartFormMutationResultDs|null>|undefined>}
     */
    static updatePartForm = async (request, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: partFormApis.update,
            method: apiMethods.put,
            data: request,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Removes a form association from a part.
     * @param {number} partFormId
     * @return {Promise<ApiResponseDs<void|null>|undefined>}
     */
    static deletePartForm = async (partFormId) => {
        return await apiCallback(Api.prepareRequest({
            url: partFormApis.delete(partFormId),
            method: apiMethods.delete,
        }))
    }

    // ############################### OPERATOR PART TECHNICAL FILE SHARE LINK APIS ###############################

    /**
     * Fetches all the existing share link related to a specific technical file.
     *
     * @param {string} id id of the technical file
     * @param {string} partNo
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getOperatorPartTechnicalFileShareLinks = async (id, partNo) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartTechnicalFileShareLink.getAllByDocument(id, partNo),
            method: apiMethods.get,
        }))
    }

    /**
     * Create a new share link for a technical file of a user defined part.
     *
     * @param {any} request the new share link to be created.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createOperatorPartTechnicalFileShareLink = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartTechnicalFileShareLink.create,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Removes an existing share link of a technical file of a user defined part.
     *
     * @param {number} id the id of the share link.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeOperatorPartTechnicalFileShareLink = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartTechnicalFileShareLink.remove(id),
            method: apiMethods.delete,
        }))
    }

    // ############################### OPERATOR PART File APIS ###############################


    /**
     * Updates the title of a technical file shared link
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateTechnicalFileShareLinkTitle = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partFileApis.updateTechnicalFileShareLinkTitle,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Un Assigns parts and category from a technical file in the server
     *
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static unAssignItemsFromTechnicalFile = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partFileApis.unAssignItemsFromTechnicalFile,
            method: apiMethods.post,
            data: request,
        }))
    }

    // ############################### BUDGET APIS ###############################

    /**
     * Fetches all the active coupons of the system.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getActiveCoupons = async () => {
        return await apiCallback(Api.prepareRequest({
            url: budgetApis.getAllActives,
            method: apiMethods.get,
        }))
    }

    /**
     * Fetches all the history of a particular budget.
     *
     * @param {object} data
     * @param {any} cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getBudgetHistory = async (data, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: budgetApis.getBudgetHistory,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Creates a new budget in the system.
     *
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createBudget = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: budgetApis.create,
            data: data,
            method: apiMethods.post,
        }))
    }

    /**
     * Updates an existing budget in the system.
     *
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateBudget = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: budgetApis.update,
            data: data,
            method: apiMethods.put,
        }))
    }

    /**
     * Removes an existing budget in the system.
     *
     * @param {number} id
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeBudget = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: budgetApis.remove(id),
            method: apiMethods.delete,
        }))
    }

    /**
     * Redeems a budget existing budget in the system.
     *
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static redeemCoupon = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: budgetApis.redeem,
            data: data,
            method: apiMethods.post,
        }))
    }

    /**
     * Gets user redeem history from server
     *
     * @param cancelToken
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getUserRedeemHistory = async (data, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: budgetApis.getUserRedeemHistory,
            data: data,
            method: apiMethods.post,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Gets promo code validation from server
     * @param {string} code
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static validatePromoCode = async (code) => {
        return await apiCallback(Api.prepareRequest({
            url: budgetApis.validatePromoCode(code),
            method: apiMethods.get,
            showErrorToast: false,
        }))
    }

    // ########################################     USER PAYMENTS APIS     ########################################

    /**
     * Fetches the list of available paymaster methods for otherPayment type.
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getAllOtherPaymentMethods = async () => {
        return await apiCallback(Api.prepareRequest({
            url: userPaymentsApis.getAllAvailablePaymentMethods,
            method: apiMethods.get,
        }))
    }

    // ########################################     PARTNER APIS     ########################################

    /**
     * Fetches the information of the current partner that the operator (user) belongs to.
     *
     * @param {Function | null} getHeaders
     * @param {CancelToken | undefined} cancelToken
     * @param {boolean} bypassAuthCheck
     * @param {unknown} logger
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartnerInformation = async (getHeaders = null, cancelToken = null, bypassAuthCheck = false, logger = null) => {
        return await apiCallback(Api.prepareRequest({
            url: partnerApis.getInformation,
            method: apiMethods.get,
            showErrorToast: false,
            getHeaders: getHeaders,
            cancelToken: cancelToken,
            logger: logger,
            loginRequired: !bypassAuthCheck,
        }))
    }

    /**
     * Fetches the price levels of the current partner that the operator (user) belongs to.
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartnerPriceLevels = async () => {
        return await apiCallback(Api.prepareRequest({
            url: partnerApis.getPriceLevels,
            method: apiMethods.get,
            redirectToError: true,
        }))
    }

    /**
     * Updates the sales regulation of the current partner that the operator (user) belongs to.
     *
     * @param {any} request the new sales regulation information
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateSalesRegulation = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partnerApis.updateSalesRegulation,
            method: apiMethods.put,
            data: request,
        }));
    }

    /**
     * Sets the operation hours of the current partner that the operator (user) belongs to.
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setPartnerOperationHours = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partnerApis.setPartnerOperationHours,
            method: apiMethods.put,
            data: request,
        }));
    }

    /**
     * Gets the operation hours of the current partner that the operator (user) belongs to.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartnerOperationHours = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partnerApis.getPartnerOperationHours,
            method: apiMethods.post,
            data: request,
        }));
    }

    /**
     * Gets the operation hours of the current partner that the operator (user) belongs to.
     *
     * @param {any} id
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removePartnerOperationHours = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: partnerApis.removePartnerOperationHours(id),
            method: apiMethods.delete,
        }));
    }

    /**
     * Fetches the Spire connection credentials of the current partner.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getSpireConnection = async () => {
        return await apiCallback(Api.prepareRequest({
            url: partnerApis.getSpireConnection,
            method: apiMethods.get,
        }));
    }

    /**
     * Updates the Spire connection credentials of the current partner.
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateSpireConnection = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: partnerApis.updateSpireConnection,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Adds a anew partner to the system with the provided information.
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addNewPartner = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: partnerApis.addNewPartner,
            method: apiMethods.post,
            data: data,
            enforceAuth: false,
        }));
    }

    /**
     * Fetches the partner setup checklist information for the current partner in the system.
     *
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartnerSetupCheckList = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: partnerApis.getPartnerSetupCheckList,
            method: apiMethods.post,
            data: data,
            enforceAuth: false,
        }));
    }

    /**
     * Updates the partner color
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static updatePartnerColor = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: partnerApis.updatePartnerColor,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Updates the basic information.
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     * @param data
     */
    static updatePartnerBasicInfo = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: partnerApis.updatePartnerBasicInfo,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Fetches the retail user information of the current partner in the system.
     * @param {{showErrorToast?: boolean}} [options]
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartnerRetailUser = async (options = {}) => {
        return await apiCallback(Api.prepareRequest({
            url: partnerApis.getPartnerRetailUser,
            method: apiMethods.get,
            showErrorToast: options.showErrorToast,
        }));
    }

    /**
     * Updates the retail user information of the current partner in the system.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updatePartnerRetailUser = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: partnerApis.updatePartnerRetailUser,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Fetches the partner-level default sales person, territory, and related new-customer properties.
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartnersSalesPersonAndTerritory = async () => {
        return await apiCallback(Api.prepareRequest({
            url: partnerApis.getPartnersSalesPersonAndTerritory,
            method: apiMethods.get,
        }));
    }

    /**
     * Updates the partner-level default sales person, territory, and related new-customer properties.
     * @param {{salesPersonOperatorId: string, territoryCode: string, priceLevelId: number, creditLimit: number, paymentTerms: string}} data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updatePartnersSalesPersonAndTerritory = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: partnerApis.updatePartnersSalesPersonAndTerritory,
            method: apiMethods.put,
            data: data,
        }));
    }


    // #################################### ADMIN FILE UPLOADER APIS ########################################

    /**
     * Uploads a file to the admin server.
     *
     * @param {Function} onUploadProgress
     * @param {FormData} file
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static uploadFileToAdmin = async (file, onUploadProgress = null) => {
        return await apiCallback(Api.prepareRequest({
            url: adminFileUploaderApis.uploadFile,
            method: apiMethods.post,
            data: file,
            onUploadProgress: onUploadProgress,
        }))
    }

    // #################################### QUOTE BYPASS APIS ########################################

    /**
     * Fetches the information record of a quote bypass.
     *
     * @param {number} orderId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getQuoteBypassInformation = async (orderId) => {
        return await apiCallback(Api.prepareRequest({
            url: quoteBypassApis.get(orderId),
            method: apiMethods.get,
            showErrorToast: false,
        }))
    }

    /**
     * Submits a quote bypass record for the given quote.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static submitQuoteBypass = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: quoteBypassApis.create,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Removes a quote bypass record from its attached order.
     *
     * @param {number} bypassId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeQuoteBypass = async (bypassId) => {
        return await apiCallback(Api.prepareRequest({
            url: quoteBypassApis.remove(bypassId),
            method: apiMethods.delete,
        }))
    }

    // #################################### QUOTE BYPASS REASON APIS ########################################

    /**
     * Fetches the list of quote bypass reasons available in the server.
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getQuoteBypassReasons = async () => {
        return await apiCallback(Api.prepareRequest({
            url: quoteBypassReasonApis.getAll,
            method: apiMethods.get,
        }))
    }

    /**
     * Creates a new quote bypass reason.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createQuoteBypassReason = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: quoteBypassReasonApis.create,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Updates an existing quote bypass reason's information.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateQuoteBypassReason = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: quoteBypassReasonApis.update,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Removes a quote bypass reason.
     *
     * @param {number} reasonId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeQuoteBypassReason = async (reasonId) => {
        return await apiCallback(Api.prepareRequest({
            url: quoteBypassReasonApis.remove(reasonId),
            method: apiMethods.delete,
        }))
    }

    // #################################### QUOTE BYPASS RULE APIS ########################################

    /**
     * Fetches the information record of a quote bypass rule for the provided customer.
     *
     * @param {number} customerId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getQuoteBypassRuleInfoForCustomer = async (customerId) => {
        return await apiCallback(Api.prepareRequest({
            url: quoteBypassRuleApis.get(customerId),
            method: apiMethods.get,
        }))
    }

    /**
     * Saves a quote bypass rule for the provided customer.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static saveQuoteBypassRuleForCustomer = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: quoteBypassRuleApis.saveNewRule,
            method: apiMethods.post,
            data: request,
        }))
    }

    // #################################### ERROR HANDLING APIS ########################################

    /**
     * Submits an error handling ticket in the system.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static submitErrorHandlingTicket = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: errorHandlingApis.reportError,
            method: apiMethods.post,
            data: request,
            showErrorToast: false,
        }))
    }

    // #################################### USER HOMEPAGE APIS ########################################

    /**
     * Fetches the live homepage information of a given user for the operator.
     *
     * @param {any} request
     * @param {import('axios').CancelToken} cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getLiveUserHomepageData = async (request, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: userHomepageApis.getLiveMainPage,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }))
    }

    // #################################### TAGS APIS ########################################

    /**
     * Creates a new tag in the system.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createNewTag = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: tagApis.createTag,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Deletes the tags from the system
     *
     * @param {any} request list of tag ids
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static deleteTagsFromSystem = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: tagApis.deleteTagsFromSystem,
            method: apiMethods.delete,
            data: request,
        }))
    }

    /**
     * Updates a tag information
     *
     * @param {any} request
     * @param {Function} onUploadProgress
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateTagInformation = async (request, onUploadProgress = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: tagApis.updateTagInformation,
            method: apiMethods.put,
            data: request,
            onUploadProgress: onUploadProgress,
        }))
    }

    /**
     * Fetches the list of tags in the system associated with the given tabIds.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getTagsListByIds = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: tagApis.getByIds,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Fetches the list of tags associated with the given keywords.
     *
     * @param {string} keywords
     * @param {string} industryId
     * @param {import('axios').CancelToken} cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getTagsAutocomplete = async (keywords, industryId, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: tagApis.autoFill(keywords, industryId),
            method: apiMethods.get,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Searches through the tags of the system with the given filters and pagination info.
     *
     * @param cancelToken
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchTags = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: tagApis.search,
            method: apiMethods.post,
            data: request,
            redirectToError: true,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Fetches the full information of a tag
     *
     * @param {number} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getTagFullInformation = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: tagApis.getTagFullInformation(request),
            method: apiMethods.get,
            redirectToError: true,
        }))
    }

    /**
     * Fetches connected parts to a tag
     *
     * @param cancelToken
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getTagConnectedParts = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: tagApis.getTagConnectedParts,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Deletes tag banner connection
     *
     * @param {any} request tab-banner connection id
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static deleteTagBannerConnection = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: tagApis.deleteTagFromBanner(request),
            method: apiMethods.delete,
        }))
    }

    /**
     * Fetches the tags of a product by its [productId].
     *
     * @param {number} productId the id of the product.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getTagsOfProduct = async (productId, showErrorTaost = false) => {
        return await apiCallback(Api.prepareRequest({
            url: tagApis.getByPartId(productId),
            method: apiMethods.post,
            showErrorTaost: showErrorTaost,
        }))
    }

    /**
     * Fetches the Statistics of the tags associated with the given tagIds.
     *
     * @param {any} request the ids of the tags to fetch the statistics of.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getTagsStatistics = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: tagApis.getStatistics,
            method: apiMethods.post,
            data: request,
        }))
    }

    // #################################### COLOR THEME APIS ########################################

    /**
     * Fetches the list of color themes of the application,
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getColorThemeList = async () => {
        return await apiCallback(Api.prepareRequest({
            url: colorThemeApis.getList,
            method: apiMethods.get,
            redirectToError: true,
        }))
    }

    /**
     * Fetches the default color of the homepage views.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getDefaultColorTheme = async () => {
        return await apiCallback(Api.prepareRequest({
            url: colorThemeApis.getDefault,
            method: apiMethods.get,
            showErrorToast: false,
        }))
    }

    /**
     * Sets the color theme associated with the given id as the default color theme of the partner.
     *
     * @param {number} id
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setColorThemeAsDefault = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: colorThemeApis.setAsDefault(id),
            method: apiMethods.put,
        }))
    }

    // #################################### SURVEY APIS ########################################

    /**
     * Fetches the list of surveys from server for current partner
     *
     * @param cancelToken
     * @param {string} keyword
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getListOfSurveys = async (keyword, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: surveysApis.getListOfSurveys(keyword),
            method: apiMethods.get,
            showErrorToast: false,
            cancelToken: cancelToken,
        }))
    }

    /**
     * removes a survey from  server for current partner
     *
     * @param {number} id
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static deleteSurvey = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: surveysApis.deleteSurvey(id),
            method: apiMethods.delete,
        }))
    }

    /**
     * Adds a new survey to the list of surveys for a partner
     *
     * @param {object} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addNewSurvey = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: surveysApis.addSurvey,
            data: request,
            method: apiMethods.post,
        }))
    }

    /**
     * Updates a survey for a partner
     *
     * @param {object} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateSurvey = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: surveysApis.updateSurvey,
            data: request,
            method: apiMethods.put,
        }))
    }

    // ############################################  Dynamic Pages (CustomisePage)  #################################################

    /**
     * Lists dynamic pages for the current partner.
     *
     * @param {import('axios').CancelToken} [cancelToken]
     * @return {Promise<ApiResponseDs<import('./type-declerations/response').CustomisePageListItemApiDs[]|null>|undefined>}
     */
    static listDynamicPages = async (cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: dynamicPageApis.list,
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Gets a single dynamic page by id.
     *
     * @param {number|string} pageId
     * @return {Promise<ApiResponseDs<import('./type-declerations/response').CustomisePageApiDs|null>|undefined>}
     */
    static getDynamicPage = async (pageId) => {
        return await apiCallback(Api.prepareRequest({
            url: dynamicPageApis.get(pageId),
            method: apiMethods.get,
            redirectToError: true,
        }));
    }

    /**
     * Creates a new dynamic page.
     *
     * @param {import('./type-declerations/response').CustomisePageApiRequestDs} data
     * @return {Promise<ApiResponseDs<import('./type-declerations/response').CustomisePageApiDs|null>|undefined>}
     */
    static createDynamicPage = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: dynamicPageApis.create,
            data: data,
            method: apiMethods.post,
        }));
    }

    /**
     * Updates a dynamic page (PUT).
     *
     * @param {import('./type-declerations/response').CustomisePageApiRequestDs} data
     * @return {Promise<ApiResponseDs<import('./type-declerations/response').CustomisePageApiDs|null>|undefined>}
     */
    static updateDynamicPage = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: dynamicPageApis.update,
            data: data,
            method: apiMethods.put,
        }));
    }

    /**
     * Removes a dynamic page (soft delete).
     *
     * @param {number|string} pageId
     * @return {Promise<ApiResponseDs<unknown|null>|undefined>}
     */
    static removeDynamicPage = async (pageId) => {
        return await apiCallback(Api.prepareRequest({
            url: dynamicPageApis.remove,
            method: apiMethods.delete,
            data: {id: pageId},
        }))
    }

    // #################################### Suggestions Management ##################################

    /**
     * Gets list of application suggestions
     *
     * @param {object} request
     * @param {any} cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getApplicationSuggestions = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartApplicationSuggestion.getListOfApplicationSuggestions,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Gets list of application suggestions
     *
     * @param {object} request
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getTechnicalSuggestions = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorTechnicalSuggestion.getListOfTechnicalSuggestions,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Changes the status of an application record suggestion
     *
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static changeStatusOfApplicationSuggestion = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorPartApplicationSuggestion.changeStatusOfApplicationSuggestion,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Changes the status of a technical property suggestion
     *
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static changeStatusOfTechnicalSuggestion = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: operatorTechnicalSuggestion.changeStatusOfTechnicalSuggestion,
            method: apiMethods.put,
            data: request,
        }))
    }

    // #################################### Product Information ##################################

    /**
     * Fetches the list of product types of the system.
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getProductTypes = async () => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.getProductTypes,
            method: apiMethods.get,
        }))
    }

    /**
     * Fetches the list of product cost history of the provided product.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getProductCostHistoryReport = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.getProductCostHistoryReport,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Toggles the part being serialized in the server
     *
     * @param {number} partId
     * @param {boolean} showErrorToast
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static toggleProductBeingSerialized = async (partId, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.toggleProductBeingSerialized(partId),
            method: apiMethods.put,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Toggles the part being serialized in the server
     *
     * @param {number} partId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static toggleProductVisibility = async (partId) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.toggleVisibility(partId),
            method: apiMethods.put,
        }))
    }

    /**
     * Toggles the part being serialized in the server
     *
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static toggleProductIsVisibleForClient = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.setPartVisibleForClient,
            method: apiMethods.post,
            data: data,
        }))
    }

    /**
     * Updates the product cost in the server
     *
     * @param {object} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateProductCost = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.updateProductCost,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Gets the fast connection data from server
     *
     * @param cancelToken
     * @param {object} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getFastConnectionData = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.getFastConnectionData,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Validates list of part numbers
     * @param request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static validatePartNumbers = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.validatePartNumbers,
            method: apiMethods.post,
            data: request,
            showErrorToast: false
        }))
    }

    /**
     * Gets a map between the part numbers and their Ids represented as an object
     * @param request
     * @param showErrorToast
     * @param {import('axios').CancelToken} [cancelToken]
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartInfoWithPartNumber = async (request, showErrorToast = false, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.getPartInfoWithPartNumbers,
            method: apiMethods.post,
            data: request,
            showErrorToast: showErrorToast,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Checks whether the customer is qualified to order the part (required BizForm responses approved).
     * @param {number|string} partId
     * @param {number|string} customerId
     * @param {import('axios').CancelToken} [cancelToken]
     * @param {boolean} [showErrorToast=false]
     * @return {Promise<ApiResponseDs<import('./type-declerations/response').PartFormQualificationDs|null>|undefined>}
     */
    static checkFormQualificationForPart = async (partId, customerId, cancelToken = undefined, showErrorToast = false) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.checkFormQualificationForPart(partId, customerId),
            method: apiMethods.get,
            cancelToken,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Updates the part visibility based on the received list of part numbers
     * @param request
     * @param showErrorToast
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setPartVisibilityByPartNumber = async (request, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.setPartVisibility,
            method: apiMethods.post,
            data: request,
            showErrorToast: showErrorToast
        }))
    }

    /**
     * Fetches the key information of a product given its partNo and warehouseCode.
     * @param partNo
     * @param warehouseCode {string?}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getProductKeyInformation = async (partNo, warehouseCode = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.getPartKeyInfo(partNo, warehouseCode),
            method: apiMethods.post,
            showErrorToast: false
        }))
    }

    /**
     * Fetches cross-sale (suggestive selling) parts for a given part id.
     * @param {number|string} partId
     * @return {Promise<ApiResponseDs<unknown[]|null>|undefined>}
     */
    static getCrossSalesParts = async (partId) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.getCrossSalesParts(partId),
            method: apiMethods.get,
            showErrorToast: false,
        }))
    }

    /**
     * Fetches the list of availabilities of a product given its partNo.
     * @param data
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getProductAvailabilitiesV2 = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.getAvailabilitiesV2,
            data: data,
            cancelToken: cancelToken,
            method: apiMethods.post,
            showErrorToast: false
        }))
    }

    /**
     * Creates a new part in the warehouse
     * @param data
     * @param showErrorToast
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createPartInWarehouse = async (data, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.createPartInWarehouse,
            data: data,
            method: apiMethods.post,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Creates a new part in the system
     *
     * @param {any} request the part information needed for its creation in the server.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createProductV2 = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.createPart,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Fetches the prices of the part for a specific customer.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPriceForCustomer = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.getPriceForCustomer,
            data: data,
            method: apiMethods.post,
            showErrorToast: false
        }))
    }

    /**
     * Marks the provided parts as needed to be re-cached for search purposes.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static markPartsForCache = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.MarkPartsForCache,
            data: data,
            method: apiMethods.post,
            showErrorToast: false
        }))
    }

    /**
     * sets the IsPublicForBuyers flag of the product information
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setProductIsPublicForBuyers = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.setIsPublicForBuyers,
            data: data,
            method: apiMethods.post,
            showErrorToast: false
        }))
    }

    /**
     * Exports parts basic information for settings export.
     * @param {any} data
     * @returns {Promise<import('./type-declerations/response').ReportingApiResponse<{
     *     partId: number,
     *     partNumber: string,
     *     shortDescription: string | null,
     *     description: string | null,
     * }> | undefined>}
     */
    static exportParts = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.exportParts,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Copies the product information from the part
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static productCopyFromPart = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.copyFromPart,
            data: data,
            method: apiMethods.post,
            showErrorToast: false
        }))
    }

    /**
     * Copies the product information from the part
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartSections = async () => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.getPartSections,
            method: apiMethods.get,
            showErrorToast: false
        }))
    }

    /**
     * Make Variant Part
     * @param {object} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static makeVariantPart = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.makeVariantPart,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     *  Remove Variant
     * @param {object} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeVariant = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.removeVariant,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     *  Get Product Variant
     * @param request
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static getProductVariant = async (request, cancelToken = undefined) => {
        const response = await apiCallback(Api.prepareRequest({
            url: productInformationApis.getProductVariant,
            method: apiMethods.post,
            data: request,
            showErrorToast: false,
            cancelToken: cancelToken
        }))
        if (response?.code !== ApiResponseCodes.productHasNoVariants && !response?.resultFlag && !response?.aborted) {
            response?.showToast?.error({
                title: response?.headerTitle,
                message: response.message ?? "",
            });
        }
        return response;
    }

    /**
     * Load Parts By Prefix
     * @param prefix
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static loadPartsByPrefix = async (prefix) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.loadPartsByPrefix(prefix),
            method: apiMethods.get,
        }))
    }

    /**
     * Updates the part number of a product
     * @param request
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static updatePartNumber = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.updatePartNumber,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Fetches the list of part numbers
     * @param data
     * @param cancelToken
     * @param showErrorToast
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static externalPartAutoFill = async (data, cancelToken = undefined, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.externalPartAutoFill,
            data: data,
            cancelToken: cancelToken,
            method: apiMethods.post,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * imports a part from an external system based on the provided part number and source system name
     * @param {object} request
     * @param showErrorToast
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static importPartFromExternal = async (request, showErrorToast = false) => {
        const response = await apiCallback(Api.prepareRequest({
            url: productInformationApis.importPartFromExternal,
            method: apiMethods.post,
            data: request,
            showErrorToast: false,
        }))
        if (response?.errorCode !== ApiResponseCodes.defaultCategoryRequiresForIndustry && !response?.resultFlag && !response?.aborted && showErrorToast) {
            response?.showToast?.error({
                title: response?.headerTitle,
                message: response.message ?? "",
            });
        }
        return response;
    }

    /**
     * Fetches the list of taxes applied on a part based on the provided part id and warehouse code
     * @param partId
     * @param warehouseCode
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static loadPartTaxes = async (partId, warehouseCode) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.loadPartTaxes(partId, warehouseCode),
            method: apiMethods.get,
        }))
    }

    /**
     * Updates the taxes applied on a part based on the provided part id, warehouse code and the list of taxes to be applied
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static updatePartTax = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.updatePartTax,
            method: apiMethods.put,
            data: data,
        }))
    }

    /**
     * Assigns a category to a part based on the provided part id, warehouse code and category title
     * @param data
     * @param showErrorToast
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static assignPartCategoryByTitle = async (data, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.assignPartCategoryByTitle,
            method: apiMethods.put,
            data: data,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Copies a part from a seller partner into the operator catalog.
     *
     * @param {{ partId: number, partnerConnectionId: number, partNumber: string, keepUpdate: boolean }} data
     * @param {boolean} [showErrorToast=true]
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static copyPartFromSellerPartner = async (data, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.copyPartFromSellerPartner,
            method: apiMethods.post,
            data: data,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Fetches the list of UPCs associated with a part based on the provided part id
     * @param partId
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listPartUpcs = async (partId) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.listPartUpcs(partId),
            method: apiMethods.get,
        }))
    }

    /**
     * Adds a UPC to a part in the system
     * @param data
     @param showErrorToast
     *
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addPartUpc = async (data, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.addPartUpc,
            method: apiMethods.post,
            data: data,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Removes a UPC from a part in the system
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removePartUpc = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.removePartUpc,
            method: apiMethods.post,
            data: data,
        }))
    }

    /**
     * Updates a UPC of a part in the system
     */
    static updatePartUpc = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.updatePartUpc,
            method: apiMethods.post,
            data: data,
        }))
    }

    /**
     * Removes a product (part) from the system.
     * @param {{partId: number}} data
     * @param {boolean} [showErrorToast=true]
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static removeProduct = async (data, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.removePart,
            method: apiMethods.post,
            data: data,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Updates the part title of a product in the system
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static updatePartTitle = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.updatePartTitle,
            method: apiMethods.post,
            data: data,
        }))
    }

    /**
     * Updates the part title of a product in the system
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static toggleProductEligibilityForOnlineOrdering = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.setPartEligibleForOnlineOrdering,
            method: apiMethods.post,
            data: data,
        }))
    }

    /**
     * Updates the delivery mode of a product.
     * @param data {{ partId: number, deliveryMode: number }}
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static updatePartDeliveryMode = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: productInformationApis.updatePartDeliveryMode,
            method: apiMethods.put,
            data: data,
        }))
    }

    // #################################### Inventory ##################################

    /**
     * Fetches the list of products' serial numbers and available quantity based on the given warehouse.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartSerialNosAndQuantityByWarehouse = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: inventoryApis.getPartSerialNosAndQuantityByWarehouse(request.partNo, request.warehouseCode),
            method: apiMethods.get,
        }))
    }

    // #################################### Banner ##################################

    /**
     * Fetches the list of all banners in the system.
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getBannersList = async () => {
        return await apiCallback(Api.prepareRequest({
            url: bannerApis.getAll,
            method: apiMethods.get,
            redirectToError: true,
        }))
    }

    /**
     * Creates a new banner with the given data in the system.
     *
     * @param {any} request
     * @param {function} onUploadProgress
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createNewBanner = async (request, onUploadProgress) => {
        return await apiCallback(Api.prepareRequest({
            url: bannerApis.create,
            method: apiMethods.post,
            data: request,
            onUploadProgress: onUploadProgress,
        }))
    }

    /**
     * updates the information of an existing banner with the given data in the system.
     *
     * @param {any} request
     * @param {function} onUploadProgress
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateBanner = async (request, onUploadProgress) => {
        return await apiCallback(Api.prepareRequest({
            url: bannerApis.update,
            method: apiMethods.put,
            data: request,
            onUploadProgress: onUploadProgress,
        }))
    }

    /**
     * Removes an existing banner associated with the given banner id in the system.
     *
     * @param {number} bannerId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeBanner = async (bannerId) => {
        return await apiCallback(Api.prepareRequest({
            url: bannerApis.remove(bannerId),
            method: apiMethods.delete,
        }))
    }

    /**
     * Adds a tag to an existing banner in the system.
     *
     * @param {number} bannerId
     * @param {number} tagId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addTagToBanner = async (bannerId, tagId) => {
        return await apiCallback(Api.prepareRequest({
            url: bannerApis.addTag(bannerId, tagId),
            method: apiMethods.put,
        }))
    }

    /**
     * Removes a tag from an existing banner in the system.
     *
     * @param {number} bannerId
     * @param {number} tagId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeTagFromBanner = async (bannerId, tagId) => {
        return await apiCallback(Api.prepareRequest({
            url: bannerApis.removeTag(bannerId, tagId),
            method: apiMethods.put,
        }))
    }

    // #################################### Homepage Edition ##################################

    /**
     * Searches though the available homepage editions in the system with the given request filters and pagination.
     *
     * @param {any} request
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchHomepageEditions = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: homepageEditionApis.search,
            method: apiMethods.post,
            data: request,
            redirectToError: true,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Creates a new homepage edition in the system with the given request data.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createHomepageEdition = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: homepageEditionApis.create,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Fetches the full information of a homepage edition associated with the given editionId.
     *
     * * If tabId is present, only fills in the components of that specific tab, else, fills in the components of
     * the first tab.
     * @param {number} editionId
     * @param {number?} tabId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getHomepageEditionDetails = async (editionId, tabId = undefined) => {
        const response = await apiCallback(Api.prepareRequest({
            url: homepageEditionApis.getDetails(editionId, tabId),
            method: apiMethods.get,
            redirectToError: true,
        }));
        if (EnvService.MockHomeImageCarousel && response?.resultFlag && response?.data) {
            response.data = injectMockHomeImageCarouselEdition(response.data, tabId);
        }
        return response;
    }

    /**
     * Updates an existing homepage edition in the system with the given request data.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateHomepageEdition = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: homepageEditionApis.update,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Removes an existing homepage edition in the system associated with the given editionId.
     *
     * @param {number} editionId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeHomepageEdition = async (editionId) => {
        return await apiCallback(Api.prepareRequest({
            url: homepageEditionApis.remove(editionId),
            method: apiMethods.delete,
        }))
    }

    /**
     * Sets an existing homepage edition in the system associated with the given editionId as the live edition of
     * the customers' homepage.
     *
     * @param {number} editionId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setHomepageEditionAsLive = async (editionId) => {
        return await apiCallback(Api.prepareRequest({
            url: homepageEditionApis.setAsLive(editionId),
            method: apiMethods.put,
        }))
    }

    // #################################### Homepage Edition Tab ##################################

    /**
     * Creates a new homepage edition tab in the system with the given request data.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createHomepageEditionTab = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: homepageEditionTabApis.create,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Updates an existing homepage edition tab in the system with the given request data.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateHomepageEditionTab = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: homepageEditionTabApis.update,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Updates an existing homepage edition tab's order index in the system with the given request data.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateHomepageEditionTabOrderIndex = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: homepageEditionTabApis.updateOrderIndex,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Removes an existing homepage edition tab that is associated with the given tabId from the system.
     *
     * @param {number} tabId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeHomepageEditionTab = async (tabId) => {
        return await apiCallback(Api.prepareRequest({
            url: homepageEditionTabApis.remove(tabId),
            method: apiMethods.delete,
        }))
    }

    // #################################### Homepage Edition Tab Component ##################################

    /**
     * Creates a new homepage edition tab component in the system with the given request data.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createHomepageEditionTabComponent = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: homepageEditionTabComponentApis.create,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Updates an existing homepage edition tab component's general information in the system with the given request
     * data.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateHomepageEditionTabComponentGeneralInformation = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: homepageEditionTabComponentApis.updateGeneralInfo,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Updates an existing homepage edition tab component's order index in the system with the given request data.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateHomepageEditionTabComponentOrderIndex = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: homepageEditionTabComponentApis.updateOrderIndex,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Updates an existing homepage edition tab component's content in the system with the given request data.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateHomepageEditionTabComponentContent = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: homepageEditionTabComponentApis.updateContent,
            method: apiMethods.put,
            data: request,
        }))
    }

    /**
     * Removes an existing homepage edition tab component that is associated with the given componentId from the system.
     *
     * @param {number} componentId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeHomepageEditionTabComponent = async (componentId) => {
        return await apiCallback(Api.prepareRequest({
            url: homepageEditionTabComponentApis.remove(componentId),
            method: apiMethods.delete,
        }))
    }

    // #################################### Part Compare Api ##################################

    /**
     * Gets the list of parts that are in the operators' comparison list
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getComparisonList = async () => {
        return await apiCallback(Api.prepareRequest({
            url: partCompareApis.getCompareList,
            method: apiMethods.get,
        }))
    }

    /**
     * Adds a specific part to operators' comparison list.
     *
     * @param request {any}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addPartToCompareList = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: partCompareApis.addPart,
            method: apiMethods.post,
            data: request,
            showErrorToast: false,
        }))
    }

    /**
     * Removes a specific part from operators' comparison list.
     *
     * @param partId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removePartFromCompareList = async (partId) => {
        return await apiCallback(Api.prepareRequest({
            url: partCompareApis.removePart(partId),
            method: apiMethods.delete,
        }))
    }

    /**
     * Removes a specific category from operators' comparison list.
     *
     * @param categoryId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeCategoryFromCompareList = async (categoryId) => {
        return await apiCallback(Api.prepareRequest({
            url: partCompareApis.removeCategory(categoryId),
            method: apiMethods.delete,
        }))
    }

    // ####################################    THEME EDITOR APIS     ########################################

    /**
     * Gets validation token from server for showing the theme editor
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getThemeEditorEditToken = async () => {
        return await apiCallback(Api.prepareRequest({
            url: themeEditorApis.getEditToken,
            method: apiMethods.get,
        }))
    }

    // ####################################    NEW CUSTOMER CREDIT CARDS APIS     ########################################

    /**
     * Gets the list of customer credit cards from server
     *
     * @param {number} customerId id of the customer
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getCustomerCreditCardsV2 = async (customerId) => {
        return await apiCallback(Api.prepareRequest({
            url: customerCreditCardsApis.getCustomerCreditCards(customerId),
            method: apiMethods.get,
        }))
    }

    /**
     * Adds a new credit card for customer to the server
     *
     * @param {object} request new credit card information object
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addNewCustomerCreditCardV2 = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: customerCreditCardsApis.addNewCustomerCreditCard,
            method: apiMethods.post,
            data: request,
        }))
    }

    /**
     * Removes customer credit card in the server
     *
     * @param {number} customerId id of the customer
     * @param {number} cardId card id
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeCustomerCreditCardV2 = async ({customerId, cardId}) => {
        return await apiCallback(Api.prepareRequest({
            url: customerCreditCardsApis.removeCustomerCreditCard(cardId, customerId),
            method: apiMethods.delete,
        }))
    }

    /**
     * Sets user credit card as default
     *
     * @param {number} customerId id of the customer
     * @param {number} cardId card id
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setCustomerCreditCardAsDefaultV2 = async ({customerId, cardId}) => {
        return await apiCallback(Api.prepareRequest({
            url: customerCreditCardsApis.setCustomerCreditCardAsDefault(cardId, customerId),
            method: apiMethods.put,
        }))
    }

    /**
     * Searches through a customer credit card's transaction history with the provided values.
     *
     * @param cancelToken
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchCustomerCreditCardTransactionHistoryV2 = async (data, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: customerCreditCardsApis.getTransactionHistory,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Adds a new credit card for customer to the server
     * @param data
     * @param {Function | null} getHeaders
     * @param {boolean} bypassAuthCheck
     * @param {ApiLogger} logger
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     * @constructor
     */
    static addCustomerCreditCardByTokenV2 = async (data, getHeaders = null, bypassAuthCheck = false, logger) => {
        return await apiCallback(Api.prepareRequest({
            url: customerCreditCardsApis.addCardByToken,
            method: apiMethods.post,
            data: data,
            getHeaders: getHeaders,
            logger: logger,
            loginRequired: !bypassAuthCheck,
        }));
    }

    /**
     * Fetches the payment providers from the server.
     *
     * @param {Function | null} getHeaders
     * @param {boolean} bypassAuthCheck
     * @param cancelToken
     * @param {ApiLogger | null} logger
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     * @constructor
     */
    static getPaymentProviders = async (getHeaders = null, cancelToken = null, bypassAuthCheck = false, logger = null) => {
        return await apiCallback(Api.prepareRequest({
            url: customerCreditCardsApis.getPaymentProviders,
            method: apiMethods.get,
            getHeaders: getHeaders,
            cancelToken: cancelToken,
            logger: logger,
            loginRequired: !bypassAuthCheck,
        }));
    }

    /**
     * Fetches the stripe public key from the server.
     *
     * @param {Function | null} getHeaders
     * @param {boolean} bypassAuthCheck
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static getStripePublicKey = async (getHeaders = null, bypassAuthCheck = false) => {
        return await apiCallback(Api.prepareRequest({
            url: customerCreditCardsApis.getStripePublicKey,
            method: apiMethods.get,
            showErrorToast: false,
            getHeaders: getHeaders,
            loginRequired: !bypassAuthCheck,
        }));
    }

    // ####################################    ONLINE PAYMENT REPORTS     ########################################

    /**
     * Searches amongst the online payments reports of the system with the provided filters.
     *
     * @param data
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchOnlinePaymentReports = async (data, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: onlinePaymentReportApis.search,
            method: apiMethods.post,
            data: data,
            redirectToError: true,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Searches amongst the online payments reports for showing timelines.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchOnlinePaymentReportTimeline = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: onlinePaymentReportApis.searchTimeline,
            method: apiMethods.post,
            data: data,
        }))
    }

    /**
     * Fetches the transaction types of the online payment reports.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getOnlinePaymentReportTransactionTypes = async () => {
        return await apiCallback(Api.prepareRequest({
            url: onlinePaymentReportApis.getTransactionTypes,
            method: apiMethods.get,
        }))
    }

    /**
     * Fetches the transaction types of the online payment reports.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getOnlinePaymentReportStatistics = async () => {
        return await apiCallback(Api.prepareRequest({
            url: onlinePaymentReportApis.getGeneralReport,
            method: apiMethods.get,
        }))
    }


    // ####################################    POS    ########################################

    /**
     * Charges the customer's credit card with the specified amount.
     *
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static chargeCustomerCreditCard = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: posApis.makePayment,
            method: apiMethods.post,
            data: data,
        }))
    }

    /**
     * Fetches the POS Receipt for the client
     *
     * @param receiptId
     * @param customerId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPOSClientReceipt = async (receiptId, customerId) => {
        return await apiCallback(Api.prepareRequest({
            url: posApis.getClientReceipt(receiptId, customerId),
            method: apiMethods.get,
        }))
    }

    /**
     * Fetches the POS Receipt for the merchant
     *
     * @param receiptId
     * @param customerId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPOSMerchantReceipt = async (receiptId, customerId) => {
        return await apiCallback(Api.prepareRequest({
            url: posApis.getMerchantReceipt(receiptId, customerId),
            method: apiMethods.get,
        }))
    }

    /**
     * Emails the POS client receipt to the client
     *
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static emailPOSClientReceipt = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: posApis.emailClientReceipt,
            method: apiMethods.post,
            data: data,
            showSuccessToast: true,
        }))
    }

    /**
     * Emails the POS client receipt to the merchant
     *
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static emailPOSMerchantReceipt = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: posApis.emailMerchantReceipt,
            method: apiMethods.post,
            data: data,
            showSuccessToast: true,
        }))
    }

    /**
     * Fetches the store information for the given store id from the server
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPOSStoreInformation = async () => {
        return await apiCallback(Api.prepareRequest({
            url: storeApis.getStoreInformation,
            method: apiMethods.get,
        }))
    }


    /**
     * Saves the store information in the server
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static savePOSStoreInformation = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: storeApis.saveStoreInformation,
            method: apiMethods.post,
            data: data,
        }))
    }

    // ####################################    BULK PRICE CHANGE   ########################################

    /**
     * Creates a new bulk price change request.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createBulkPriceChange = async () => {
        return await apiCallback(Api.prepareRequest({
            url: bulkPriceChangeApis.create,
            method: apiMethods.post,
        }));
    }

    /**
     * Fetches the dashboard information of the bulk-price change requests.
     *
     * @param request
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getBulkPriceChangeDashboardInformation = async (request, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: bulkPriceChangeApis.getDashboard,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Fetches the autocomplete parts selection for a new bulk price change request.
     *
     * @params {string}  keywords
     * @params {any}  cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getBulkPriceChangeAutoCompleteParts = async (keywords, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: bulkPriceChangeApis.partSelectionAutocomplete(keywords),
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }


    /**
     * Sets the parts of a bulk price change request.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setPartsOfBulkPriceChange = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: bulkPriceChangeApis.addParts,
            method: apiMethods.post,
            data: request,
        }));
    }

    /**
     * Searches among the assigned parts of a bulk price change request.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static searchAssignedPartsOfBulkPriceChange = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: bulkPriceChangeApis.listParts,
            method: apiMethods.post,
            data: request,
        }));
    }

    /**
     * Updates the status of a bulk price change request.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateBulkPriceChangeStatus = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: bulkPriceChangeApis.updateStatus,
            method: apiMethods.put,
            data: request,
        }));
    }

    /**
     * Saves the selected price levels of a bulk price change request.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static saveBulkPriceChangeSelectedPriceLevels = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: bulkPriceChangeApis.savePriceLevels,
            method: apiMethods.post,
            data: request,
        }));
    }

    /**
     * Updates the price change information of a bulk price change request.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateBulkPriceChangePriceChangeInfo = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: bulkPriceChangeApis.updatePriceChangeInfo,
            method: apiMethods.put,
            data: request,
        }));
    }

    /**
     * Fetches the information of a bulk price change information associated with the provided id.
     *
     * @param {number} id
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getBulkPriceChangeInformation = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: bulkPriceChangeApis.get(id),
            method: apiMethods.get,
            redirectToError: true,
        }));
    }

    /**
     * Changes the price of a part in a bulk price change request.
     *
     * @param {any} request
     * @param {import(axios).CancelToken} cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static changePartPriceOfBulkPriceChangeRequest = async (request, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: bulkPriceChangeApis.changePrice,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Fetches the price change logs of a bulk price change request with the given constraints.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getBulkPriceChangePriceChangeLogs = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: bulkPriceChangeApis.getLogs,
            method: apiMethods.post,
            data: request,
        }));
    }

    /**
     * Creates a new attempt for a bulk price change request.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createNewBulkPriceChangePriceAttempt = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: bulkPriceChangeApis.newAttempt,
            method: apiMethods.post,
            data: request,
        }));
    }

    /**
     * Cancels the last attempt of a bulk price change request.
     *
     * @param {any} request
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static cancelLastBulkPriceChangePriceAttempt = async (request) => {
        return await apiCallback(Api.prepareRequest({
            url: bulkPriceChangeApis.cancel,
            method: apiMethods.post,
            data: request,
        }));
    }


    // ####################################    PART SUPPORT DRIVER CHECKLIST  ########################################

    /**
     * Gets the current driver checklist for a part support request
     *
     * @param {number} partSupportId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getCurrentDriverCheckList = async (partSupportId) => {
        return await apiCallback(Api.prepareRequest({
            url: PartSupportDriverCheckListApis.getCurrentDriverCheckList(partSupportId),
            method: apiMethods.get,
        }));
    }

    /**
     * Updates the driver checklist in the part support request
     *
     * @param {object} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updatePartSupportDriverCheckList = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: PartSupportDriverCheckListApis.updateCurrentDriverCheckList,
            data: data,
            method: apiMethods.put,
        }));
    }

    // ####################################    NEW PART SUPPORT REQ  ########################################

    /**
     * Updates additional information of a part support request
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updatePartSupportAdditionalInformation = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: NewPartSupportReqApis.updatePartSupportAdditionalInformation,
            data: data,
            method: apiMethods.put,
        }));
    }

    /**
     * Fetches or generates a public link for a part support request
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartSupportPublicLink = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: NewPartSupportReqApis.generatePublicLink,
            data: data,
            method: apiMethods.post,
        }));
    }

    /**
     * Updates the public link for a part support request
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updatePartSupportPublicLink = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: NewPartSupportReqApis.updatePublicLink,
            data: data,
            method: apiMethods.put,
        }));
    }


    /**
     * Fetches the new part support request list from server
     * @param forApi
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static reportPartSupportReq = async (forApi, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: NewPartSupportReqApis.reportPartSupportReq,
            data: forApi,
            method: apiMethods.post,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Updates the operator of a part support request.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updatePartSupportOperator = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: NewPartSupportReqApis.updateOperator,
            data: data,
            method: apiMethods.put,
        }));
    }

    /**
     * Updates the vendor status of a part support request.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateVendorStatusOfPartSupport = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: NewPartSupportReqApis.updateVendorStatus,
            data: data,
            method: apiMethods.put,
        }));
    }

    /**
     * Fetches the autocomplete results for RGA requests based on the provided keyword.
     */
    static rgaAutocomplete = async (keyword) => {
        return await apiCallback(Api.prepareRequest({
            url: NewPartSupportReqApis.rgaAutocomplete(keyword),
            method: apiMethods.get,
        }));
    }


    // #################################################  DRIVER  ######################################################

    /**
     * Gets list of drivers from server
     * @param data
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getListOfDrivers = async (data, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: DriverApis.getListOfDrivers,
            data: data,
            method: apiMethods.post,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Creates a new driver in the system
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createNewDriver = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: DriverApis.createNewDriver,
            data: data,
            method: apiMethods.post,
        }));
    }

    /**
     * Removes list of drivers from the system
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static bulkRemoveDrivers = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: DriverApis.bulkRemoveDrivers,
            data: data,
            method: apiMethods.delete,
        }));
    }

    /**
     * Updates a driver information in the system
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateDriverInformation = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: DriverApis.updateDriver,
            data: data,
            method: apiMethods.put,
        }));
    }

    // #################################################  New AR  ######################################################

    /**
     * gets the new AR aged list from server
     * @param data
     * @param cancelToken
     * @param onErrorCallback
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getARAgedList = async (data, cancelToken, onErrorCallback) => {
        return await apiCallback(Api.prepareRequest({
            url: NewARApis.getARAgedList,
            data: data,
            method: apiMethods.post,
            cancelToken: cancelToken,
            unAuthorizedCallback: onErrorCallback,
            accessDeniedCallback: onErrorCallback,
        }));
    }

    /**
     * Lists the transactions for a specific AR aged list entry based on the provided filters.
     * @param data
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listArTransactions = async (data, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: NewARApis.listArTransactions,
            data: data,
            method: apiMethods.post,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Connects AR transactions to a specific AR aged list entry based on the provided transaction ids.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static connectArTransactions = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: NewARApis.connectArTransactions,
            data: data,
            method: apiMethods.post,
        }));
    }

    // #################################################  Inventory Adjustment  ######################################################

    /**
     * Fetches the list of serial numbers for a specific part number to apply to the inventory adjustment.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getInventoryAdjustmentProductSerialNumbers = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: inventoryAdjustmentApis.getAvailableSerialNumbers,
            data: data,
            method: apiMethods.post,
        }));
    }


    /**
     * Creates a new inventory adjustment entity from the provided list.
     * @param data
     * @param showErrorToast
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createInventoryAdjustment = async (data, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: inventoryAdjustmentApis.createAdjustment,
            data: data,
            method: apiMethods.post,
            showErrorToast: showErrorToast,
        }));
    }

    /**
     * Sets warehouse on-hand quantities and posts resulting inventory adjustments.
     * @param data
     * @param showErrorToast
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setInventoryAvailability = async (data, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: inventoryApis.setInventoryAvailability,
            data: data,
            method: apiMethods.post,
            showErrorToast: showErrorToast,
        }));
    }

    /**
     * Gets list of inventory adjustment from server
     * @param data
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getInventoryAdjustmentList = async (data, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: inventoryAdjustmentApis.getAdjustmentsList,
            data: data,
            method: apiMethods.post,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Gets list of inventory adjustment items from server
     * @param data
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getInventoryAdjustmentItems = async (data, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: inventoryAdjustmentApis.getAdjustmentsItems,
            data: data,
            method: apiMethods.post,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Fetches the data associated with of inventory adjustment report from server.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getInventoryAdjustmentReport = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: inventoryAdjustmentApis.getAdjustmentReport,
            data: data,
            method: apiMethods.post,
        }))
    }

    /**
     * Fetches the data associated with a single inventory adjustment from the server.
     * @param id
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getInventoryAdjustment = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: inventoryAdjustmentApis.getAdjustment(id),
            method: apiMethods.get,
        }))
    }

    // #################################################  Inventory Adjustment Reasons  ######################################################

    /**
     * Creates a new reason for modifying bulk inventory adjustment
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createInventoryAdjustmentReason = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: InventoryAdjustmentReasonsApis.createReason,
            data: data,
            method: apiMethods.post,
        }))
    }


    /**
     * Gets the list of reasons for modifying inventory availability
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getInventoryAdjustmentsReasons = async () => {
        return await apiCallback(Api.prepareRequest({
            url: InventoryAdjustmentReasonsApis.getReasonList,
            method: apiMethods.get,
        }))
    }

    /**
     * Gets the list of reasons for modifying inventory availability
     * @param {object} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateInventoryAdjustmentReason = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: InventoryAdjustmentReasonsApis.updateReason,
            data: data,
            method: apiMethods.put,
        }));
    }

    /**
     * Removes inventory adjustment reason from server
     * @param {number} id
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeInventoryAdjustmentsReason = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: InventoryAdjustmentReasonsApis.removeReason(id),
            method: apiMethods.delete,
        }))
    }

    // #################################################  Inventory Transfer  ######################################################

    /**
     * Creates a new inventory transfer between two warehouses.
     * @param data
     * @param {boolean} [showErrorToast=true]
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createInventoryTransfer = async (data, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: inventoryTransferApis.createTransfer,
            data: data,
            method: apiMethods.post,
            showErrorToast,
        }))
    }

    /**
     * Returns a paginated list of inventory transfers.
     * @param data
     * @param cancelToken
     * @param {boolean} [showErrorToast=true]
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listInventoryTransfers = async (data, cancelToken, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: inventoryTransferApis.listInventoryTransfers,
            data: data,
            method: apiMethods.post,
            cancelToken: cancelToken,
            showErrorToast,
        }))
    }

    /**
     * Returns full detail for one inventory transfer.
     * @param transferId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getInventoryTransfer = async (transferId) => {
        return await apiCallback(Api.prepareRequest({
            url: inventoryTransferApis.getInventoryTransfer,
            data: {transferId},
            method: apiMethods.post,
        }))
    }

    /**
     * Adds parts to an existing transfer.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addPartsToInventoryTransfer = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: inventoryTransferApis.addPartsToTransfer,
            data: data,
            method: apiMethods.post,
        }))
    }

    /**
     * Removes parts from an existing transfer.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removePartsFromInventoryTransfer = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: inventoryTransferApis.removePartsFromTransfer,
            data: data,
            method: apiMethods.post,
        }))
    }

    /**
     * Updates basic fields on a transfer line.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateInventoryTransferItemBasicInfo = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: inventoryTransferApis.updateTransferItemBasicInfo,
            data: data,
            method: apiMethods.post,
        }))
    }

    /**
     * Updates the cost on a transfer line.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateInventoryTransferItemCoreInfo = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: inventoryTransferApis.updateTransferItemCoreInfo,
            data: data,
            method: apiMethods.post,
        }))
    }

    /**
     * Commits scanned quantity (and serial numbers when applicable) for one transfer line.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static commitInventoryTransferItem = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: inventoryTransferApis.commitItem,
            data: data,
            method: apiMethods.post,
        }))
    }

    /**
     * Removes previously committed quantity or serial numbers from one transfer line.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static uncommitInventoryTransferItem = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: inventoryTransferApis.uncommitItem,
            data: data,
            method: apiMethods.post,
        }))
    }

    /**
     * Updates the status of a transfer and records an audit log entry.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateInventoryTransferStatus = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: inventoryTransferApis.updateTransferStatus,
            data: data,
            method: apiMethods.post,
        }))
    }

    /**
     * Posts a finalized inventory transfer.
     * @param transferId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static postInventoryTransfer = async (transferId) => {
        return await apiCallback(Api.prepareRequest({
            url: inventoryTransferApis.postTransfer,
            data: {transferId},
            method: apiMethods.post,
        }))
    }


    // #################################################  Regions  ######################################################

    /**
     * Fetches the list of system regions from the server.
     *
     * @param {import(axios).CancelToken | null} cancelToken
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getSystemRegions = async (data, cancelToken = null) => {
        return await apiCallback(Api.prepareRequest({
            url: regionsApis.get,
            data: data,
            method: apiMethods.post,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Creates a new system region with the provided values.
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createSystemRegions = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: regionsApis.create,
            data: data,
            method: apiMethods.post,
        }))
    }

    /**
     * Updates an existing system region with the provided values.
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateSystemRegion = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: regionsApis.update,
            data: data,
            method: apiMethods.put,
        }))
    }

    /**
     * Removes a set of existing system region with the provided values.
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static deleteSystemRegions = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: regionsApis.delete,
            data: data,
            method: apiMethods.post,
        }))
    }

    /**
     * Fetches the region of a customer from the server.
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getCustomerRegion = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: regionsApis.getCustomerRegion,
            data: data,
            method: apiMethods.post,
            showErrorToast: false,
        }));
    }

    // #################################################  Freight Info  ######################################################


    /**
     * Saves the freight info of an order entity in the server.
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static saveOrderFreightInfo = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightInfoApis.saveOrder,
            data: data,
            method: apiMethods.post,
        }))
    }

    /**
     * Saves the freight info of an invoice entity in the server.
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static saveInvoiceFreightInfo = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightInfoApis.saveInvoice,
            data: data,
            method: apiMethods.post,
        }))
    }

    /**
     * Determines if the order is eligible for free freight.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static calculateFreeFreightEligibility = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightInfoApis.calculateFreeFreightEligibility,
            data: data,
            method: apiMethods.post,
            showErrorToast: false,
        }));
    }

    /**
     * Estimates the shipping fee for an order based on freight company and shipping address.
     * @param {{orderId: number, freightCompanyId: number}} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static estimateShippingFee = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightInfoApis.estimateShippingFee,
            data: data,
            method: apiMethods.post,
            showErrorToast: false,
        }));
    }

    // #################################################  Freight SERVICE  ######################################################

    // #################################################  Freight Companies  ######################################################

    /**
     * Fetches the list of freight companies from the server.
     * @param {any} data
     * @param {any} cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getFreightCompanies = async (data, cancelToken = null) => {
        return await apiCallback(Api.prepareRequest({
            url: freightCompaniesApis.get,
            data: data,
            method: apiMethods.post,
            cancelToken: cancelToken,
        }))
    }

    /**
     * Creates a new freight company with the provided values.
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createFreightCompanies = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightCompaniesApis.create,
            data: data,
            method: apiMethods.post,
        }))
    }

    /**
     * Updates an existing freight company with the provided values.
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateFreightCompanies = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightCompaniesApis.update,
            data: data,
            method: apiMethods.put,
        }))
    }

    /**
     * Removes a set of existing freight company with the provided values.
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static deleteFreightCompanies = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightCompaniesApis.delete,
            data: data,
            method: apiMethods.post,
        }))
    }

    // #################################################  Freight Orders  ######################################################

    /**
     * Fetches the freight information of an order from the server.
     *
     * @param {number?} orderId
     * @param {number?} invoiceId
     * @return {Promise<ApiResponseDs<unknown | null> | undefined>}
     */
    static getFreightOrderInformation = ({orderId, invoiceId}) => {
        return apiCallback(Api.prepareRequest({
            url: freightOrderApis.getOrder(orderId, invoiceId),
            method: apiMethods.get,
            showErrorToast: false,
        }));
    }

    /**
     * Fetches the list of freight orders from the server.
     *
     * @param {any} data
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listFreightOrders = async (data, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: freightOrderApis.listOrders,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken,
        }));
    }


    /**
     * Updates a freight order values with the provided values.
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateFreightOrder = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightOrderApis.updateOrder,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Fetches the list of freight orders for reporting purposes from the server.
     *
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getFreightOrdersReport = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightOrderApis.getOrderReport,
            method: apiMethods.post,
            data: data,
        }));
    }

    // #################################################  Freight Quote  ######################################################

    /**
     * Fetches the configured freight quote estimation provider for the company.
     * @param {import('axios').CancelToken} [cancelToken]
     * @return {Promise<ApiResponseDs<{id: number, serviceName: string} | null>|undefined>}
     */
    static getQuoteProvider = async (cancelToken = null) => {
        return await apiCallback(Api.prepareRequest({
            url: freightQuoteApis.getQuoteProvider,
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Saves the freight quote estimation provider for the company.
     * @param {{serviceName: string}} data
     * @return {Promise<ApiResponseDs<{id: number, serviceName: string} | null>|undefined>}
     */
    static saveQuoteProvider = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightQuoteApis.saveQuoteProvider,
            method: apiMethods.post,
            data: data,
        }));
    }


    // #################################################  Freight Flat Exceptions  ######################################################

    /**
     * Fetches the list of freight flat exceptions from the server.
     *
     * @param {number} customerId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getFreightFlatExceptions = async (customerId = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: freightFlatExceptionApis.list(customerId),
            method: apiMethods.get,
        }));
    }

    /**
     * Saves the freight flat exceptions in the server.
     *
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static saveFreightFlatExceptions = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightFlatExceptionApis.save,
            method: apiMethods.post,
            data: data,
        }));
    }


    // ############################################  Freight Category Exceptions  #################################################

    /**
     * Fetches the list of freight category exceptions from the server.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getFreightCategoryExceptions = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightCategoryExceptionApis.list,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Saves the freight category exceptions in the server.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static saveFreightCategoryException = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightCategoryExceptionApis.save,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Removes a list of freight category exceptions in the server.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeFreightCategoryException = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightCategoryExceptionApis.remove,
            method: apiMethods.post,
            data: data,
        }));
    }

    // ############################################  Freight Part Exceptions  #################################################

    /**
     * Fetches the list of freight part exceptions from the server.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getFreightPartExceptions = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightPartExceptionApis.list,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Saves the freight part exceptions in the server.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static saveFreightPartException = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightPartExceptionApis.save,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Removes a list of freight part exceptions in the server.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeFreightPartException = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightPartExceptionApis.remove,
            method: apiMethods.post,
            data: data,
        }));
    }


    // ############################################  Freight Price Level Exceptions  #################################################

    /**
     * Fetches the list of freight price level exceptions from the server.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getFreightPriceLevelExceptions = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightPriceLevelExceptionApis.list,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Saves the freight price level exceptions in the server.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static saveFreightPriceLevelException = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightPriceLevelExceptionApis.save,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Removes a list of freight price level exceptions in the server.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeFreightPriceLevelException = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightPriceLevelExceptionApis.remove,
            method: apiMethods.post,
            data: data,
        }));
    }


    // ############################################  Freight Region Exceptions  #################################################

    /**
     * Fetches the list of freight region exceptions from the server.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getFreightRegionExceptions = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightRegionExceptionApis.list,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Saves the freight region exceptions in the server.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static saveFreightRegionException = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightRegionExceptionApis.save,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Removes a list of freight region exceptions in the server.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeFreightRegionException = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightRegionExceptionApis.remove,
            method: apiMethods.post,
            data: data,
        }));
    }

    // #################################################  Region Rates  ######################################################

    /**
     * Fetches the list of region rates from the server.
     * @param {{keyword?: string}} data
     * @param {import('axios').CancelToken} [cancelToken]
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listRegionRates = async (data, cancelToken = null) => {
        const keyword = encodeURIComponent(data?.keyword ?? '');
        return await apiCallback(Api.prepareRequest({
            url: `${regionRateApis.list}?keyword=${keyword}`,
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Saves a region rate.
     * @param {{originalRegionId: number, originalRegionTitle: string, amount: number}} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static saveRegionRate = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: regionRateApis.save,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Removes region rates by their original region ids.
     * @param {{regionOriginalIds: number[]}} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeRegionRate = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: regionRateApis.remove,
            method: apiMethods.post,
            data: data,
        }));
    }

    // #################################################  Part Rates  ######################################################

    /**
     * Fetches the list of part rates from the server.
     * @param {{keyword?: string}} data
     * @param {import('axios').CancelToken} [cancelToken]
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listPartRates = async (data, cancelToken = null) => {
        const keyword = encodeURIComponent(data?.keyword ?? '');
        return await apiCallback(Api.prepareRequest({
            url: `${freightPartRateApis.list}?keyword=${keyword}`,
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Saves a part rate.
     * @param {{originalPartId: number, partNumber: string, parentCategoryId?: number | null, parentCategoryTitle?: string | null, amount: number}} data
     * @param {boolean} [showErrorToast=true]
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static savePartRate = async (data, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: freightPartRateApis.save,
            method: apiMethods.post,
            data: data,
            showErrorToast: showErrorToast,
        }));
    }

    /**
     * Removes part rates by their original part ids.
     * @param {{partOriginalIds: number[]}} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removePartRate = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightPartRateApis.remove,
            method: apiMethods.post,
            data: data,
        }));
    }


    // ############################################  Freight Company Exceptions  #################################################

    /**
     * Fetches the list of freight company exceptions from the server.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getFreightCompanyExceptions = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightCompanyExceptionApis.list,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Saves the freight company exceptions in the server.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static saveFreightCompanyException = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightCompanyExceptionApis.save,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Removes a list of freight company exceptions in the server.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeFreightCompanyException = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightCompanyExceptionApis.remove,
            method: apiMethods.post,
            data: data,
        }));
    }

    // ############################################  Freight Customer Exceptions  #################################################

    /**
     * Fetches the list of freight customer exceptions from the server.
     * @param cancelToken
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getFreightCustomerExceptions = async (data, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: freightCustomerExceptionApis.list,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Fetches the freight customer exception info from the server.
     * @param {number} customerId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getFreightCustomerExceptionInfo = async (customerId) => {
        return await apiCallback(Api.prepareRequest({
            url: freightCustomerExceptionApis.get(customerId),
            method: apiMethods.get,
            showErrorToast: false,
        }));
    }

    /**
     * Makes a freight customer exception in the server.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static makeFreightCustomerException = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: freightCustomerExceptionApis.add,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Removes a freight customer exception in the server.
     * @param {number} customerExceptionId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeFreightCustomerException = async (customerExceptionId) => {
        return await apiCallback(Api.prepareRequest({
            url: freightCustomerExceptionApis.delete(customerExceptionId),
            method: apiMethods.delete,
        }));
    }

    // ############################################  Free Freight Request  #################################################

    /**
     * Fetches the free freight request info from the server.
     * @param id
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getFreeFreightRequest = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: freeFreightRequestApis.getFreeFreightEligibility(id),
            method: apiMethods.get,
            showErrorToast: false,
        }));
    }

    /**
     * Simulates the free freight request in the server.
     * @param data
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static simulateFreeFreight = async (data, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: freeFreightRequestApis.simulateFreeFreight,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken,
            showErrorToast: false,
        }));
    }


    // ############################################  New Price Matrix  #################################################

    /**
     * Fetches the list of price matrix exceptional customers from the server.
     * @param data
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPriceMatrixExceptionalCustomers = async (data, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: newPriceMatrixApis.exceptionalCustomersList,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken,
        }));
    }


    // ############################################  Biz Print  #################################################

    /**
     * Generates the biz print access token for a given template.
     * @param data  data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static generateBizPrintAccessToken = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: bizPrintTemplateAccessApis.GenerateToken,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Fetches the list of biz print templates from the server.
     * @param pageName         page name
     * @param applicationId    application id
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getBizPrintTemplates = async ({pageName, applicationId}) => {
        return await apiCallback(Api.prepareRequest({
            url: bizPrintTemplateApis.listTemplate(pageName, applicationId),
            method: apiMethods.get,
        }));
    }

    /**
     * Removes the biz print template from the server.
     *
     * @param templateId        template id
     * @param applicationId     application id
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeBizPrintTemplate = async (templateId, applicationId) => {
        return await apiCallback(Api.prepareRequest({
            url: bizPrintTemplateApis.removeTemplate(templateId, applicationId),
            method: apiMethods.delete,
        }));
    }

    /**
     * Duplicate the biz print template from the server.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static duplicateBizPrintTemplate = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: bizPrintTemplateApis.duplicateTemplate,
            data: data,
            method: apiMethods.post,
        }));
    }

    // ############################################  Catalogue  #################################################

    /**
     * Fetches the list of catalogue products from the server.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getCatalogueProducts = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: catalogueApis.getProducts,
            data: data,
            method: apiMethods.post,
        }));
    }


    // ############################################  Partner Printer Hub  #################################################


    /**
     * Fetches the printer hubs of the system
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPrinterHubs = async () => {
        return await apiCallback(Api.prepareRequest({
            url: partnerPrinterHubApis.list,
            method: apiMethods.get,
        }));
    }

    /**
     * Updates a printer hub of the system.
     *
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updatePrinterHub = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: partnerPrinterHubApis.update,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Connects a printer hub to the system.
     *
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static connectPrinterHub = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: printerHubApis.connect,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Disconnects a printer hub from the system.
     *
     * @param {number} id
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static disconnectPrinterHub = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: printerHubApis.disconnect(id),
            method: apiMethods.delete,
        }));
    }

    /**
     * Fetches the application info of the printer hub.
     *
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static gtPrinterHubApplicationInfo = async () => {
        return await apiCallback(Api.prepareRequest({
            url: printerHubApis.getApplicationInfo,
            method: apiMethods.get,
        }));
    }

    /**
     * Fetches the printer hub queues of a specific printer hub.
     *
     * @param {any} data
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPrinterHubQueues = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: printerHubQueueApis.list,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Creates a new printer hub queue.
     *
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createPrinterHubQueue = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: printerHubQueueApis.create,
            method: apiMethods.post,
            data: data,
        }));
    }


    /**
     * Checks the status of printer hub queues.
     *
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static checkStatusOfPrinterHubQueues = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: printerHubQueueApis.checkStatus,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Copies a printer hub queue.
     *
     * @param {any} data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static copyPrinterHubQueue = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: printerHubQueueApis.copy,
            method: apiMethods.post,
            data: data,
        }));
    }


    // ############################################  Tasks  #################################################

    /**
     * Fetches the list of today tasks from the server.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getTodayTaskSummary = async () => {
        return await apiCallback(Api.prepareRequest({
            url: tasksApis.getTodayTaskSummary,
            method: apiMethods.get,
            getHeaders: () => ({
                ApplicationId: CacheService.bizTaskServiceApplicationId,
            }),
        }));
    }

    /**
     * Fetches the list of notes for the provided tags.
     * @param data
     * @param cancelToken
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPageTasksV2 = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: tasksApis.listByTags,
            data: data,
            method: apiMethods.post,
            cancelToken: cancelToken,
            showErrorToast: false,
            getHeaders: () => ({
                ApplicationId: CacheService.bizTaskServiceApplicationId,
            }),
        }));
    }

    /**
     * Fetches my tasks from the server for the given data.
     * @param cancelToken
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getMyTasks = async (data, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: tasksApis.getMyTasks,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken,
            getHeaders: () => ({
                ApplicationId: CacheService.bizTaskServiceApplicationId,
            }),
        }));
    }

    /**
     * Fetches assigned tasks from the server for the given data.
     * @param cancelToken
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getAssignedTasks = async (data, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: tasksApis.getAssignedTasks,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken,
            getHeaders: () => ({
                ApplicationId: CacheService.bizTaskServiceApplicationId,
            }),
        }));
    }


    /**
     * Creates a new task with the provided values.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createTask = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: tasksApis.createTask,
            method: apiMethods.post,
            data: data,
            getHeaders: () => ({
                ApplicationId: CacheService.bizTaskServiceApplicationId,
            }),
        }));
    }

    /**
     * Updates an existing task with the provided values.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateTask = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: tasksApis.updateTask,
            method: apiMethods.put,
            data: data,
            getHeaders: () => ({
                ApplicationId: CacheService.bizTaskServiceApplicationId,
            }),
        }));
    }


    /**
     * Changes the status of a task with the provided values.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static changeTaskStatus = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: tasksApis.changeTaskStatus,
            method: apiMethods.put,
            data: data,
            getHeaders: () => ({
                ApplicationId: CacheService.bizTaskServiceApplicationId,
            }),
        }));
    }

    /**
     * Removes a task assigned with the provided taskId.
     * @param taskId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeTask = async (taskId) => {
        return await apiCallback(Api.prepareRequest({
            url: tasksApis.removeTask(taskId),
            method: apiMethods.delete,
            getHeaders: () => ({
                ApplicationId: CacheService.bizTaskServiceApplicationId,
            }),
        }));
    }

    // ############################################  Task Status  #################################################


    /**
     * Fetches the list of task statuses from the server.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getTaskStatuses = async () => {
        return await apiCallback(Api.prepareRequest({
            url: taskStatusApis.getTaskStatuses,
            method: apiMethods.get,
            getHeaders: () => ({
                ApplicationId: CacheService.bizTaskServiceApplicationId,
            }),
        }));
    }

    /**
     * Creates a new task status with the provided values.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createTaskStatus = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: taskStatusApis.create,
            method: apiMethods.post,
            data: data,
            getHeaders: () => ({
                ApplicationId: CacheService.bizTaskServiceApplicationId,
            }),
        }));
    }
    /**
     * Updates an existing task status with the provided values.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateTaskStatus = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: taskStatusApis.update,
            method: apiMethods.put,
            data: data,
            getHeaders: () => ({
                ApplicationId: CacheService.bizTaskServiceApplicationId,
            }),
        }));
    }

    /**
     * Reorders the task statuses with the provided values.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static reorderTaskStatuses = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: taskStatusApis.reorder,
            method: apiMethods.put,
            data: data,
            getHeaders: () => ({
                ApplicationId: CacheService.bizTaskServiceApplicationId,
            }),
        }));
    }

    /**
     * Removes a task status assigned with the provided taskStatusId.
     * @param taskStatusId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeTaskStatus = async (taskStatusId) => {
        return await apiCallback(Api.prepareRequest({
            url: taskStatusApis.remove(taskStatusId),
            method: apiMethods.delete,
            getHeaders: () => ({
                ApplicationId: CacheService.bizTaskServiceApplicationId,
            }),
        }));
    }

    // ############################################  Reporting Tools  #################################################


    /**
     * Fetches the dynamic columns of the application
     * @param sectionName           section name
     * @param cancelToken           cancel token
     * @return {ApiResponseDs<unknown | null> | undefined}
     */
    static fetchDynamicColumns = async (sectionName, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: reportingToolsApis.get(sectionName),
            cancelToken: cancelToken,
            method: apiMethods.get,
            showErrorToast: false,
        }));
    }

    /**
     * Fetches the dynamic columns of the notes service
     * @param sectionName           section name
     * @param cancelToken           cancel token
     * @return {ApiResponseDs<unknown | null> | undefined}
     */
    static fetchNotesDynamicColumns = async (sectionName, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: reportingToolsApis.getNotes(sectionName),
            cancelToken: cancelToken,
            method: apiMethods.get,
            showErrorToast: false,
            getHeaders: () => ({
                ExternalApplicationId: CacheService.bizNoteServiceApplicationId,
            }),
        }));
    }

    /**
     * Fetches the dynamic columns of the tasks service
     * @param sectionName           section name
     * @param cancelToken           cancel token
     * @return {ApiResponseDs<unknown | null> | undefined}
     */
    static fetchTasksDynamicColumns = async (sectionName, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: reportingToolsApis.geTasks(sectionName),
            cancelToken: cancelToken,
            method: apiMethods.get,
            showErrorToast: false,
            getHeaders: () => ({
                ExternalApplicationId: CacheService.bizTaskServiceApplicationId,
            }),
        }));
    }

    // ############################################  Part Support Vendor Status  #################################################


    /**
     * Fetches the list of part support vendor statuses from the server.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartSupportVendorStatuses = async (cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqVendorStatusApis.list,
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Creates a new part support vendor status with the provided values.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createPartSupportVendorStatus = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqVendorStatusApis.create,
            method: apiMethods.post,
            data: data,
        }));
    }
    /**
     * Updates an existing  part support vendor status with the provided values.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updatePartSupportVendorStatus = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqVendorStatusApis.update,
            method: apiMethods.put,
            data: data,
        }));
    }
    /**
     * Removes a  part support vendor status assigned with the provided taskStatusId.
     * @param id
     * @param replaceId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removePartSupportVendorStatus = async (id, replaceId) => {
        return await apiCallback(Api.prepareRequest({
            url: partSupportReqVendorStatusApis.remove(id, replaceId),
            method: apiMethods.delete,
        }));
    }


    // ############################################  NOTES  #################################################

    /**
     * Fetches the list of notes for the provided tags.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPageNotes = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: notesApis.listByTags,
            data: data,
            method: apiMethods.post,
            showErrorToast: false,
            getHeaders: () => ({
                ExternalApplicationId: CacheService.bizNoteServiceApplicationId,
            }),
        }));
    }

    /**
     * Creates a new note with the provided values.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createNote = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: notesApis.createNote,
            method: apiMethods.post,
            data: data,
            getHeaders: () => ({
                ExternalApplicationId: CacheService.bizNoteServiceApplicationId,
            }),
        }));
    }

    /**
     * Updates an existing note with the provided values.
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateNote = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: notesApis.updateNote,
            method: apiMethods.put,
            data: data,
            getHeaders: () => ({
                ExternalApplicationId: CacheService.bizNoteServiceApplicationId,
            }),
        }));
    }
    /**
     * Removes a note with the provided noteId.
     * @param noteId
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeNote = async (noteId) => {
        return await apiCallback(Api.prepareRequest({
            url: notesApis.removeNote(noteId),
            method: apiMethods.delete,
            getHeaders: () => ({
                ExternalApplicationId: CacheService.bizNoteServiceApplicationId,
            }),
        }));
    }

    // ############################################  UI COMPONENT  #################################################

    /**
     * Fetches the UI components from the server.
     *
     * @param {string} applicationName                                  the name of the application.
     * @param {import('axios').CancelToken | undefined} cancelToken     the cancel token to cancel the request.
     */
    static listUIComponents = async (applicationName, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            method: ApiMethods.get,
            url: uiComponentApis.get.concat(`?applicationName=${applicationName}`),
            cancelToken: cancelToken,
            showErrorToast: false,
        }));
    }

    /**
     * Saves the UI components to the server.
     *
     * @param request           The request to save the UI components.
     * @param {import('axios').CancelToken | undefined} cancelToken     the cancel token to cancel the request.
     */
    static saveUIComponent = async (request, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            method: ApiMethods.post,
            url: uiComponentApis.save,
            cancelToken: cancelToken,
            data: request,
            showErrorToast: false,
        }));
    }

    // ############################################  INDUSTRY  #################################################

    /**
     * Fetches all the industries from the server.
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getAllIndustries = async () => {
        return await apiCallback(Api.prepareRequest({
            url: industryApis.getAllIndustries,
            method: apiMethods.get,
        }));
    }

    /**
     * Fetches the list of industries from the server.
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getPartnerIndustries = async () => {
        return await apiCallback(Api.prepareRequest({
            url: industryApis.listPartnerIndustries,
            method: apiMethods.get,
        }));
    }

    /**
     * Sets the industry as the default industry.
     * @param industryId {number}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static async setIndustryAsDefault(industryId) {
        return await apiCallback(Api.prepareRequest({
            url: industryApis.setDefaultIndustry,
            method: apiMethods.post,
            data: {
                industryId: industryId,
            },
        }));
    }

    /**
     * Sets the industry access.
     * @param industryIds {number[]}
     * @return {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static async setIndustryAccess(industryIds) {
        return await apiCallback(Api.prepareRequest({
            url: industryApis.accessToIndustry,
            method: apiMethods.post,
            data: {
                industryIds: industryIds,
            },
        }));
    }


    // ############################################  NCR Reports  #################################################
    /**
     * Initiates a new NCR report
     * @param data
     * @return {ApiResponseDs<unknown | null> | undefined}
     */
    static initiateNcrReport = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrReportsApis.initiateReport,
            data: data,
            method: apiMethods.post,
        }));
    }

    /**
     * Fetches the list of NCR reports from the server.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static assignNcrReportParts = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrReportsApis.assignParts,
            data: data,
            method: apiMethods.post,
        }))
    }

    /**
     * Assigns the process to the NCR report
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static assignNcrReportProcess = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrReportsApis.assignProcess,
            data: data,
            method: apiMethods.post,
        }))
    }

    /**
     * Check the NCR code duplication
     * @param code
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static checkNcrCodeDuplication = async (code) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrReportsApis.checkCodeDuplication(code),
            method: apiMethods.get,
            showErrorToast: false,
        }));
    }

    /**
     * Fetches the list of NCR reports from the server.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listNcrReports = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrReportsApis.listReports,
            data: data,
            method: apiMethods.post,
            redirectToError: true,
        }));
    }

    /**
     * Updates the NCR report
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateNcrReport = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrReportsApis.updateReport,
            data: data,
            method: apiMethods.put,
        }))
    }

    /**
     * Changes the status of the NCR report
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static changeNcrReportStatus = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrReportsApis.changeReportStatus,
            data: data,
            method: apiMethods.put,
        }))
    }

    /**
     * Fetches the NCR report
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNcrReport = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrReportsApis.getReport(id),
            method: apiMethods.get,
            redirectToError: true,
        }))
    }

    /**
     * Fetches the NCR report
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeNcrReport = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrReportsApis.removeReport(id),
            method: apiMethods.delete,
        }))
    }

    // ############################################  NCR Status  #################################################

    /**
     * Fetches the initial status of the NCR
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNcrInitialStatus = async (showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrStatusApis.getInitialStatus,
            method: apiMethods.get,
            showErrorToast: showErrorToast,
        }));
    }

    /**
     * Fetches the list of NCR statuses
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listNcrStatuses = async () => {
        return await apiCallback(Api.prepareRequest({
            url: ncrStatusApis.list,
            method: apiMethods.get,
        }));
    }

    /**
     * Creates a new NCR status
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createNcrStatus = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrStatusApis.create,
            data: data,
            method: apiMethods.post,
        }));
    }

    /**
     * Updates a NCR status
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateNcrStatus = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrStatusApis.update,
            data: data,
            method: apiMethods.put,
        }));
    }

    /**
     * Changes the status indexes of the NCR statuses.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static changeNcrStatusIndex = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrStatusApis.changeStatusIndexes,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Fetches the related report no of the NCR status
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNcrStatusRelatedReportNo = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrStatusApis.getRelatedReportNo(id),
            method: apiMethods.get,
        }));
    }

    /**
     * Deletes a NCR status
     * @param id
     * @param replaceId
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static deleteNcrStatus = async (id, replaceId) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrStatusApis.delete(id, replaceId),
            method: apiMethods.delete,
        }));
    }

    // ############################################  NCR Action Groups  #################################################

    /**
     * List the NCR action groups
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listNcrActionGroups = async () => {
        return await apiCallback(Api.prepareRequest({
            url: ncrActionGroupsApis.list,
            method: apiMethods.get,
            redirectToError: true,
        }));
    }

    /**
     * creates a new NCR action group
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createNcrActionGroup = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrActionGroupsApis.create,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Updates a NCR action group
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateNcrActionGroup = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrActionGroupsApis.update,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Changes the status indexes of the NCR action groups
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static changeNcrActionGroupIndex = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrActionGroupsApis.changeStatusIndexes,
            method: apiMethods.put,
            data: data,
        }));
    }

    // ############################################  NCR Process  #################################################

    /**
     * Fetches the initial status of the NCR
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listNcrProcesses = async () => {
        return await apiCallback(Api.prepareRequest({
            url: ncrProcessApis.listProcesses,
            method: apiMethods.get,
            redirectToError: true,
        }));
    }

    /**
     * Creates a new NCR process
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createNcrProcess = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrProcessApis.create,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Updates a NCR process
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateNcrProcess = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrProcessApis.update,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Deletes a NCR process
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static deleteNcrProcess = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrProcessApis.delete(id),
            method: apiMethods.delete,
        }));
    }

    // ############################################  NCR Reporting Tools  #################################################

    /**
     * Fetches the dynamic columns of the notes service
     * @param sectionName           section name
     * @param cancelToken           cancel token
     * @return {ApiResponseDs<unknown | null> | undefined}
     */
    static fetchNcrDynamicColumns = async (sectionName, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: reportingToolsApis.getNcr(sectionName),
            cancelToken: cancelToken,
            method: apiMethods.get,
            showErrorToast: false,
        }));
    }

    // ############################################  NCR Settings  #################################################

    /**
     * Fetches the partner settings from the server.
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNcrPartnerSettings = async () => {
        return await apiCallback(Api.prepareRequest({
            url: ncrSettingsApis.getPartnerSettings,
            method: apiMethods.get,
            showErrorToast: false,
            redirectToError: true,
        }));
    }

    /**
     * Updates the partner settings in the server.
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateNcrPartnerSettings = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrSettingsApis.updatePartnerSettings,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Resets the partner settings in the server.
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static resetNcrPartnerSettingsToDefault = async () => {
        return await apiCallback(Api.prepareRequest({
            url: ncrSettingsApis.resetToDefaultPartnerSettings,
            method: apiMethods.post,
        }));
    }

    // ############################################  NCR NTS  #################################################

    /**
     * Creates a new NCR NTS
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createNcrNoteTitleSuggestion = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrNoteTitleSuggestionsApis.create,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Updates a NCR NTS
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateNcrNoteTitleSuggestion = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrNoteTitleSuggestionsApis.update,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Deletes a NCR NTS
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static deleteNcrNoteTitleSuggestion = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: ncrNoteTitleSuggestionsApis.delete(id),
            method: apiMethods.delete,
        }));
    }

    /**
     * Fetches the list of NCR NTS from the server.
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNcrNoteTitleSuggestions = async () => {
        return await apiCallback(Api.prepareRequest({
            url: ncrNoteTitleSuggestionsApis.list,
            method: apiMethods.get,
        }));
    }

    // ############################################  Biz File  #################################################

    /**
     * Submits a file chunk to the server.
     *
     * @param request               The request to upload a file chunk.
     * @param onUploadProgress      The callback that will be called when the upload progress changes.
     * @param abortController       The abort controller that will be used to cancel the request.
     * @returns                     The response from the server.
     */
    static async uploadRemainingChunk(request, onUploadProgress, abortController = undefined) {
        const formData = new FormData();
        formData.append('nextChunk', request.nextChunk, request.nextChunkFileName);
        formData.append('fileId', request.fileId);
        return await apiCallback(Api.prepareRequest({
            method: ApiMethods.post,
            url: bizFileApis.uploadRemainingChunk,
            data: formData,
            onUploadProgress,
            signal: abortController?.signal,
            showErrorToast: false,
        }))
    }

    /**
     * Uploads the initial file chunk to the server.
     *
     * @param request               The argument to upload the initial file chunk.
     * @param onUploadProgress      The callback that will be called when the upload progress changes.
     * @param abortController       The abort controller that will be used to cancel the request.
     * @returns                     The response from the server.
     */
    static async uploadFile(request, onUploadProgress, abortController = undefined) {
        const formData = new FormData();
        formData.append('firstChunk', request.file, request.fileName);
        formData.append('totalFileSize', request.fileSize.toString());
        formData.append('accessLevelId', '3');
        return await apiCallback(Api.prepareRequest({
            method: ApiMethods.post,
            url: bizFileApis.uploadFile,
            data: formData,
            onUploadProgress: onUploadProgress,
            signal: abortController?.signal,
            showErrorToast: false,
        }))
    }

    /**
     * Creates a new BizFile access token.
     *
     * @param token                 The token to create the access token.
     * @param abortController       The abort controller that will be used to cancel the request.
     * @returns                     The response from the server.
     */
    static async createBizFileAccessToken(token, abortController = undefined) {
        return await apiCallback(Api.prepareRequest({
            method: ApiMethods.get,
            url: bizFileApis.createAccessToken,
            signal: abortController?.signal,
            loginRequired: false,
            showErrorToast: false,
            getHeaders: () => ({
                Authorization: token ?? "00000000-0000-0000-0000-000000000000",
            }),
        }));
    }

    /**
     * Creates a new BizFile storage account.
     *
     * @param abortController       The abort controller that will be used to cancel the request.
     * @returns                     The response from the server.
     */
    static async createBizFileStorageAccount(abortController) {
        return await apiCallback(Api.prepareRequest({
            method: ApiMethods.post,
            url: bizFileApis.createStorageAccount,
            signal: abortController?.signal,
        }));
    }

    /**
     * Deletes a file from the server.
     * @param {string} fileId       The id of the file to be deleted.
     */
    static async deleteFile(fileId) {
        return await apiCallback(Api.prepareRequest({
            method: ApiMethods.delete,
            url: bizFileApis.deleteFile(fileId),
        }));
    }

    /**
     * Get BizFile storage account.
     *
     * @param cancelToken       The cancel token that will be used to cancel the request.
     * @returns                 The response from the server.
     */
    static async getBizFileStorageAccount(cancelToken) {
        return await apiCallback(Api.prepareRequest({
            method: ApiMethods.get,
            url: bizFileApis.getStorageAccount,
            cancelToken: cancelToken,
            showErrorToast: false,
        }));
    }

    // ####################################   Sales Tax     ########################################

    /**
     * Creates a new sales tax
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static async createSalesTax(data) {
        return await apiCallback(Api.prepareRequest({
            url: salesTaxApis.createSalesTax,
            data: data,
            method: apiMethods.post,
        }));
    }

    /**
     * Updates a sales tax.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static async updateSalesTax(data) {
        return await apiCallback(Api.prepareRequest({
            url: salesTaxApis.updateSalesTax,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Fetches the list of sales taxes from the server.
     * @param data
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static async getSalesTaxes(data, cancelToken = undefined) {
        return await apiCallback(Api.prepareRequest({
            url: salesTaxApis.salesTaxList,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Adds a sales tax to a province
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addSalesTaxToProvince = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: salesTaxApis.addTaxToProvince,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Updates a sales tax in a province
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateSalesTaxProvince = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: salesTaxApis.updateProvinceTax,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Removes a sales tax from a province
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeSalesTaxFromProvince = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: salesTaxApis.removeProvinceTax(id),
            method: apiMethods.delete,
        }));
    }

    /**
     * Fetches the list of sales taxes from the server.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getProvinceTaxList = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: salesTaxApis.provinceTaxList(id),
            method: apiMethods.post,
        }));
    }


    // ####################################   New Part Category     ########################################

    /**
     * Fetches all the part categories for a given industryId.
     * @param industryId
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getAllPartCategoriesNew = async (industryId, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: newPartCategoryApis.getAllPartCategories(industryId),
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Lists the part categories for a given industryId.
     * @param industryId
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listPartCategoryNew = async (industryId) => {
        return await apiCallback(Api.prepareRequest({
            url: newPartCategoryApis.listPartCategory(industryId),
            method: apiMethods.get,
        }));
    }

    /**
     * Autofills the part categories for a given industryId.
     * @param data
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getCategoryIndustryIds = async (data, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: newPartCategoryApis.getIndustryIds,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Creates a new part category.
     * @param data                  T
     * @param onUploadProgress      The callback that will be called when the upload progress changes.
     * @param abortController       The abort controller that will be used to cancel the request.
     * @param showErrorToast       Whether to show error toast when the request fails.
     * @returns                     The response from the server.
     */
    static createPartCategory = async (data, onUploadProgress, abortController, showErrorToast = true) => {
        const formData = new FormData();
        if (data.backgroundColor) {
            formData.append('backgroundColor', data.backgroundColor.toString());
        }
        formData.append('title', data.title.toString());
        formData.append('parentId', data.parentId?.toString() ?? "");
        formData.append('industryId', data.industryId.toString());
        if (data.firstChunk) {
            formData.append('fileSize', data.fileSize.toString());
            formData.append('fileName', data.fileName?.toString() ?? "");
            formData.append('firstChunk', data.firstChunk, data.fileName);
        }
        return await apiCallback(Api.prepareRequest({
            method: ApiMethods.post,
            url: newPartCategoryApis.createPartCategory,
            data: formData,
            onUploadProgress: onUploadProgress,
            signal: abortController?.signal,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Updates a part category.
     *
     * @param data                  T
     * @param onUploadProgress      The callback that will be called when the upload progress changes.
     * @param abortController       The abort controller that will be used to cancel the request.
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updatePartCategory = async (data, onUploadProgress = undefined, abortController = undefined) => {
        const formData = new FormData();
        formData.append('id', data.id.toString());
        if (data.backgroundColor) {
            formData.append('backgroundColor', data.backgroundColor.toString());
        }
        formData.append('title', data.title.toString());
        formData.append('parentId', data.parentId?.toString() ?? "");
        formData.append('industryId', data.industryId.toString());
        formData.append('updatedProperties', JSON.stringify(data.updatedProperties));
        if (data.firstChunk) {
            formData.append('fileSize', data.fileSize.toString());
            formData.append('fileName', data.fileName?.toString() ?? "");
            formData.append('firstChunk', data.firstChunk, data.fileName);
        }
        return await apiCallback(Api.prepareRequest({
            method: ApiMethods.put,
            url: newPartCategoryApis.updatePartCategory,
            data: formData,
            onUploadProgress: onUploadProgress,
            signal: abortController?.signal,
        }))
    }

    /**
     * Selects a part category.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static selectPartCategory = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: newPartCategoryApis.selectPartCategory,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Un-Selects a part category.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static unselectPartCategory = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: newPartCategoryApis.unSelectPartCategory,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Un-Selects a part category.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removePartCategory = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: newPartCategoryApis.removePartCategory,
            method: apiMethods.post,
            data: data,
        }));
    }

    // ####################################   Industry Property     ########################################

    /**
     * Creates a custom industry property.
     * @param data
     * @param showErrorToast
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createCustomIndustryProperty = async (data, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyApis.createCustomProperty,
            method: apiMethods.post,
            data: data,
            showErrorToast: showErrorToast,
        }));
    }

    /**
     * Updates a custom industry property.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateCustomIndustryProperty = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyApis.updateCustomProperty,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Removes a custom industry property.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removeCustomIndustryProperty = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyApis.removeCustomProperty(id),
            method: apiMethods.delete,
        }));
    }

    /**
     * Fetches the number of related parts we get to
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getIndustryPropertyRelatedPartsCount = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyApis.relatedPartsCount(id),
            method: apiMethods.get,
        }));
    }

    /**
     * Sets the config
     * @param data
     * @param showErrorToast
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setIndustryPropertyConfig = async (data, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyApis.setConfig,
            method: apiMethods.put,
            data: data,
            showErrorToast: showErrorToast,
        }));
    }

    /**
     * Sets the config
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getEligibleIndustryPropertiesByPartIds = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyApis.getEligibleProperties,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Sets the config
     * @param industryId
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getEligibleIndustryPropertiesByIndustryId = async (industryId, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyApis.list(industryId),
            method: apiMethods.post,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Adds a property value to an industry property.
     * @param data
     * @param showErrorToast
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addIndustryPropertyPropertyValue = async (data, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyApis.addPropertyValue,
            method: apiMethods.post,
            data: data,
            showErrorToast: showErrorToast,
        }));
    }

    /**
     * Updates a property value in an industry property.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateIndustryPropertyPropertyValue = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyApis.updatePropertyValue,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Updates a property value in an industry property.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static deleteIndustryPropertyPropertyValue = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyApis.deletePropertyValue,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Lists the property values for an industry property.
     * @param propertyId
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listIndustryPropertyPropertyValues = async (propertyId, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyApis.listPropertyValues(propertyId),
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Auto suggests a value in industry property values.
     * @param data
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static autoSuggestIndustryPropertyValue = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyApis.autoSuggest,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Suggests a new industry property.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static suggestIndustryProperty = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyApis.suggestProperty,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Fetches the extra configs for the industry property.
     *
     * @param industryId
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getIndustryPropertyExtraConfigs = async (industryId, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyApis.getExtraConfigs(industryId),
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Saves the extra configs for the industry property.
     *
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static saveIndustryPropertyExtraConfigs = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyApis.saveExtraConfigs,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Deletes an industry property template.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static deleteIndustryPropertyTemplate = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyTemplateApis.delete(id),
            method: apiMethods.delete,
        }));
    }

    /**
     * Fetches the information of an industry propety template.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getIndustryPropertyTemplate = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyTemplateApis.get(id),
            method: apiMethods.get,
        }));
    }

    /**
     * Sets the properties for an industry property template.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setPropertiesForIndustryPropertyTemplate = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyTemplateApis.setProperties,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Lists the templates for an industry property
     * @param industryId
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listIndustryPropertyTemplate = async (industryId) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyTemplateApis.list(industryId),
            method: apiMethods.get,
        }));
    }

    /**
     * Creates a template for an industry property
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createIndustryPropertyTemplate = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyTemplateApis.create,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Creates a template for an industry property
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateIndustryPropertyTemplate = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: industryPropertyTemplateApis.update,
            method: apiMethods.put,
            data: data,
        }));
    }

    // ####################################   Part Industry Property     ########################################

    /**
     * Adds the properties to a part (without values)
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addPartIndustryProperties = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: partIndustryPropertyApis.addProperties,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Adds an industry property to a part with value. (both the property and their value)
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addPartIndustryProperty = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: partIndustryPropertyApis.addProperty,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Removes a property from a part.
     * @param partIndustryPropertyId
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static removePropertyValueFromPart = async (partIndustryPropertyId) => {
        return await apiCallback(Api.prepareRequest({
            url: partIndustryPropertyApis.removeProperty(partIndustryPropertyId),
            method: apiMethods.delete,
        }));
    }

    /**
     * Removes a property from a part.
     * @param industryPropertyId
     * @param partId
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static clearPropertyFromPart = async (industryPropertyId, partId) => {
        return await apiCallback(Api.prepareRequest({
            url: partIndustryPropertyApis.clearProperty(industryPropertyId, partId),
            method: apiMethods.delete,
        }));
    }

    /**
     * Sets the property value for the selected part.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setPartPropertyValue = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: partIndustryPropertyApis.setPropertyValue,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Sets the property value for the selected part.
     * @param data
     * @param showErrorToast
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setPartPropertyValues = async (data, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: partIndustryPropertyApis.setPropertyValues,
            method: apiMethods.put,
            data: data,
            showErrorToast: showErrorToast,
        }));
    }

    /**
     * Lists the properties of a specific part.
     * @param partId
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listPartProperties = async (partId, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: partIndustryPropertyApis.list(partId),
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }


    // ####################################   Industry Group Property     ########################################

    /**
     * Queries the industry group properties.
     * @param data
     * @param cncelToken
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static queryIndustryGroupProperties = async (data, cncelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: industryGroupPropertyApis.query,
            method: apiMethods.post,
            data: data,
            cncelToken: cncelToken,
        }));
    }

    /**
     * Lists the industry group properties.
     * @param industryId
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listIndustryGroupProperties = async (industryId, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: industryGroupPropertyApis.list(industryId),
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Lists the industry group properties.
     * @param industryGroupPropertyId
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listIndustryGroupPropertiesAttrs = async (industryGroupPropertyId, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: industryGroupPropertyApis.listAttrs(industryGroupPropertyId),
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }

    /**
     * insert the industry group property.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static insertIndustryGroupProperty = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: industryGroupPropertyApis.insert,
            method: apiMethods.post,
            data: data,
        }));
    }

    // ####################################   Nexus Search     ########################################

    /**
     * Fetches the base structure of the nexus search.
     * @param industryId
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNexusSearchBaseStructure = async (industryId) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchApis.getBaseStructure(industryId),
            method: apiMethods.get,
        }));
    }

    /**
     * Fetches the search results from the nexus search.
     * @param data
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNexusSearchSuggestion = async (data, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchApis.getSuggestion,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken,
            showErrorToast: false,
        }));
    }

    /**
     * Performs a search in the nexus search.
     * @param data
     * @param cancelToken
     * @param onErrorCallback
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static nexusSearch = async (data, cancelToken, onErrorCallback) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchApis.search,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken,
            unAuthorizedCallback: onErrorCallback,
            accessDeniedCallback: onErrorCallback,
        }));
    }

    /**
     * Performs a search in the nexus search.
     * @param data
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static nexusSearchProductsList = async (data, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchApis.partInformationSearch,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Submits a click in the nexus search.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static submitNexusSearchClick = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchApis.submitClick,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Submits a lost search in the nexus search.
     * @param searchToken
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNexusSearchLog = async (searchToken, cancelToken) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchApis.getSearchLog(searchToken),
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Submits a lost search in the nexus search.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static submitLostNexusSearch = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchApis.submitLostSearch,
            method: apiMethods.post,
            data: data,
        }));
    }

    // ####################################   Part Code Category     ########################################

    /**
     * Creates a new part code category.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createPartCodeCategory = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: partCodeCategoryApis.create,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Updates a part code category.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updatePartCodeCategory = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: partCodeCategoryApis.update,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Deletes a part code category.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static deletePartCodeCategory = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: partCodeCategoryApis.delete(id),
            method: apiMethods.delete,
        }));
    }

    /**
     * Lists the part code categories.
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listPartCodeCategories = async () => {
        return await apiCallback(Api.prepareRequest({
            url: partCodeCategoryApis.list,
            method: apiMethods.get,
        }));
    }

    /**
     * Reactivates a part code category.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static reActivatePartCodeCategory = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: partCodeCategoryApis.reActivate,
            method: apiMethods.post,
            data: {id: id},
        }));
    }

    // ####################################   Part Code Value     ########################################

    /**
     * Creates a new part code value.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createPartCodeValue = async (data, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: partCodeValueApis.create,
            method: apiMethods.post,
            data: data,
            showErrorToast: showErrorToast,
        }));
    }

    /**
     * Updates a part code value.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updatePartCodeValue = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: partCodeValueApis.update,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Deletes a part code value.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static deletePartCodeValue = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: partCodeValueApis.delete(id),
            method: apiMethods.delete,
        }));
    }

    /**
     * Lists the part code values for edit purposes
     * @param partId
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listPartCodeValuesForEdit = async (partId) => {
        return await apiCallback(Api.prepareRequest({
            url: partCodeValueApis.editViewList(partId),
            method: apiMethods.get,
        }));
    }

    /**
     * Lists the part code values for part info purposes
     * @param partId
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listPartCodeValuesForView = async (partId) => {
        return await apiCallback(Api.prepareRequest({
            url: partCodeValueApis.partInfoList(partId),
            method: apiMethods.get,
        }));
    }

    // ####################################   Part Group Industry Property     ########################################

    /**
     * Adds a group property to a part.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addPartIndustryGroupProperty = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: partGroupIndustryPropertyApis.addGroupProperty,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Deletes a group property from a part.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static deletePartIndustryGroupProperty = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: partGroupIndustryPropertyApis.delete(id),
            method: apiMethods.delete,
        }));
    }

    /**
     * Lists the group properties for a part.
     * @param industryGroupPropertyId
     * @param partId
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listPartIndustryGroupProperties = async (industryGroupPropertyId, partId, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: partGroupIndustryPropertyApis.list(industryGroupPropertyId, partId),
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }

    // ####################################   Partner Connection     ########################################

    /**
     * Sends a seller request to a buyer.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static partnerConnectionSendSellerRequest = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: PartnerConnectionApis.sendSellerRequest,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Lists the sellers for a buyer.
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static partnerConnectionSellersList = async () => {
        return await apiCallback(Api.prepareRequest({
            url: PartnerConnectionApis.sellersList,
            method: apiMethods.get,
        }));
    }

    /**
     * Lists the buyers for a seller.
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static partnerConnectionBuyersList = async () => {
        return await apiCallback(Api.prepareRequest({
            url: PartnerConnectionApis.buyersList,
            method: apiMethods.get,
        }));
    }

    /**
     * Accepts a seller request.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static partnerConnectionAcceptSellerRequest = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: PartnerConnectionApis.acceptSellerRequest,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Replaces a vendor.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static partnerConnectionReplaceVendor = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: PartnerConnectionApis.replaceVendor,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Replaces a customer.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static partnerConnectionReplaceCustomer = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: PartnerConnectionApis.replaceCustomer,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Updates the seller config.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static partnerConnectionUpdateSellerConfig = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: PartnerConnectionApis.updateSellerConfig,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Fetches the partners and warehouses.
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static partnerConnectionGetPartnersAndWarehouses = async () => {
        return await apiCallback(Api.prepareRequest({
            url: PartnerConnectionApis.getPartnersAndWarehouses,
            method: apiMethods.get,
        }));
    }

    // ####################################   AMIN     ########################################


    /**
     * Fetches the admin settings.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static importPartsWithAI = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: adminApis.getParts,
            method: apiMethods.post,
            data: data,
        }));
    }


    // ####################################   Price Level     ########################################

    /**
     * Lists the price level Title Dictionary.
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static listPriceLevelTitleDictionary = async () => {
        return await apiCallback(Api.prepareRequest({
            url: priceLevelApis.listTitleDictionary,
            method: apiMethods.get,
        }));
    }


    /**
     * Lists the price level Title Dictionary.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static savePriceLevelTitleDictionary = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: priceLevelApis.saveTitleDictionary,
            method: apiMethods.post,
            data: data,
        }));
    }

    // ############################################  CUSTOMER V2  #################################################

    /**
     * Fetches the customers for the specified keywords.
     * @param keywords
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static autoCompleteCustomersV2 = async (keywords, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: customerV2Apis.autoComplete(keywords),
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Fetches the list of customers for the provided data.
     * @param data
     * @param cancelToken
     * @param onErrorCallback
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static searchCustomersV2 = async (data, cancelToken, onErrorCallback) => {
        return await apiCallback(Api.prepareRequest({
            url: customerV2Apis.search,
            data: data,
            method: apiMethods.post,
            cancelToken: cancelToken,
            unAuthorizedCallback: onErrorCallback,
            accessDeniedCallback: onErrorCallback,
        }));
    }

    /**
     * Fetches the customer simple info by id.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static getCustomerSimpleInfoById = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: customerV2Apis.simpleGetById(id),
            method: apiMethods.get,
        }));
    }

    /**
     * Fetches the customer simple info by code
     * @param code
     * @param showErrorToast
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static getCustomerSimpleInfoByCode = async (code, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: customerV2Apis.simpleGetByCode(code),
            method: apiMethods.get,
            showErrorToast: showErrorToast,
        }));
    }

    /**
     * Fetches the customer's price levels list.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static getCustomerPriceLevels = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: customerV2Apis.getPriceLevels(id),
            method: apiMethods.get,
        }));
    }

    /**
     * Fetches the customer's full information.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static getCustomerFullInformation = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: customerV2Apis.getFullInfo(id),
            method: apiMethods.get,
            redirectToError: true,
        }));
    }

    /**
     * Creates a new customer.
     * @param data
     * @param hideToasts
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static createCustomer = async (data, hideToasts = false) => {
        return await apiCallback(Api.prepareRequest({
            url: customerV2Apis.create,
            data: data,
            method: apiMethods.post,
            ...(hideToasts ? {
                showErrorToast: false,
                showSuccessToast: false,
            } : {})
        }));
    }

    /**
     * Updates the owner of a customer.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static updateCustomerOwner = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: customerV2Apis.updateCustomerOwner,
            data: data,
            method: apiMethods.post,
        }));
    }

    /**
     * Removes a customer.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static removeCustomer = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: customerV2Apis.removeCustomer(id),
            method: apiMethods.delete,
        }));
    }

    /**
     * Lists the account managers and territories.
     *
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static listCustomersAccountManagersAndTerritories = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: customerV2Apis.listAccountManagersAndTerritories,
            data: data,
            method: apiMethods.post,
        }));
    }

    /**
     * Imports and updates customer owners in bulk.
     * @param data
     * @param showErrorToast
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static importUpdateCustomerOwner = async (data, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: customerV2Apis.importUpdateCustomerOwner,
            data: data,
            method: apiMethods.post,
            showErrorToast: showErrorToast,
        }));
    }


    /**
     * Fetches the list of external customers
     * @param data
     * @param cancelToken
     * @param showErrorToast
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static externalCustomerAutoFill = async (data, cancelToken = undefined, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: customerV2Apis.externalCustomerAutoFill,
            data: data,
            cancelToken: cancelToken,
            method: apiMethods.post,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Imports customers from external sources.
     * @param data
     * @param showErrorToast
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static importCustomerFromExternal = async (data, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: customerV2Apis.importCustomerFromExternal,
            data: data,
            method: apiMethods.post,
            showErrorToast: showErrorToast,
        }))
    }

    /**
     * Fetches the addresses v2 for the customer
     * @param customerId
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static getCustomerAddressesV2 = async (customerId) => {
        return await apiCallback(Api.prepareRequest({
            url: customerV2Apis.getAddresses(customerId),
            method: apiMethods.get,
        }));
    }

    /**
     * Updates an address v2 for the customer.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static updateCustomerAddressV2 = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: customerV2Apis.updateAddress,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Sets a default address v2 for the customer.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static setDefaultCustomerAddressV2 = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: customerV2Apis.setDefaultAddress,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Updates the tax information for a customer address.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static updateCustomerAddressTaxV2 = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: customerV2Apis.updateAddressTax,
            method: apiMethods.post,
            data: data,
        }));
    }

    //createCustomerAddressV2

    /**
     * Creates a new address v2 for the customer.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static createCustomerAddressV2 = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: customerV2Apis.createAddress,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Deletes a customer address v2.
     * @param customerId
     * @param addressId
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static deleteCustomerAddressV2 = async (customerId, addressId) => {
        return await apiCallback(Api.prepareRequest({
            url: customerV2Apis.deleteAddress(customerId, addressId),
            method: apiMethods.delete,
        }));
    }

/**
     * Removes a customer member from the customer.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static removeCustomerMembers = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: customerV2Apis.removeUsers,
            method: apiMethods.post,
            data: data,
        }));
    }


    // ############################################  ACCESS LEVELS  #################################################

    /**
     * Fetches the access levels of the current operator
     * @return {Promise<ApiResponseDs<AccessLevelPackages | null>|undefined>}
     */
    static getCurrentOperatorAccessLevels = async (partnerId, userId) => {
        // TODO: call api to get operator access levels;
        /**@type {ApiResponseDs<AccessLevelPackages | null>}*/
        return {
            resultFlag: true,
            data: AccessLevelDataByPartnerId(partnerId, userId),
        }
    }

    // ############################################  NEXUS SEARCH CONFIGURATIONS  #################################################

    /**
     * Fetches the nexus search configurations.
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNexusSearchConfigurations = async () => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchApis.getConfig,
            method: apiMethods.get,
        }));
    }

    /**
     * Updates the nexus search configurations.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateNexusSearchConfig = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchApis.saveConfig,
            method: apiMethods.put,
            data: data,
        }));
    }


    // ############################################  NEXUS SEARCH REPORT  #################################################

    /**
     * Fetches the general chart for the nexus search.
     *
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNexusSearchReportGeneralChart = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchReportApis.getNexusGeneralChart,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken
        }));
    }

    /**
     * Fetches the top queries for the nexus search.
     *
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNexusSearchReportTopQueries = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchReportApis.getTopQueries,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken
        }));
    }

    /**
     * Fetches the top queries with results for the nexus search.
     *
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNexusSearchReportTopQueriesWithResult = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchReportApis.getTopQueriesWithResult,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken
        }));
    }

    /**
     * Fetches the top queries lead to click for the nexus search.
     *
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNexusSearchReportTopQueriesLead2Click = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchReportApis.getTopQueriesLead2Click,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken
        }));
    }

    /**
     * Fetches the top queries without results for the nexus search.
     *
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNexusSearchReportTopQueriesWithoutResult = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchReportApis.getTopQueriesWithoutResult,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken
        }));
    }

    /**
     * Fetches the top clicked products for the nexus search.
     *
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNexusSearchReportTopClickedProducts = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchReportApis.getTopClickedProducts,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken
        }));
    }

    /**
     * Fetches the top customers with high search for the nexus search.
     *
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNexusSearchReportTopCustomerHighSearch = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchReportApis.getTopCustomerHighSearch,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken
        }));
    }

    /**
     * Fetches the top customers with high clicks for the nexus search.
     *
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNexusSearchReportTopCustomerHighClick = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchReportApis.getTopCustomerHighClick,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken
        }));
    }

    /**
     * Fetches the top customers with high QC ratio for the nexus search.
     *
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNexusSearchReportTopCustomerHighQCRatio = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchReportApis.getTopCustomerHighQCRatio,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken
        }));
    }

    /**
     * Fetches the top operators with high search for the nexus search.
     *
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNexusSearchReportTopOperatorsHighSearch = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchReportApis.getTopOperatorsHighSearch,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken
        }));
    }

    /**
     * Fetches the top operators with high QC ratio for the nexus search.
     *
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNexusSearchReportTopOperatorsHighQCRatio = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchReportApis.getTopOperatorsHighQCRatio,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken
        }));
    }

    /**
     * Fetches the nexus logs for the nexus search.
     *
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getNexusSearchReportNexusLogs = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchReportApis.getNexusLogs,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken
        }));
    }

    /**
     * Toggles the review status of a nexus log.
     *
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static toggleNexusLogReview = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchReportApis.toggleNexusLogReview,
            method: apiMethods.post,
            data: data,
        }))
    }

    /**
     * Updates the review note of a nexus log.
     *
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateNexusLogReviewNote = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchReportApis.updateNexusLogReviewNote,
            method: apiMethods.post,
            data: data,
        }));
    }


    /**
     * Connects a nexus search to a customer.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static connectNexusSearchToCustomer = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchApis.connectToCustomer,
            method: apiMethods.put,
            data: data
        }));
    }

    /**
     * Connects a nexus search to an order.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static connectNexusSearchToOrder = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: nexusSearchApis.connectToOrder,
            method: apiMethods.put,
            data: data
        }));
    }

    // ############################################  LOST SALES  #################################################

    /**
     * Get top reported products in lost sales by quantity
     * @param {Object} data - Request data containing period and filters
     * @param {CancelToken} [cancelToken] - Optional cancel token for the request
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getLostSalesTopReportedProductsByQty = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: lostSalesApis.getTopReportedProductsByQty,
            method: apiMethods.post,
            data,
            cancelToken
        }));
    }

    /**
     * Get top reported products in lost sales by value
     * @param {Object} data - Request data containing period and filters
     * @param {CancelToken} [cancelToken] - Optional cancel token for the request
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getLostSalesTopReportedProductsByValue = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: lostSalesApis.getTopReportedProductsByValue,
            method: apiMethods.post,
            data,
            cancelToken
        }));
    }

    /**
     * Get top reported customers in lost sales by quantity
     * @param {Object} data - Request data containing period and filters
     * @param {CancelToken} [cancelToken] - Optional cancel token for the request
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getLostSalesTopReportedCustomersByQty = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: lostSalesApis.getTopReportedCustomersByQty,
            method: apiMethods.post,
            data,
            cancelToken
        }));
    }

    /**
     * Get top reported customers in lost sales by value
     * @param {Object} data - Request data containing period and filters
     * @param {CancelToken} [cancelToken] - Optional cancel token for the request
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getLostSalesTopReportedCustomersByValue = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: lostSalesApis.getTopReportedCustomersByValue,
            method: apiMethods.post,
            data,
            cancelToken
        }));
    }

    /**
     * Get top reported operators in lost sales by request count
     * @param {Object} data - Request data containing period and filters
     * @param {CancelToken} [cancelToken] - Optional cancel token for the request
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getLostSalesTopReportedOperatorsByRequest = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: lostSalesApis.getTopReportedOperatorsByRequest,
            method: apiMethods.post,
            data,
            cancelToken
        }));
    }

    /**
     * Get lost sales chart data
     * @param {Object} data - Request data containing period and filters
     * @param {CancelToken} [cancelToken] - Optional cancel token for the request
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getLostSalesChart = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: lostSalesApis.getLostSalesChart,
            method: apiMethods.post,
            data,
            cancelToken
        }));
    }

    /**
     * Get paginated list of lost sales reports
     * @param {Object} data - Request data containing sortBy, pagination, and filters
     * @param {CancelToken} [cancelToken] - Optional cancel token for the request
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listReportedLostSales = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: lostSalesApis.listReportedLostSales,
            method: apiMethods.post,
            data,
            cancelToken
        }));
    }

    /**
     * Toggle the checked status of a lost sale report
     * @param {number} id - The ID of the lost sale report to toggle
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static toggleReportLostSaleCheck = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: lostSalesApis.toggleReportLostSaleCheck,
            method: apiMethods.post,
            data: {id}
        }));
    }


    // ############################################  Export  #################################################

    /**
     * Toggle the checked status of a lost sale report
     * @param {any} data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static exportSalesTax = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: exportApis.exportSalesTax,
            method: apiMethods.post,
            data: data,
        }));
    }

    // ############################################  Custom Dashboard  #################################################

    /**
     * Fetches the custom dashboard widgets.
     *
     * @param {CancelToken=} cancelToken - Optional cancel token for the request
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static loadCustomDashboardWidgetData = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: customDashboardApis.loadWidgetData,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Deletes a custom dashboard.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static deleteCustomDashboard = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: customDashboardApis.deleteDashboard(id),
            method: apiMethods.delete,
        }));
    }

    /**
     * Fetches all available widgets for the custom dashboard.
     *
     * @param {CancelToken=} cancelToken - Optional cancel token for the request
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static getCustomDashboardsAllWidgets = async (cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: customDashboardApis.allWidgets,
            method: apiMethods.get,
            cancelToken: cancelToken
        }));
    }

    /**
     * Sets the default dashboard for the user.
     *
     * @param {any} data - The data containing the dashboard ID to set as default.
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static setDefaultCustomDashboard = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: customDashboardApis.setDefaultDashboard,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Updates the UI data for a custom dashboard.
     *
     * @param {any} data - The data containing the updated UI information.
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static updateCustomDashboardUIData = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: customDashboardApis.updateUIData,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Sets the groups for a custom dashboard.
     *
     * @param {any} data - The data containing the group information.
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static setCustomDashboardGroups = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: customDashboardApis.setGroups,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Creates a new custom dashboard.
     *
     * @param {any} data - The data containing the new dashboard information.
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static createCustomDashboard = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: customDashboardApis.create,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Updates an existing custom dashboard.
     *
     * @param {any} data - The data containing the updated dashboard information.
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static updateCustomDashboard = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: customDashboardApis.update,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Fetches the list of custom dashboards.
     *
     * @param {CancelToken=} cancelToken - Optional cancel token for the request
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static listCustomDashboards = async (cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: customDashboardApis.list,
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Adds a new widget to the custom dashboard.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static addCustomDashboardWidget = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: customDashboardApis.addWidget,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Updates an existing widget on the custom dashboard.
     *
     * @param data
     * @return {Promise<ApiResponseDs<unknown | null>>}
     */
    static updateCustomDashboardWidget = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: customDashboardApis.updateWidget,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Removes a widget from the custom dashboard.
     *
     * @param id
     * @return {Promise<ApiResponseDs<unknown | null>>}
     */
    static removeCustomDashboardWidget = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: customDashboardApis.removeWidget(id),
            method: apiMethods.delete,
        }));
    }

    // ############################################  VIN  #################################################

    /**
     * Decodes a VIN (Vehicle Identification Number).
     *
     * @param vin
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static decodeVin = async (vin, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: vinApis.decode(vin),
            method: apiMethods.get,
            cancelToken: cancelToken,
            showErrorToast: false,
        }));
    }

    /**
     * Fetches the purchase ETA for a specific part.
     * @param partNo
     * @param warehouseCode
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async getPurchasesETAForPart({partNo, warehouseCode}, cancelToken) {
        return await apiCallback(Api.prepareRequest({
            url: purchaseApis.getETAForPart(partNo, warehouseCode),
            method: apiMethods.get,
            cancelToken: cancelToken,
            showErrorToast: false,
        }));
    }


    /**
     * Fetches the purchasing key for planning purposes.
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async getPurchasingKeyForPlanning() {
        return await apiCallback(Api.prepareRequest({
            url: purchaseApis.getPurchasingKeyForPlanning,
            method: apiMethods.get,
            showErrorToast: false,
        }));
    }

    /**
     * Updates the ETA information for a specific part.
     * @param {Object} data - The data containing part number, warehouse code, and ETA information.
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async updatePurchaseETAInfo(data) {
        return await apiCallback(Api.prepareRequest({
            url: purchaseApis.updateETAInfo,
            method: apiMethods.put,
            data: data,
        }));
    }

    // ############################################  NEW SALES PERSON  #################################################

    /**
     * Lists the sales persons based on a keyword.
     * @param keyword
     * @param cancelToken
     * @param showErrorToast
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async listSalesPersons(keyword, cancelToken = undefined, showErrorToast = true) {
        return await apiCallback(Api.prepareRequest({
            url: newSalesPersonApis.listSalesPerson(keyword),
            method: apiMethods.get,
            cancelToken: cancelToken,
            showErrorToast: showErrorToast,
        }));
    }

    /**
     * Gets the sales person information by ID.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async grantSalesPersonWarehouseAccess(data) {
        return await apiCallback(Api.prepareRequest({
            url: newSalesPersonApis.grantWarehouseAccess,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Deletes a sales person information.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async deleteSalesPersonInformation(id) {
        return await apiCallback(Api.prepareRequest({
            url: newSalesPersonApis.delete(id),
            method: apiMethods.delete,
        }));
    }

    /**
     * Updates the sales person information.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async updateSalesPersonConfig(data) {
        return await apiCallback(Api.prepareRequest({
            url: newSalesPersonApis.updateConfig,
            method: apiMethods.put,
            data: data,
        }));
    }

    // ############################################  Territory  #################################################

    // list
    /**
     * Lists the territories of the app.
     * @param request
     * @param cancelToken
     * @param showErrorToast
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async listTerritories(request, cancelToken, showErrorToast = true) {
        return await apiCallback(Api.prepareRequest({
            url: territoryApis.list,
            method: apiMethods.post,
            data: request,
            cancelToken: cancelToken,
            showErrorToast: showErrorToast,
        }));
    }

    // create
    /**
     * Creates a new territory.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async createTerritory(data) {
        return await apiCallback(Api.prepareRequest({
            url: territoryApis.create,
            method: apiMethods.post,
            data: data,
        }));
    }

    // udpdate
    /**
     * Updates an existing territory.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async updateTerritory(data) {
        return await apiCallback(Api.prepareRequest({
            url: territoryApis.update,
            method: apiMethods.put,
            data: data,
        }));
    }

    // delete
    /**
     * Deletes a territory.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async deleteTerritory(id) {
        return await apiCallback(Api.prepareRequest({
            url: territoryApis.delete,
            method: apiMethods.delete,
            data: {id}
        }));
    }

    // ############################################  Part Warehouse  #################################################

    /**
     * Gets the reorder report for part warehouses.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async partWarehouseReorderReport(data) {
        return await apiCallback(Api.prepareRequest({
            url: partWarehouseApis.reOrderReport,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Updates the part warehouse information.
     * @param data
     * @param showErrorToast
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async updatePartWarehouse(data, showErrorToast = true) {
        return await apiCallback(Api.prepareRequest({
            url: partWarehouseApis.updatePartWarehouse,
            method: apiMethods.put,
            data: data,
            showErrorToast: showErrorToast,
        }));
    }

    /**
     * Gets the part warehouse information for a specific part.
     * @param partId
     * @returns {ApiResponseDs<unknown | null>}
     */
    static async getPartWarehouseInformationForPart(partId) {
        return await apiCallback(Api.prepareRequest({
            url: partWarehouseApis.getForPart(partId),
            method: apiMethods.get,
        }));
    }

    // ############################################ Order Dimensions  #################################################

    /**
     * Gets the list of order dimensions.
     *
     * @param data
     * @param cancelToken
     * @param showErrorToast
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async getOrderDimensionsList(data, cancelToken = undefined, showErrorToast = true) {
        return await apiCallback(Api.prepareRequest({
            url: orderDimensionApis.list,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken,
            showErrorToast: showErrorToast,
        }));
    }

    /**
     * Creates a new order dimension.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async createOrderDimension(data) {
        return await apiCallback(Api.prepareRequest({
            url: orderDimensionApis.create,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Updates an existing order dimension.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async updateOrderDimension(data) {
        return await apiCallback(Api.prepareRequest({
            url: orderDimensionApis.update,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Deletes an existing order dimension.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async deleteOrderDimension(data) {
        return await apiCallback(Api.prepareRequest({
            url: orderDimensionApis.delete,
            method: apiMethods.post,
            data: data,
        }));
    }

    // ############################################ Order Pallet  #################################################

    /**
     * Gets the list of order pallets.
     *
     * @param data
     * @param cancelToken
     * @param showErrorToast
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async getOrderPalletsList(data, cancelToken = undefined, showErrorToast = true) {
        return await apiCallback(Api.prepareRequest({
            url: orderPalletApis.list,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken,
            showErrorToast: showErrorToast,
        }));
    }

    /**
     * Creates a new order pallet.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async createOrderPallet(data) {
        return await apiCallback(Api.prepareRequest({
            url: orderPalletApis.create,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Updates an existing order pallet.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async updateOrderPallet(data) {
        return await apiCallback(Api.prepareRequest({
            url: orderPalletApis.update,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Deletes an order pallet.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async deleteOrderPallet(data) {
        return await apiCallback(Api.prepareRequest({
            url: orderPalletApis.delete,
            method: apiMethods.delete,
            data: data,
        }));
    }

    // ############################################ Part Size  #################################################

    /**
     * Gets the list of part sizes for a specific part.
     * @param partId
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async getPartSizesList(partId, cancelToken = undefined) {
        return await apiCallback(Api.prepareRequest({
            url: partSizeApis.list(partId),
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Creates a new part size.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async createPartSize(data) {
        return await apiCallback(Api.prepareRequest({
            url: partSizeApis.create,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Updates an existing part size.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async updatePartSize(data) {
        return await apiCallback(Api.prepareRequest({
            url: partSizeApis.update,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Deletes a part size.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async deletePartSize(data) {
        return await apiCallback(Api.prepareRequest({
            url: partSizeApis.delete,
            method: apiMethods.delete,
            data: data,
        }));
    }

    /**
     * Sets the part sizes for a specific part.
     * @param data
     * @param showErrorToast
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static async setPartSizes(data, showErrorToast = true) {
        return await apiCallback(Api.prepareRequest({
            url: partSizeApis.setPartSizes,
            method: apiMethods.post,
            data: data,
            showErrorToast: showErrorToast,
        }));
    }

    // ############################################ Vendor Part  #################################################


    /**
     * Lists the vendor parts based on the provided criteria.
     * @param data
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null> | undefined>}
     */
    static listVendorParts(data, cancelToken = undefined) {
        return apiCallback(Api.prepareRequest({
            url: vendorPartApis.list,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Gets the list of vendors for a specific part number.
     *
     * @param data
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>>}
     */
    static getVendorsByPartNumber(data, cancelToken = undefined) {
        return apiCallback(Api.prepareRequest({
            url: vendorPartApis.getVendorsByPartNumber,
            method: apiMethods.post,
            data: data,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Creates a new vendor part association.
     * @param data
     * @param showErrorToast
     * @returns {Promise<ApiResponseDs<unknown | null> | undefined>}
     */
    static createVendorPart(data, showErrorToast = true) {
        return apiCallback(Api.prepareRequest({
            url: vendorPartApis.create,
            method: apiMethods.post,
            data: data,
            showErrorToast: showErrorToast,
        }));
    }

    /**
     * Updates an existing vendor part association.
     * @param data
     * @param showErrorToast
     * @returns {Promise<ApiResponseDs<unknown | null> | undefined>}
     */
    static updateVendorPart(data, showErrorToast = true) {
        return apiCallback(Api.prepareRequest({
            url: vendorPartApis.update,
            method: apiMethods.put,
            data: data,
            showErrorToast: showErrorToast,
        }));
    }

    /**
     * Deletes a vendor part association.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null> | undefined>}
     */
    static deleteVendorPart(id) {
        return apiCallback(Api.prepareRequest({
            url: vendorPartApis.delete(id),
            method: apiMethods.delete,
        }));
    }

    //  ############################################## Price Formula  #################################################

    /**
     * Lists the price formula templates based on the provided criteria.
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null> | undefined>}
     */
    static listPriceFormulaTemplates(cancelToken = undefined) {
        return apiCallback(Api.prepareRequest({
            url: priceFormulaApis.listTemplates,
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Gets the details of a specific price formula template by its ID.
     * @param id
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null> | undefined>}
     */
    static getPriceFormulaTemplate(id, cancelToken = undefined) {
        return apiCallback(Api.prepareRequest({
            url: priceFormulaApis.getTemplate(id),
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Creates a new price formula template with the provided data.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null> | undefined>}
     */
    static createPriceFormulaTemplate(data) {
        return apiCallback(Api.prepareRequest({
            url: priceFormulaApis.createTemplate,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Updates an existing price formula template with the provided data.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null> | undefined>}
     */
    static updatePriceFormulaTemplate(data) {
        return apiCallback(Api.prepareRequest({
            url: priceFormulaApis.updateTemplate,
            method: apiMethods.put,
            data: data,
        }));
    }

    /**
     * Sets the formula list for a formula template.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null> | undefined>}
     */
    static setPriceFormulaTemplateItems(data) {
        return apiCallback(Api.prepareRequest({
            url: priceFormulaApis.setTemplateItems,
            method: apiMethods.post,
            data: data,
        }));
    }

    /**
     * Deletes a price formula template by its ID.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null> | undefined>}
     */
    static deletePriceFormulaTemplate(id) {
        return apiCallback(Api.prepareRequest({
            url: priceFormulaApis.deleteTemplate(id),
            method: apiMethods.delete,
        }));
    }

    /**
     * Gets the list of currently used price formulas associated with a specific product (part) by its ID.
     * @param partId
     * @param cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null> | undefined>}
     */
    static getProductPriceFormulas(partId, cancelToken = undefined) {
        return apiCallback(Api.prepareRequest({
            url: priceFormulaApis.getProductFormulas(partId),
            method: apiMethods.get,
            cancelToken: cancelToken,
        }));
    }

    /**
     * Sets the price formulas for a specific product (part) with the provided data.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null> | undefined>}
     */
    static setProductPriceFormulas(data) {
        return apiCallback(Api.prepareRequest({
            url: priceFormulaApis.setProductFormulas,
            method: apiMethods.put,
            data: data,
        }));
    }

    // ############################################  CleanAF Vendor V2  #################################################

    /**
     * Lists vendors from the local SpireVendor cache.
     * @param data
     * @param {import('axios').CancelToken} cancelToken
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listVendorsV2 = async (data, cancelToken = undefined) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.list,
            method: apiMethods.post,
            data,
            cancelToken,
        }));
    }

    /**
     * Gets a vendor by local id.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getVendorV2 = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.get(id),
            method: apiMethods.get,
        }));
    }

    /**
     * Creates a vendor in Spire and local cache.
     * @param data
     * @param hideToasts
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static createVendorV2 = async (data, hideToasts = false) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.create,
            method: apiMethods.post,
            data,
            ...(hideToasts ? {showErrorToast: false, showSuccessToast: false} : {}),
        }));
    }

    /**
     * Imports a vendor from Spire by vendor code.
     * @param data {{code: string}}
     * @param showErrorToast
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static importVendorFromExternalService = async (data, showErrorToast = true) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.import,
            method: apiMethods.post,
            data,
            showErrorToast,
        }));
    }

    /**
     * Partially updates a vendor.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateVendorV2 = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.update,
            method: apiMethods.put,
            data,
        }));
    }

    /**
     * Changes vendor status.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static changeVendorStatus = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.changeStatus,
            method: apiMethods.put,
            data,
        }));
    }

    /**
     * Soft-deactivates a vendor.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static deactivateVendor = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.deactivate(id),
            method: apiMethods.delete,
        }));
    }

    /**
     * Gets vendor billing and shipping addresses.
     * @param vendorId
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getVendorAddresses = async (vendorId) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.addresses(vendorId),
            method: apiMethods.get,
        }));
    }

    /**
     * Adds a shipping address for a vendor.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addVendorShippingAddress = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.addAddress,
            method: apiMethods.post,
            data,
        }));
    }

    /**
     * Adds a billing address for a vendor.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addVendorBillingAddress = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.addBillingAddress,
            method: apiMethods.post,
            data,
        }));
    }

    /**
     * Updates a vendor address.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateVendorAddress = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.updateAddress,
            method: apiMethods.put,
            data,
        }));
    }

    /**
     * Deletes a vendor shipping address.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static deleteVendorAddress = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.deleteAddress(id),
            method: apiMethods.delete,
        }));
    }

    /**
     * Sets default shipping address for a vendor.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setVendorDefaultShipping = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.setDefaultShipping,
            method: apiMethods.put,
            data,
        }));
    }

    /**
     * Gets AP aged account summary for a vendor.
     * @param vendorId
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static getVendorAccountSummary = async (vendorId) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.accountSummary(vendorId),
            method: apiMethods.get,
        }));
    }

    /**
     * Lists partner vendor statuses.
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listVendorStatuses = async () => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.listStatuses,
            method: apiMethods.get,
        }));
    }

    /**
     * Adds a vendor status.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addVendorStatus = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.addStatus,
            method: apiMethods.post,
            data,
        }));
    }

    /**
     * Updates a vendor status.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateVendorStatus = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.updateStatus,
            method: apiMethods.put,
            data,
        }));
    }

    /**
     * Deletes a vendor status and reassigns related vendors.
     * @param id
     * @param replacementId
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static deleteVendorStatus = async (id, replacementId) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.deleteStatus(id, replacementId),
            method: apiMethods.delete,
        }));
    }

    /**
     * Sets the default vendor status.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static setDefaultVendorStatus = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.setDefaultStatus,
            method: apiMethods.put,
            data,
        }));
    }

    /**
     * Lists vendor contact users.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static listVendorUsers = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.listUsers,
            method: apiMethods.post,
            data,
        }));
    }

    /**
     * Adds a vendor contact user.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static addVendorUser = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.addUser,
            method: apiMethods.post,
            data,
        }));
    }

    /**
     * Updates a vendor contact user.
     * @param data
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static updateVendorUser = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.updateUser,
            method: apiMethods.put,
            data,
        }));
    }

    /**
     * Soft-deletes a vendor contact user.
     * @param id
     * @returns {Promise<ApiResponseDs<unknown | null>|undefined>}
     */
    static deleteVendorUser = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: vendorV2Apis.deleteUser(id),
            method: apiMethods.delete,
        }));
    }

    /**
     * Paginated list of contact messages for the current partner.
     * @param {{
     *   keyword?: string,
     *   isView?: boolean|null,
     *   period?: {startDateTime?: string, endDateTime?: string}|null,
     *   pagination?: object,
     *   sorts?: Array<{property: string, isDesc: boolean}>,
     * }} data
     * @returns {Promise<ApiResponseDs<{
     *   items: Array<object>,
     *   totalCount: number,
     *   pageSize?: number,
     *   pageIndex?: number,
     *   totalPages?: number,
     * }>|undefined>}
     */
    static listContactMessages = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: contactMessageApis.list,
            method: apiMethods.post,
            data,
        }));
    }

    /**
     * Count of unread contact messages for the current partner.
     * @returns {Promise<ApiResponseDs<{count: number}>|undefined>}
     */
    static getContactUsUnreadCount = async () => {
        return await apiCallback(Api.prepareRequest({
            url: contactMessageApis.unreadCount,
            method: apiMethods.get,
        }));
    }

    /**
     * Mark a contact message as viewed (read) or unread.
     * @param {{id: number, isView: boolean}} data
     * @returns {Promise<ApiResponseDs<unknown|null>|undefined>}
     */
    static setContactMessageView = async (data) => {
        return await apiCallback(Api.prepareRequest({
            url: contactMessageApis.setView,
            method: apiMethods.put,
            data,
        }));
    }

    /**
     * Soft-delete a contact message.
     * @param {number|string} id
     * @returns {Promise<ApiResponseDs<unknown|null>|undefined>}
     */
    static deleteContactMessage = async (id) => {
        return await apiCallback(Api.prepareRequest({
            url: contactMessageApis.delete(id),
            method: apiMethods.delete,
        }));
    }

}
